var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-135"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 298.26,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.82,323.56l-13.12.28L38,324c-2.23.05-4.47,0-6.7.06H30.9v-.45l-.06-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,431.68l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.44v-.45l-.05-11.19V420h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,445.79l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.12-3.71-.14-5.54l.28.27c-4.42.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.63,
    y: 420.49,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.18,
    y: 312.37,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.87,
    y: 237.8,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.41,
    y: 38.7,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,64l-13.13.28-6.66.12c-2.22,0-4.46,0-6.69,0h-.45V64l-.05-11.18V52.3h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.65c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.49L432.62,64l-.44-.44c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.59,49.88l-13.12.28-6.66.12c-2.23,0-4.47,0-6.7,0h-.44v-.45L45.61,38.7v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.18-.45-.44c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,500c-10.77-1.8-21.52-3.71-32.27-5.64l-32.22-5.9-32.18-6.12-16.08-3.15L371.2,476l16.14,2.76,16.13,2.87,32.22,5.9,32.18,6.13C478.59,495.69,489.3,497.79,500,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,500c-8.65-5.72-17.23-11.53-25.81-17.35l-25.65-17.57L423,447.32l-12.72-8.94-12.65-9L410.58,438l12.87,8.72,25.66,17.57L474.63,482Q487.35,490.95,500,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,500c-5.8-8.8-11.51-17.65-17.21-26.51l-17-26.66L449,420.06l-8.32-13.44-8.24-13.49,8.65,13.23,8.56,13.29,17,26.65,16.79,26.78C489,482,494.55,491,500,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,500c-1.63-10.21-3.16-20.43-4.66-30.65l-4.4-30.68L486.77,408l-2-15.37-1.9-15.39,2.38,15.32,2.28,15.33,4.4,30.69,4.17,30.72C497.44,479.49,498.78,489.74,500,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.79,500a15.51,15.51,0,0,0,2.52-4.11,14,14,0,0,0,1.1-4.67,12.57,12.57,0,0,0-.58-4.72,13.74,13.74,0,0,0-.87-2.23c-.34-.72-.8-1.38-1.19-2.07l-.17-.29.32-.08a38.67,38.67,0,0,0,10.45-4.1,27.12,27.12,0,0,0,8.43-7.25,22.59,22.59,0,0,0,2.72-4.84,23.15,23.15,0,0,0,1.33-5.38,30,30,0,0,0-1.07-11.06l-.16-.56.6,0a42.24,42.24,0,0,0,9.7-1.69,31.05,31.05,0,0,0,8.87-4.16A18.32,18.32,0,0,0,451,435.4a17.72,17.72,0,0,0,.87-2.27,19.46,19.46,0,0,0,.53-2.38,23.46,23.46,0,0,0,.27-4.89v-.53l.52.08a48.37,48.37,0,0,0,9.63.28,42.45,42.45,0,0,0,9.49-1.68,30.27,30.27,0,0,0,8.68-4.13,26.41,26.41,0,0,0,6.75-6.83l.1-.15.14.1a11,11,0,0,0,3.06,1.4,8.48,8.48,0,0,0,3.36.27,6.92,6.92,0,0,0,3.15-1.18,9.15,9.15,0,0,0,1.32-1.08c.41-.4.75-.86,1.13-1.29-.37.44-.7.91-1.1,1.32a9.25,9.25,0,0,1-1.3,1.12,7,7,0,0,1-3.18,1.28,8.5,8.5,0,0,1-3.44-.2,11.09,11.09,0,0,1-3.19-1.36l.24,0a26,26,0,0,1-6.73,7.1,30.88,30.88,0,0,1-8.78,4.34,42.86,42.86,0,0,1-9.64,1.83,46.87,46.87,0,0,1-9.83-.22l.51-.46a24.7,24.7,0,0,1-.25,5.08,21.74,21.74,0,0,1-.55,2.49,20.36,20.36,0,0,1-.9,2.4,19.31,19.31,0,0,1-6.51,7.76,30.33,30.33,0,0,1-9.15,4.31,42.89,42.89,0,0,1-10,1.68l.44-.59a30.92,30.92,0,0,1,1.05,11.41,24.1,24.1,0,0,1-1.42,5.6,21.42,21.42,0,0,1-2.87,5,27.73,27.73,0,0,1-8.76,7.33,38.76,38.76,0,0,1-10.67,4l.16-.37c.38.73.83,1.41,1.17,2.16a15.83,15.83,0,0,1,.84,2.3,13,13,0,0,1,.47,4.85,14.14,14.14,0,0,1-1.23,4.7A15.72,15.72,0,0,1,402.79,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.25,500a10.13,10.13,0,0,0,1.57-2.62,9,9,0,0,0,.68-3,8.1,8.1,0,0,0-.38-3,10.91,10.91,0,0,0-1.32-2.7l-.18-.29.33-.08a24.59,24.59,0,0,0,6.6-2.62,17.06,17.06,0,0,0,5.29-4.59,13.75,13.75,0,0,0,1.7-3,14.68,14.68,0,0,0,.84-3.38,19.08,19.08,0,0,0-.69-7l-.16-.56.6,0a26.19,26.19,0,0,0,6.12-1.07,20.06,20.06,0,0,0,5.58-2.61,11.64,11.64,0,0,0,3.9-4.6,12.7,12.7,0,0,0,1-6l0-.54.53.08a30.85,30.85,0,0,0,6.08.18,27.71,27.71,0,0,0,6-1,19.87,19.87,0,0,0,5.49-2.59,17.84,17.84,0,0,0,4.29-4.29l.11-.14.14.09a6.23,6.23,0,0,0,4,1.08,4.51,4.51,0,0,0,2-.74,6.3,6.3,0,0,0,1.57-1.48,6.43,6.43,0,0,1-1.51,1.57,4.36,4.36,0,0,1-2,.84,5.5,5.5,0,0,1-2.21-.12,7.21,7.21,0,0,1-2.05-.86l.25-.05a17.12,17.12,0,0,1-4.28,4.54,20.35,20.35,0,0,1-5.59,2.8,28.72,28.72,0,0,1-6.15,1.2,30.7,30.7,0,0,1-6.28-.13l.51-.46a13.61,13.61,0,0,1-1.09,6.41,12.49,12.49,0,0,1-4.18,5,19.3,19.3,0,0,1-5.86,2.76,27.47,27.47,0,0,1-6.38,1.07l.44-.59a19.77,19.77,0,0,1,.66,7.31,15.26,15.26,0,0,1-.91,3.59,13.51,13.51,0,0,1-1.86,3.21,17.57,17.57,0,0,1-5.62,4.67,24.37,24.37,0,0,1-6.82,2.53l.16-.36a11.1,11.1,0,0,1,1.27,2.86,8.55,8.55,0,0,1,.29,3.1A9.59,9.59,0,0,1,438.25,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.56,500a3.61,3.61,0,0,0,.74-2,3.22,3.22,0,0,0-.67-2l-.19-.27.35-.1a7.47,7.47,0,0,0,4.14-2.62,6.29,6.29,0,0,0,.57-1.05,5.19,5.19,0,0,0,.25-1.17,6.77,6.77,0,0,0-.24-2.4l-.13-.59.58,0a8.83,8.83,0,0,0,2.14-.38,7.11,7.11,0,0,0,1.93-.9,3.91,3.91,0,0,0,1.31-1.55,4.56,4.56,0,0,0,.39-2l0-.55.5.08a10.93,10.93,0,0,0,2.15.09,9.54,9.54,0,0,0,2.13-.32,7.06,7.06,0,0,0,2-.88,6.83,6.83,0,0,0,1.57-1.47l.11-.15.13.1a2.23,2.23,0,0,0,1.4.42,1.94,1.94,0,0,0,1.3-.74,2,2,0,0,1-1.28.93,2.45,2.45,0,0,1-1.62-.32l.25-.05a6.23,6.23,0,0,1-1.55,1.73,7.71,7.71,0,0,1-2.07,1.08,10.45,10.45,0,0,1-2.27.49,11.55,11.55,0,0,1-2.35,0l.52-.47a5.28,5.28,0,0,1-.41,2.47,5,5,0,0,1-1.61,1.95,7.45,7.45,0,0,1-2.23,1.05,10.57,10.57,0,0,1-2.39.4l.45-.61a7.36,7.36,0,0,1,.21,2.77,4.91,4.91,0,0,1-1.08,2.59,6.8,6.8,0,0,1-2.14,1.72,9.22,9.22,0,0,1-2.55.9l.16-.37a4.3,4.3,0,0,1,.44,1.09,3.08,3.08,0,0,1,.08,1.17A3.45,3.45,0,0,1,477.56,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.51,500a7.91,7.91,0,0,0,1.67-2.53,14.3,14.3,0,0,0,.54-1.42c.12-.49.27-1,.35-1.48a18.34,18.34,0,0,0,0-6.05c-.09-1-.38-2-.57-3s-.56-1.94-.88-2.91-.7-1.9-1.1-2.83L376.29,477l-.12-.27.3-.06a35.07,35.07,0,0,0,12.88-5.57,31.57,31.57,0,0,0,9.46-10.29,36.4,36.4,0,0,0,4.31-13.32,55,55,0,0,0-.1-14.1l-.07-.53h.55a42.19,42.19,0,0,0,12.62-1.8,33.51,33.51,0,0,0,11.3-5.8,28.46,28.46,0,0,0,4.46-4.52,29.48,29.48,0,0,0,3.3-5.43A37.32,37.32,0,0,0,438.26,403l.05-.55.54.16a40.65,40.65,0,0,0,12.72,1.63,39.14,39.14,0,0,0,12.62-2.38,37.67,37.67,0,0,0,11.11-6.47,48.2,48.2,0,0,0,8.63-9.62l.13-.19.16.18a13.37,13.37,0,0,0,3.5,2.88,9.32,9.32,0,0,0,4.33,1.25h.58l.56-.07a5.16,5.16,0,0,0,1.12-.21l1.1-.35,1-.52.51-.27.46-.34.93-.68c.57-.51,1.11-1.06,1.67-1.59-.55.54-1.07,1.11-1.64,1.63l-.92.69-.46.36-.51.28-1,.54-1.1.38a5.49,5.49,0,0,1-1.14.23l-.58.09h-.58a9.36,9.36,0,0,1-4.46-1.19,13.74,13.74,0,0,1-3.65-2.89h.29a46.8,46.8,0,0,1-8.57,9.85,38.26,38.26,0,0,1-11.22,6.7,40,40,0,0,1-12.85,2.56,42.27,42.27,0,0,1-6.56-.3,35.4,35.4,0,0,1-6.47-1.33l.59-.38A38.26,38.26,0,0,1,436,415.75a31,31,0,0,1-3.39,5.63,29.7,29.7,0,0,1-4.61,4.7,33.47,33.47,0,0,1-11.63,6,42.86,42.86,0,0,1-12.94,1.79l.48-.52a55.88,55.88,0,0,1,.05,14.33,40,40,0,0,1-1.57,7,34.3,34.3,0,0,1-2.93,6.58,32.17,32.17,0,0,1-9.78,10.42,35.26,35.26,0,0,1-6.3,3.43,32.06,32.06,0,0,1-6.87,2.08l.17-.33,1.23,2.81c.38.94.7,1.92,1.05,2.87s.57,2,.83,3,.45,2,.52,3a18.37,18.37,0,0,1-.16,6.1c-.08.51-.25,1-.37,1.49a14.5,14.5,0,0,1-.57,1.42A8.18,8.18,0,0,1,377.51,500Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 5.19 21.96 10.29 43.95 20.31 87.97 30.11 132.03 34.93 154.08 39.65 176.15 34.45 154.18 29.36 132.2 19.34 88.18 9.54 44.12 4.72 22.07 0 0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 14.74 17.34 29.41 34.75 58.62 69.67 87.65 104.73 102.1 122.32 116.47 139.97 101.72 122.63 87.06 105.22 57.85 70.31 28.82 35.24 14.37 17.65 0 0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 22.13 11.33 44.22 22.76 88.31 45.75 132.3 68.94 154.25 80.61 176.16 92.38 154.02 81.05 131.94 69.63 87.85 46.63 43.86 23.43 21.91 11.76 0 0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 25.33 2.69 50.65 5.48 101.27 11.22 151.87 17.19 177.16 20.26 202.43 23.43 177.1 20.74 151.78 17.95 101.16 12.21 50.56 6.24 25.28 3.17 0 0",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,132.94a27.07,27.07,0,0,1,6.89-3.64,26.71,26.71,0,0,1,7.65-1.61,25.63,25.63,0,0,1,7.8.65,28.07,28.07,0,0,1,3.76,1.15,15,15,0,0,1,1.8.78l1.78.84-.37.17a49.26,49.26,0,0,1,7.5-15.79,40.24,40.24,0,0,1,13-11.72,41.44,41.44,0,0,1,4-1.94,43.73,43.73,0,0,1,4.18-1.42c1.4-.45,2.86-.68,4.29-1s2.91-.46,4.38-.51a59.93,59.93,0,0,1,17.46,1.51l-.58.45a49.45,49.45,0,0,1,3.2-14.69,37.39,37.39,0,0,1,7.94-12.76,32.72,32.72,0,0,1,5.88-4.75,33.46,33.46,0,0,1,6.87-3.18,43,43,0,0,1,14.9-1.82l-.44.52a53.88,53.88,0,0,1-.34-13.95,49,49,0,0,1,3.28-13.54,39.59,39.59,0,0,1,7.35-11.8,40.81,40.81,0,0,1,11-8.47l0,.25a14.44,14.44,0,0,1-2.27-4.39,9.78,9.78,0,0,1-.31-4.89,5.79,5.79,0,0,1,.12-.6l.22-.58a4.55,4.55,0,0,1,.49-1.13c.2-.36.4-.72.62-1.07l.78-.95a5.45,5.45,0,0,1,.86-.87l.92-.82c.66-.48,1.36-.92,2-1.38-.67.47-1.35.92-2,1.41l-.9.83a5.44,5.44,0,0,0-.85.88l-.76,1c-.21.35-.4.71-.59,1.06a5,5,0,0,0-.47,1.12l-.2.58c-.06.19-.07.4-.11.59a9.51,9.51,0,0,0,.38,4.79,14,14,0,0,0,2.29,4.25l.13.15-.17.09a41.3,41.3,0,0,0-10.75,8.55A39,39,0,0,0,125.37,37a48.28,48.28,0,0,0-3.1,13.37,54.59,54.59,0,0,0,.4,13.7l.09.54-.54,0a42.21,42.21,0,0,0-14.58,1.82,33.25,33.25,0,0,0-6.65,3.1,31.66,31.66,0,0,0-5.69,4.63,37,37,0,0,0-7.7,12.44,48.48,48.48,0,0,0-3.18,14.37l0,.57-.54-.12A59.25,59.25,0,0,0,66.65,99.8c-1.44,0-2.86.32-4.29.48-1.4.31-2.84.52-4.21,1a42.48,42.48,0,0,0-4.08,1.37,42.21,42.21,0,0,0-3.89,1.88,39.28,39.28,0,0,0-12.82,11.38,48.49,48.49,0,0,0-7.55,15.51l-.08.3-.29-.13c-1.17-.54-2.3-1.19-3.51-1.65a26.32,26.32,0,0,0-3.68-1.19,25.26,25.26,0,0,0-7.7-.77,26.52,26.52,0,0,0-7.62,1.47A26.79,26.79,0,0,0,0,132.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,84.44a17.49,17.49,0,0,1,4.36-2.35,17.28,17.28,0,0,1,4.87-1,16.07,16.07,0,0,1,5,.39A19.79,19.79,0,0,1,18.9,83.2l-.37.17a31.12,31.12,0,0,1,4.76-10.08,25.4,25.4,0,0,1,8.26-7.51,22.73,22.73,0,0,1,5.2-2.15A28,28,0,0,1,39.49,63c.93-.11,1.86-.29,2.8-.32a38.27,38.27,0,0,1,11.14.95l-.58.45a31.81,31.81,0,0,1,2-9.4A24,24,0,0,1,60,46.52a20.62,20.62,0,0,1,3.78-3.05,21.87,21.87,0,0,1,4.39-2,27.48,27.48,0,0,1,9.53-1.15l-.45.51a34.47,34.47,0,0,1-.2-8.9,31.35,31.35,0,0,1,2.12-8.63,25.28,25.28,0,0,1,4.71-7.52,25.87,25.87,0,0,1,7-5.37l-.05.26a9.27,9.27,0,0,1-1.45-2.81,6.2,6.2,0,0,1-.18-3.14,5.71,5.71,0,0,1,1.44-2.76A10.44,10.44,0,0,1,91.77.87c.42-.31.87-.58,1.3-.87-.43.3-.86.59-1.27.91A10.3,10.3,0,0,0,90.7,2a5.78,5.78,0,0,0-1.33,2.73,6.09,6.09,0,0,0,.25,3,9,9,0,0,0,1.46,2.67l.13.16-.18.1a26.08,26.08,0,0,0-6.79,5.43,24.75,24.75,0,0,0-4.49,7.41A30.63,30.63,0,0,0,77.81,32a34.9,34.9,0,0,0,.27,8.67l.08.54-.53,0a26.67,26.67,0,0,0-9.2,1.16,20.78,20.78,0,0,0-4.19,2,20,20,0,0,0-3.58,2.91A23.49,23.49,0,0,0,55.81,55a30.87,30.87,0,0,0-2,9.07l0,.57-.54-.13a37.62,37.62,0,0,0-10.87-1c-.91,0-1.81.2-2.71.3a27,27,0,0,0-2.66.61,22.4,22.4,0,0,0-5,2,24.92,24.92,0,0,0-8.12,7.17,30.64,30.64,0,0,0-4.8,9.8l-.09.3-.28-.13c-.74-.34-1.45-.76-2.22-1.05a15.85,15.85,0,0,0-2.33-.76,15.9,15.9,0,0,0-4.86-.51,17,17,0,0,0-4.83.91A17.39,17.39,0,0,0,0,84.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,30.68a6.32,6.32,0,0,1,3.35-1.32,6,6,0,0,1,1.84.11,7.3,7.3,0,0,1,1.75.62l-.36.16A11.59,11.59,0,0,1,8.29,26.5a9.48,9.48,0,0,1,3.05-2.82,5.21,5.21,0,0,1,.95-.46,4.85,4.85,0,0,1,1-.35l1-.26,1-.11a5.27,5.27,0,0,1,1.05,0l1,0c.69.07,1.37.21,2.05.31l-.58.45a12,12,0,0,1,.75-3.52,9,9,0,0,1,1.93-3.05,7.11,7.11,0,0,1,3.09-1.9,8.34,8.34,0,0,1,1.77-.38c.6-.07,1.2,0,1.79-.06l-.44.52a11.86,11.86,0,0,1-.05-3.31,11.72,11.72,0,0,1,.83-3.19,9,9,0,0,1,1.78-2.76A9.49,9.49,0,0,1,33,3.68l0,.25a3.2,3.2,0,0,1-.53-1.06,2.36,2.36,0,0,1,0-1.18,2.13,2.13,0,0,1,.55-1A4.06,4.06,0,0,1,33.82,0,3.76,3.76,0,0,0,33,.75a2.14,2.14,0,0,0-.45,1,2.61,2.61,0,0,0,.65,2l.12.14L33.13,4a10.29,10.29,0,0,0-2.39,2,8.43,8.43,0,0,0-1.56,2.65,11,11,0,0,0-.66,3,13.62,13.62,0,0,0,.12,3.07l.08.49-.53,0c-.55,0-1.1,0-1.64.08a7.65,7.65,0,0,0-1.59.36,6.16,6.16,0,0,0-2.69,1.7,8.39,8.39,0,0,0-1.69,2.74,10.79,10.79,0,0,0-.73,3.19l0,.53-.54-.08c-.64-.11-1.28-.25-1.93-.33l-1,0a4.4,4.4,0,0,0-1,0,8.69,8.69,0,0,0-3.67,1A8.58,8.58,0,0,0,8.83,26.9a11,11,0,0,0-1.76,3.47L7,30.68l-.28-.15a7,7,0,0,0-1.6-.67,5.63,5.63,0,0,0-1.73-.22A6.57,6.57,0,0,0,0,30.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,167.51a13.8,13.8,0,0,1,4.3-2.41,23.15,23.15,0,0,1,2.36-.75c.8-.16,1.6-.41,2.42-.5a36.4,36.4,0,0,1,9.89-.17l1.23.11c.41.05.82.13,1.23.2l2.45.4c1.61.34,3.22.72,4.83,1.12s3.17.93,4.74,1.45l4.66,1.7-.34.18a40.37,40.37,0,0,1,4-10.36,47.91,47.91,0,0,1,6.4-9.07,51.09,51.09,0,0,1,18-12.76c1.69-.77,3.45-1.36,5.2-2l2.66-.79,1.34-.39,1.35-.31,2.71-.62,2.74-.47c1.82-.36,3.67-.49,5.51-.73a111.74,111.74,0,0,1,22.17.21l-.49.47a46.08,46.08,0,0,1,.82-9.76,48.06,48.06,0,0,1,2.69-9.4,42.59,42.59,0,0,1,11-16,47.38,47.38,0,0,1,16.82-9.75,72.36,72.36,0,0,1,19.1-3.64l-.33.53a42.89,42.89,0,0,1-2.23-9.15,49,49,0,0,1-.39-9.38,46.25,46.25,0,0,1,4.71-18.08,52,52,0,0,1,11.26-14.9,72.7,72.7,0,0,1,15.22-10.83l0,.28a19.55,19.55,0,0,1-4.65-4.78,11.56,11.56,0,0,1-2.14-6.27,10.51,10.51,0,0,1,2.14-6.22A20.91,20.91,0,0,1,188.13,0a20.83,20.83,0,0,0-4.68,4.69,10.36,10.36,0,0,0-2,6.17A11.33,11.33,0,0,0,183.59,17a19.29,19.29,0,0,0,4.63,4.65l.22.16-.23.13a76.22,76.22,0,0,0-15,10.92,51.34,51.34,0,0,0-11.07,14.79,45.55,45.55,0,0,0-4.57,17.84,47.69,47.69,0,0,0,.43,9.25,42.45,42.45,0,0,0,2.21,9l.19.5-.52,0A71.64,71.64,0,0,0,141,87.89a46.61,46.61,0,0,0-16.46,9.63,42.68,42.68,0,0,0-10.73,15.71,48.34,48.34,0,0,0-2.68,9.21,45.05,45.05,0,0,0-.84,9.53v.52l-.5-.05a110.9,110.9,0,0,0-22-.3c-1.82.23-3.66.34-5.46.69l-2.71.46-2.69.6-1.34.31-1.32.37-2.64.77c-1.73.62-3.47,1.19-5.14,1.95a50.26,50.26,0,0,0-17.86,12.52,46.79,46.79,0,0,0-6.37,8.93,39.77,39.77,0,0,0-4,10.19l-.06.3-.28-.11-4.61-1.74c-1.56-.54-3.14-1-4.71-1.5s-3.18-.82-4.79-1.19l-2.43-.43c-.4-.06-.8-.15-1.21-.2l-1.23-.13a36.43,36.43,0,0,0-9.84,0c-.82.08-1.61.32-2.42.47s-1.59.43-2.36.71A14,14,0,0,0,0,167.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.96,
    y: 168.89,
    width: 0.31,
    height: 191.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.24,360.6a5.46,5.46,0,0,0-.06,4.35c.68,1.72,4.63,2.43,5.92,2.21s3.82-1.19,4.29-2,.65-4.38-.15-5.33A6.82,6.82,0,0,0,38,357.73C34.59,358.15,33.56,359.82,33.24,360.6Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.08,365.08c-1-.23-2.12-.21-3.15-.53a12.33,12.33,0,0,1-2.73-1.45.21.21,0,0,0-.25,0,.18.18,0,0,0-.07.11c-.4,3.08-2,5.48-3.81,7.87-.08.09,0,.25.14.17a8.35,8.35,0,0,0,3-3.75,7.72,7.72,0,0,0,1.08-3.71,6.11,6.11,0,0,0,5.81,1.62A.2.2,0,0,0,35.08,365.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.67,363.28c-.93-.53-2-.83-2.85-1.45a12.61,12.61,0,0,1-2.18-2.2.19.19,0,0,0-.25,0,.1.1,0,0,0-.09.07c-1.31,2.82-3.52,4.64-6,6.37a.11.11,0,0,0,.08.21,8.33,8.33,0,0,0,4-2.69,7.67,7.67,0,0,0,2.14-3.21,6.15,6.15,0,0,0,5.06,3.29A.21.21,0,0,0,33.67,363.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.72,362.43c-.65-.85-1.48-1.53-2.06-2.44a12.53,12.53,0,0,1-1.14-2.88.19.19,0,0,0-.22-.12.13.13,0,0,0-.12,0c-2.3,2.09-5.05,2.91-8,3.53-.11,0-.14.2,0,.22a8.48,8.48,0,0,0,4.71-.92,7.71,7.71,0,0,0,3.22-2.13,6.14,6.14,0,0,0,3.38,5C33.64,362.8,33.84,362.59,33.72,362.43Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,361.56c-.46-1-1.13-1.8-1.51-2.81a12.77,12.77,0,0,1-.54-3.05.19.19,0,0,0-.19-.17.13.13,0,0,0-.12,0c-2.68,1.58-5.53,1.81-8.55,1.81-.13,0-.19.17-.06.22a8.52,8.52,0,0,0,4.8.06,7.77,7.77,0,0,0,3.58-1.42,6.12,6.12,0,0,0,2.29,5.58A.2.2,0,0,0,34.51,361.56Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.84,365.08c1-.23,2.12-.21,3.15-.53a12.4,12.4,0,0,0,2.74-1.45.19.19,0,0,1,.24,0,.12.12,0,0,1,.07.11c.4,3.08,2,5.48,3.81,7.87.08.09,0,.25-.13.17a8.37,8.37,0,0,1-3-3.75,7.83,7.83,0,0,1-1.08-3.71,6.11,6.11,0,0,1-5.81,1.62A.2.2,0,0,1,40.84,365.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,363.28c.92-.53,2-.83,2.84-1.45a12.61,12.61,0,0,0,2.18-2.2.19.19,0,0,1,.25,0,.1.1,0,0,1,.1.07c1.3,2.82,3.51,4.64,6,6.37a.11.11,0,0,1-.08.21,8.38,8.38,0,0,1-4-2.69,7.77,7.77,0,0,1-2.14-3.21,6.15,6.15,0,0,1-5.06,3.29A.2.2,0,0,1,42.26,363.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,362.43c.64-.85,1.47-1.53,2-2.44a13,13,0,0,0,1.15-2.88.18.18,0,0,1,.22-.12.14.14,0,0,1,.12,0c2.3,2.09,5,2.91,8,3.53.12,0,.15.2,0,.22a8.5,8.5,0,0,1-4.71-.92,7.78,7.78,0,0,1-3.22-2.13,6.12,6.12,0,0,1-3.38,5A.2.2,0,0,1,42.21,362.43Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.42,361.56c.45-1,1.13-1.8,1.51-2.81a13.27,13.27,0,0,0,.53-3.05.19.19,0,0,1,.19-.17.13.13,0,0,1,.12,0c2.68,1.58,5.54,1.81,8.56,1.81a.11.11,0,0,1,.05.22,8.48,8.48,0,0,1-4.79.06A7.81,7.81,0,0,1,44,356.21a6.14,6.14,0,0,1-2.28,5.58C41.56,361.9,41.33,361.74,41.42,361.56Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ticket-2--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.61,89.35a4,4,0,0,1,1-.14V85.44a6.54,6.54,0,0,1-6.54-6.54H360.06a6.42,6.42,0,0,1-11.14,0h-287a6.54,6.54,0,0,1-6.54,6.54V222.67a6.54,6.54,0,0,1,6.54,6.54h287a6.42,6.42,0,0,1,11.14,0h78.05a6.54,6.54,0,0,1,5.55-6.46,6.4,6.4,0,0,1,1-.08v-3.79a3.85,3.85,0,1,1,0-7.7v-5.86a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V124a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85V96.91a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2A3.85,3.85,0,0,1,443.61,89.35ZM354.49,218.88a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,218.88Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,205.32Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,191.77Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,178.22Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,164.67Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,151.12Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,137.57Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,124Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,110.46Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,96.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.61,85.35a4,4,0,0,1,1-.14V81.44a6.54,6.54,0,0,1-6.54-6.54H360.06a6.42,6.42,0,0,1-11.14,0h-287a6.54,6.54,0,0,1-6.54,6.54V218.67a6.54,6.54,0,0,1,6.54,6.54h287a6.42,6.42,0,0,1,11.14,0h78.05a6.54,6.54,0,0,1,5.55-6.46,6.4,6.4,0,0,1,1-.08v-3.79a3.85,3.85,0,1,1,0-7.7v-5.86a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V120a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85v-5.85a3.83,3.83,0,0,1-3.29-1.85,3.76,3.76,0,0,1-.56-2,3.85,3.85,0,0,1,3.85-3.85V92.91a3.83,3.83,0,0,1-3.29-1.85,3.79,3.79,0,0,1-.56-2A3.85,3.85,0,0,1,443.61,85.35ZM354.49,214.88a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,214.88Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,201.32Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,187.77Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,174.22Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,160.67Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,147.12Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,133.57Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,120Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,106.46Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,92.91Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,215.14H368.41V85h62.32Zm-61.82-.5h61.32V85.47H368.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.57,215.15H65.42V85H340.57Zm-274.65-.5H340.07V85.46H65.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.29,169.4s-4.13,4.75-8.62,5.15c-.52,0-.46-3.2-.46-3.2l-.83.88a1.77,1.77,0,0,0-2-.49l-.17-1.48s-1.35,3-2,3.25S219,168,218.91,164.7c0-.34-4,2.16-8.28,1.28,0,0,3.22,1.91,3,5.05,0,0,5.24.27,4.72,5.66,0,0,5.09-.74,6.28,5.05,0,0,2.33-4.26,7.79-1.86,0,0,2.19-4.76,7.36-3.29,0,0,2.38-3.66,6.57-3.38A21.78,21.78,0,0,1,238.29,169.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.76,140.07s-2,9.43-7.67,13.32c-.66.45-3-3.92-3-3.92l-.44,1.79a2.69,2.69,0,0,0-3.1.88l-1.35-1.85s.42,5-.23,5.84-11-3.57-13.59-7.85c-.27-.44-3.8,5.91-10.12,7.9,0,0,5.73.15,7.76,4.51,0,0,7.21-3.55,10.54,4.05,0,0,6.25-4.8,12.17,2,0,0-.08-7.43,9-8.3,0,0-.63-8,7.38-9.9,0,0,.43-6.67,6.24-9.43A33.41,33.41,0,0,1,201.76,140.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05,145.55s-.48,3.94-2.68,5.73c-.26.21-1.37-1.51-1.37-1.51l-.12.76a1.11,1.11,0,0,0-1.24.47l-.62-.72a7.45,7.45,0,0,1,.11,2.4c-.24.38-4.64-1.07-5.85-2.74-.12-.17-1.35,2.56-3.87,3.6,0,0,2.36-.14,3.34,1.57a3.11,3.11,0,0,1,4.46,1.3,3.58,3.58,0,0,1,5.06.41s-.29-3,3.41-3.72a3.91,3.91,0,0,1,2.68-4.32,4.88,4.88,0,0,1,2.23-4.08A13.79,13.79,0,0,1,255.05,145.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ticket-1--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.65,271.89v-3.77a6.54,6.54,0,0,1-6.54-6.54H360.06a6.6,6.6,0,0,1-11.14,0h-287a6.54,6.54,0,0,1-6.54,6.54V405.35a6.54,6.54,0,0,1,6.54,6.54h287a6.59,6.59,0,0,1,11.14,0h78.05a6.54,6.54,0,0,1,6.54-6.54v-3.79a3.85,3.85,0,1,1,0-7.7V388a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V360.9a3.85,3.85,0,0,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V333.8a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7v-5.86a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,0,1,0-7.7v-5.85a3.85,3.85,0,0,1,0-7.7ZM354.49,401.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,401.55Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,388Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,374.45Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,360.9Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,347.34Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,333.79Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,320.24Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,306.69Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,293.14Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,279.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.65,267.89v-3.77a6.54,6.54,0,0,1-6.54-6.54H360.06a6.6,6.6,0,0,1-11.14,0h-287a6.54,6.54,0,0,1-6.54,6.54V401.35a6.54,6.54,0,0,1,6.54,6.54h287a6.59,6.59,0,0,1,11.14,0h78.05a6.54,6.54,0,0,1,6.54-6.54v-3.79a3.85,3.85,0,1,1,0-7.7V384a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V356.9a3.85,3.85,0,0,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7V329.8a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,1,1,0-7.7v-5.86a3.85,3.85,0,1,1,0-7.7v-5.85a3.85,3.85,0,0,1,0-7.7v-5.85a3.85,3.85,0,0,1,0-7.7ZM354.49,397.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,397.55Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,384Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,370.45Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,356.9Zm0-13.56a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,343.34Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,329.79Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,316.24Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,302.69Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,289.14Zm0-13.55a3.85,3.85,0,1,1,3.85-3.85A3.85,3.85,0,0,1,354.49,275.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,397.82H368.41V267.65h62.32Zm-61.82-.5h61.32V268.15H368.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.57,397.82H65.42V267.64H340.57Zm-274.65-.5H340.07V268.14H65.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.67,397.57q9.14-1.85,18.27-3.61l18.28-3.47,18.31-3.36q9.16-1.67,18.34-3.23-9.13,1.85-18.27,3.6L102.32,391,84,394.34Q74.85,396,65.67,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,397.57q7.2-5.13,14.43-10.2l14.51-10.08,14.57-10q7.3-5,14.65-9.88-7.18,5.13-14.43,10.19L94.9,377.7l-14.58,10Q73,392.67,65.67,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,397.57q4.68-7.67,9.44-15.29l9.54-15.21,9.65-15.15q4.85-7.56,9.76-15.08-4.68,7.67-9.44,15.28l-9.54,15.22-9.65,15.15Q70.59,390,65.67,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.67,397.57q1.08-8.74,2.25-17.48l2.37-17.45,2.49-17.44q1.27-8.71,2.63-17.42-1.08,8.75-2.25,17.47l-2.37,17.46L68.3,380.15Q67,388.87,65.67,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.91,397.57a8.62,8.62,0,0,1-2.18-5,7.31,7.31,0,0,1,.27-2.75,9.93,9.93,0,0,1,1.14-2.53l.08.18a22,22,0,0,1-6-2.29,15.75,15.75,0,0,1-5-4.17,12,12,0,0,1-2.42-6,17.42,17.42,0,0,1,.58-6.47l.21.28a24.46,24.46,0,0,1-5.65-1,17,17,0,0,1-5.19-2.44,11.07,11.07,0,0,1-3.68-4.4,12,12,0,0,1-.95-5.64l.22.2a28,28,0,0,1-5.57.12,25.91,25.91,0,0,1-5.46-1,18.39,18.39,0,0,1-5-2.45,15.53,15.53,0,0,1-3.83-4l.12,0a5.73,5.73,0,0,1-3.77.89,3.91,3.91,0,0,1-1.8-.73,6,6,0,0,1-1.37-1.38,6.14,6.14,0,0,0,1.39,1.35,4,4,0,0,0,1.79.68,5.59,5.59,0,0,0,3.66-.95l.07-.05,0,.07a16.12,16.12,0,0,0,3.84,3.89,17.67,17.67,0,0,0,4.93,2.37,24.68,24.68,0,0,0,5.4,1,27.12,27.12,0,0,0,5.48-.16l.23,0v.24a11.75,11.75,0,0,0,1,5.44A10.51,10.51,0,0,0,97,365.07a18.09,18.09,0,0,0,5,2.37,24.3,24.3,0,0,0,5.53,1h.28l-.08.27a17.23,17.23,0,0,0-.62,6.3,13.39,13.39,0,0,0,.76,3.07,12.11,12.11,0,0,0,1.56,2.76,15.31,15.31,0,0,0,4.82,4.12,22.23,22.23,0,0,0,6,2.32l.16,0-.09.14a10,10,0,0,0-1.17,2.45,7.19,7.19,0,0,0-.32,2.69A8.6,8.6,0,0,0,120.91,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.76,397.57a5.55,5.55,0,0,1-1.41-3.16,4.56,4.56,0,0,1,.17-1.76,6,6,0,0,1,.72-1.62l.07.18a14.17,14.17,0,0,1-3.86-1.44,10.15,10.15,0,0,1-3.17-2.66,6.91,6.91,0,0,1-.59-.86l-.47-.95a8,8,0,0,1-.49-2,9.12,9.12,0,0,1,0-2.09c.06-.69.25-1.36.38-2.05l.22.3a16.13,16.13,0,0,1-3.61-.61,11.4,11.4,0,0,1-3.33-1.56A7.28,7.28,0,0,1,83,374.41a8,8,0,0,1-.64-3.62l.26.23a17.67,17.67,0,0,1-3.56.07,16.56,16.56,0,0,1-3.49-.67,11.7,11.7,0,0,1-3.18-1.59A9.71,9.71,0,0,1,70,366.26l.12,0a3.65,3.65,0,0,1-2.42.56,2.5,2.5,0,0,1-1.14-.47,3.68,3.68,0,0,1-.87-.89,3.59,3.59,0,0,0,.89.85,2.48,2.48,0,0,0,1.14.43,3.55,3.55,0,0,0,2.3-.62l.07,0,.05.07a10.1,10.1,0,0,0,2.44,2.44,11.31,11.31,0,0,0,3.12,1.48,15.22,15.22,0,0,0,3.42.59,17.37,17.37,0,0,0,3.46-.1l.25,0v.26a7.61,7.61,0,0,0,.62,3.41,6.78,6.78,0,0,0,2.21,2.63,11.56,11.56,0,0,0,3.18,1.49,15.39,15.39,0,0,0,3.49.61l.27,0,0,.28c-.12.66-.31,1.31-.37,2a8.28,8.28,0,0,0,0,2,8,8,0,0,0,.44,1.93l.44.9a7.45,7.45,0,0,0,.55.83,9.82,9.82,0,0,0,3,2.61,14.15,14.15,0,0,0,3.75,1.5l.17,0-.09.14a5.94,5.94,0,0,0-.75,1.54,4.43,4.43,0,0,0-.22,1.7A5.53,5.53,0,0,0,100.76,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.42,397.57a1.94,1.94,0,0,1-.25-2.42l.08.18a4.85,4.85,0,0,1-1.44-.51,3.79,3.79,0,0,1-1.21-1,2.82,2.82,0,0,1-.6-1.46,4.29,4.29,0,0,1,.12-1.56l.22.29A6,6,0,0,1,74,390.9a4,4,0,0,1-1.25-.59,2.8,2.8,0,0,1-.9-1.09,3.05,3.05,0,0,1-.24-1.39l.26.23a6.08,6.08,0,0,1-2.62-.25,4.35,4.35,0,0,1-1.17-.61,3.43,3.43,0,0,1-.88-1l.12,0a1.4,1.4,0,0,1-.91.19,1.11,1.11,0,0,1-.73-.53,1.12,1.12,0,0,0,.74.43,1.19,1.19,0,0,0,.8-.24l.07-.05.06.08a3.69,3.69,0,0,0,2,1.35,6.53,6.53,0,0,0,2.45.14l.24,0v.26a2.55,2.55,0,0,0,.22,1.17,2.25,2.25,0,0,0,.76.89,4.78,4.78,0,0,0,2.33.74l.29,0-.07.28a3.84,3.84,0,0,0-.13,1.38,2.45,2.45,0,0,0,.48,1.27,4.25,4.25,0,0,0,2.37,1.5l.18,0-.1.14a1.84,1.84,0,0,0-.37,1.13A2.08,2.08,0,0,0,78.42,397.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.28,397.57a6,6,0,0,1-1.52-3.07,10.37,10.37,0,0,1-.08-3.47,16.53,16.53,0,0,1,.3-1.71c.14-.57.3-1.13.47-1.68s.38-1.1.6-1.63l.7-1.6.08.17a20,20,0,0,1-7.46-3.15,18.21,18.21,0,0,1-5.53-5.92c-.35-.58-.6-1.22-.9-1.83a9.75,9.75,0,0,1-.72-1.91,16.28,16.28,0,0,1-.56-2l-.35-2a12.43,12.43,0,0,1-.18-2l-.09-2c.06-1.35.18-2.71.27-4.06l.22.24a24.28,24.28,0,0,1-7.34-1,19,19,0,0,1-6.6-3.38,17.28,17.28,0,0,1-2.61-2.66,18.21,18.21,0,0,1-1.92-3.2,22,22,0,0,1-1.76-7.19l.27.17a23.43,23.43,0,0,1-7.39.91,21.78,21.78,0,0,1-7.27-1.45,20.78,20.78,0,0,1-6.37-3.79,23.23,23.23,0,0,1-2.65-2.6c-.81-.93-1.49-2-2.24-3h.14a7.81,7.81,0,0,1-2.07,1.64,5.35,5.35,0,0,1-2.53.68,4.71,4.71,0,0,1-2.51-.7,8,8,0,0,1-1.07-.76c-.33-.29-.63-.61-.94-.92.32.3.62.62,1,.91a7.87,7.87,0,0,0,1.08.73,4.76,4.76,0,0,0,2.49.65,5.19,5.19,0,0,0,2.47-.71,7.64,7.64,0,0,0,2-1.63l.07-.09.07.09c.77,1,1.46,2,2.28,2.9a25.52,25.52,0,0,0,2.64,2.56,20.67,20.67,0,0,0,6.31,3.7,21.69,21.69,0,0,0,7.17,1.39,23.6,23.6,0,0,0,7.25-.93l.24-.07,0,.24a21.32,21.32,0,0,0,1.76,7,16.82,16.82,0,0,0,1.89,3.09,16.31,16.31,0,0,0,2.54,2.58,19.44,19.44,0,0,0,6.43,3.3,24.42,24.42,0,0,0,7.19,1h.24v.25c-.1,1.34-.22,2.68-.29,4l.08,2a11.09,11.09,0,0,0,.16,2l.33,2a17.75,17.75,0,0,0,.54,1.93,9.42,9.42,0,0,0,.7,1.88,20,20,0,0,0,.88,1.8,17.89,17.89,0,0,0,5.4,5.85,20.12,20.12,0,0,0,7.33,3.16l.15,0-.06.13-.72,1.57c-.23.53-.42,1.08-.63,1.62s-.34,1.1-.49,1.65a16.27,16.27,0,0,0-.33,1.69,10.45,10.45,0,0,0,0,3.44A5.93,5.93,0,0,0,135.28,397.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.32 267.89 337.62 280.43 334.85 292.95 329.3 317.99 323.58 343 320.72 355.5 317.79 367.98 320.48 355.44 323.26 342.92 328.81 317.88 334.52 292.87 337.38 280.37 340.32 267.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.32 267.89 332.14 277.91 323.9 287.88 307.42 307.82 290.81 327.65 282.5 337.56 274.13 347.43 282.31 337.41 290.55 327.44 307.03 307.5 323.64 287.67 331.95 277.75 340.32 267.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.32 267.89 327.86 274.56 315.37 281.16 290.38 294.36 265.32 307.4 252.78 313.93 240.22 320.38 252.67 313.71 265.16 307.11 290.15 293.91 315.21 280.86 327.75 274.34 340.32 267.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.32 267.89 325.95 269.67 311.58 271.38 282.83 274.79 254.06 278.04 239.68 279.66 225.28 281.2 239.65 279.41 254.02 277.71 282.77 274.3 311.54 271.05 325.92 269.43 340.32 267.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,343.43a15.93,15.93,0,0,0-3.94-2,15.3,15.3,0,0,0-4.33-.83,14,14,0,0,0-4.38.43,17.76,17.76,0,0,0-4.09,1.61l-.14.07,0-.15a27.76,27.76,0,0,0-4.28-8.84,22.49,22.49,0,0,0-7.29-6.5,20.11,20.11,0,0,0-4.54-1.84,21.94,21.94,0,0,0-2.4-.55c-.81-.1-1.62-.25-2.44-.27a33.55,33.55,0,0,0-9.78.88l-.26.06,0-.27a27.42,27.42,0,0,0-1.82-8.17,21,21,0,0,0-4.38-7.09,17.9,17.9,0,0,0-3.24-2.64,18.7,18.7,0,0,0-3.79-1.77,24,24,0,0,0-8.3-1.05h-.23l0-.23a31.32,31.32,0,0,0,.22-7.8,28,28,0,0,0-1.8-7.6c-.27-.6-.47-1.22-.79-1.79l-.94-1.72c-.33-.56-.74-1.07-1.11-1.61l-.57-.79-.67-.72a24.41,24.41,0,0,0-6.09-4.88l-.09-.05.06-.07a8.11,8.11,0,0,0,1.31-2.42,5.58,5.58,0,0,0,.21-2.72,5.08,5.08,0,0,0-1.22-2.45,7.56,7.56,0,0,0-1-1c-.37-.28-.76-.54-1.14-.8.38.26.78.51,1.15.78a8.36,8.36,0,0,1,1,1,5.2,5.2,0,0,1,1.27,2.46,5.58,5.58,0,0,1-.18,2.78,8.2,8.2,0,0,1-1.29,2.49l0-.13a23.41,23.41,0,0,1,6.21,4.85l.68.72c.2.26.39.53.58.8.38.54.8,1.06,1.14,1.63l1,1.73c.32.58.54,1.21.81,1.81a28.19,28.19,0,0,1,1.85,7.67,31.75,31.75,0,0,1-.18,7.91l-.2-.22a24.46,24.46,0,0,1,8.46,1,19.29,19.29,0,0,1,3.89,1.79,18.39,18.39,0,0,1,3.33,2.7,21,21,0,0,1,4.51,7.23,27.66,27.66,0,0,1,1.81,8.34l-.27-.21a33.63,33.63,0,0,1,9.9-.85,23.15,23.15,0,0,1,2.49.29c.81.18,1.64.3,2.43.56a20.21,20.21,0,0,1,4.61,1.91,22.72,22.72,0,0,1,7.37,6.63,27.78,27.78,0,0,1,4.27,8.95l-.18-.08a17.82,17.82,0,0,1,4.17-1.58,14.35,14.35,0,0,1,4.43-.37,15.33,15.33,0,0,1,4.34.9A15.65,15.65,0,0,1,340.32,343.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,315.87a10,10,0,0,0-5.26-1.78,8.92,8.92,0,0,0-2.77.29,10.84,10.84,0,0,0-2.58,1l-.14.07-.05-.15a17.63,17.63,0,0,0-2.71-5.58,13.66,13.66,0,0,0-4.63-4.09,7.79,7.79,0,0,0-1.4-.66,6.89,6.89,0,0,0-1.47-.5l-1.51-.37-1.55-.14c-.25,0-.51-.06-.77-.07l-.78,0-1.56.07c-1,.12-2.05.34-3.07.5l-.26,0,0-.25a17.72,17.72,0,0,0-1.16-5.16,13.38,13.38,0,0,0-2.77-4.46,9.87,9.87,0,0,0-4.42-2.77,12.55,12.55,0,0,0-2.58-.59c-.88-.11-1.77-.07-2.66-.11l-.23,0,0-.21a19.89,19.89,0,0,0,.14-4.94,17.38,17.38,0,0,0-1.13-4.81,13.35,13.35,0,0,0-2.57-4.2,15.57,15.57,0,0,0-3.85-3.1l-.08-.05.05-.07a4.19,4.19,0,0,0,1-3.25,3.19,3.19,0,0,0-.76-1.55,5.28,5.28,0,0,0-.63-.62c-.23-.18-.48-.34-.72-.51.25.16.5.32.74.49a6.15,6.15,0,0,1,.64.61,3.25,3.25,0,0,1,.81,1.57,3.55,3.55,0,0,1-.1,1.77,5.12,5.12,0,0,1-.82,1.59l0-.12a14.83,14.83,0,0,1,4,3.07,13.77,13.77,0,0,1,2.66,4.26,17.94,17.94,0,0,1,1.19,4.89,20.25,20.25,0,0,1-.11,5l-.2-.22c.91,0,1.82,0,2.72.09a12.73,12.73,0,0,1,2.67.59,10.29,10.29,0,0,1,4.62,2.84,13.58,13.58,0,0,1,2.9,4.61,18,18,0,0,1,1.15,5.33l-.27-.22c1-.16,2.08-.37,3.13-.49l1.59-.06.8,0,.79.08,1.59.16,1.55.38a8.11,8.11,0,0,1,1.5.53,8.19,8.19,0,0,1,1.43.69,14.2,14.2,0,0,1,4.7,4.22,17.83,17.83,0,0,1,2.72,5.7l-.18-.08a11.08,11.08,0,0,1,2.66-1,9.23,9.23,0,0,1,2.82-.23A10.13,10.13,0,0,1,340.32,315.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,285.32a3.56,3.56,0,0,0-1.91-.6,3.64,3.64,0,0,0-1.91.5l-.13.08-.05-.16a5.64,5.64,0,0,0-2.66-3.41,5.11,5.11,0,0,0-2.1-.58,6.76,6.76,0,0,0-1.1,0c-.37,0-.73.12-1.1.18l-.27,0,0-.27a5.67,5.67,0,0,0-1.38-3.39,3.5,3.5,0,0,0-1.55-1,5.71,5.71,0,0,0-1.85-.25H324l0-.26a7.07,7.07,0,0,0-.31-3.47,4.73,4.73,0,0,0-.9-1.51,5.77,5.77,0,0,0-1.36-1.14l-.08-.05.06-.07a1.48,1.48,0,0,0,.36-1.14,1.46,1.46,0,0,0-.74-1,1.54,1.54,0,0,1,.82,1,1.6,1.6,0,0,1-.32,1.26l0-.12a5.49,5.49,0,0,1,1.48,1.1,5.18,5.18,0,0,1,1,1.57,7,7,0,0,1,.44,3.68l-.22-.26a5.76,5.76,0,0,1,2,.25A4,4,0,0,1,328,277.4a5,5,0,0,1,1.09,1.72,6.43,6.43,0,0,1,.42,2l-.28-.22c.38-.06.77-.14,1.16-.18a7.74,7.74,0,0,1,1.18,0,5.2,5.2,0,0,1,2.26.67,5.38,5.38,0,0,1,1.73,1.59,6.69,6.69,0,0,1,1,2.12l-.18-.08a3.7,3.7,0,0,1,2-.41A3.65,3.65,0,0,1,340.32,285.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,363.07a8.24,8.24,0,0,0-2.45-1.34,15.22,15.22,0,0,0-2.72-.67,21,21,0,0,0-5.6,0c-.93.07-1.84.29-2.77.43s-1.82.44-2.72.67-1.79.55-2.67.85l-2.63,1-.13,0,0-.15A25.38,25.38,0,0,0,312.71,353a28.7,28.7,0,0,0-10.16-7.12A40.12,40.12,0,0,0,290.44,343a63,63,0,0,0-12.51.17l-.25,0v-.26a27.65,27.65,0,0,0-2-10.66,24.33,24.33,0,0,0-6.1-8.94,26.58,26.58,0,0,0-9.37-5.48,41.22,41.22,0,0,0-10.73-2.09l-.26,0,.09-.25a26.51,26.51,0,0,0,1.5-10.35,25.8,25.8,0,0,0-2.6-10.15,29.1,29.1,0,0,0-6.29-8.4,43.54,43.54,0,0,0-8.55-6.21l-.12-.06.12-.08a11,11,0,0,0,2.62-2.65,6.29,6.29,0,0,0,1.22-3.48,5.88,5.88,0,0,0-1.15-3.51,14.88,14.88,0,0,0-1.21-1.44l-1.44-1.22,1.45,1.21a13.86,13.86,0,0,1,1.23,1.43,5.93,5.93,0,0,1,1.21,3.53,6.49,6.49,0,0,1-1.2,3.55,11.18,11.18,0,0,1-2.64,2.72v-.14a41.36,41.36,0,0,1,8.65,6.16,29.6,29.6,0,0,1,6.39,8.46,26.54,26.54,0,0,1,2.67,10.26,27.09,27.09,0,0,1-1.49,10.52l-.17-.26a41,41,0,0,1,10.85,2.07,26.94,26.94,0,0,1,9.55,5.53,24.32,24.32,0,0,1,6.23,9.11,28,28,0,0,1,2,10.87l-.24-.23a62.33,62.33,0,0,1,12.59-.12,40.54,40.54,0,0,1,12.22,3,29.1,29.1,0,0,1,10.24,7.24,25.57,25.57,0,0,1,5.91,11l-.17-.1,2.65-1c.89-.3,1.79-.55,2.69-.83s1.82-.44,2.74-.64,1.85-.35,2.79-.4a20.75,20.75,0,0,1,5.62.09,13.62,13.62,0,0,1,2.72.71A7.92,7.92,0,0,1,340.32,363.07Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.75,353.55c-1.58.94-29.38-11.69-35.59-16.69s-28.92-18.09-43.11-27.15c-12.32-7.88-27.84-23.26-29.87-27.9-.31-.7-.31-1.15,0-1.3a.89.89,0,0,1,.23-.05c2.71-.3,21.87,3.23,36,15.09,8.7,7.33,25.71,12.68,37.47,18.56,10.67,5.35,32,32.71,34.65,38.41C334.82,353.11,334.9,353.46,334.75,353.55Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.75,353.55c-1.58.94-29.38-11.69-35.59-16.69s-28.92-18.09-43.11-27.15c-12.32-7.88-27.84-23.26-29.87-27.9-.31-.7-.31-1.15,0-1.3a.89.89,0,0,1,.23-.05c2.71-.3,21.87,3.23,36,15.09,8.7,7.33,25.71,12.68,37.47,18.56,10.67,5.35,32,32.71,34.65,38.41C334.82,353.11,334.9,353.46,334.75,353.55Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,407.89H319.28a78.49,78.49,0,0,1-5.36-22.39s-1.09,8-1.65,15.85c0,.2,0,.41,0,.61v.12l-.06.72c-.11,1.77-.19,3.5-.22,5.09h-6.28a63,63,0,0,1-1.55-9.51s-.6,4.4-1.08,9.51H276.55l-10.71-.64-6.68-.41c.18-1.15.31-2.27.41-3.36a0,0,0,0,0,0,0c.08-.78.13-1.56.17-2.31a55.49,55.49,0,0,0-.09-7c-.51-6.37-2-10-1.89-8.95a39.45,39.45,0,0,1-1.41,14.13v0a32,32,0,0,1-2.68,6.42l-.43.74-.54,0-.66,0H252l-3.84-.23-.87-.06L245.2,406H245l-3.46-.2c-1.1-.05.4-1.66,2.29-4.1l.47-.64c.34-.45.68-.93,1-1.43l.08-.11c.42-.64.84-1.31,1.21-2a12.41,12.41,0,0,0,1.75-6.26c-.16-4.05-1.64-8.1-2.3-12.71,0-.32-.09-.65-.12-1a24.91,24.91,0,0,1,1.29-11.6,53.52,53.52,0,0,1,3.78-8.36c2.65-4.81,5.24-8.26,6.84-14.48,0,0,0,0,0,0a11.91,11.91,0,0,0,.26-2.06v-.06c.06-1.5,0-3.44,0-5.67-.16-6.43-.38-15.3,1.93-23,.05-.19.1-.37.16-.56q.18-.57.39-1.14c.13-.38.27-.75.42-1.12s.21-.51.33-.76a1.22,1.22,0,0,1,.07-.17,21.08,21.08,0,0,1,6.56-8.55l.41-.29a19.56,19.56,0,0,1,5.22-2.66,28.62,28.62,0,0,1,5-1.25,26,26,0,0,1,2.69-.29,24.48,24.48,0,0,1,3,0l.79.07h.13l.47.05.72.1a23,23,0,0,1,3.29.73,20.67,20.67,0,0,1,2.41.85,24.62,24.62,0,0,1,8.8,6,13.92,13.92,0,0,1,8.08,7.3l.07.15a19.17,19.17,0,0,1,.78,1.86,36.12,36.12,0,0,1,1.88,11.23c0,.31,0,.62,0,.93.07,4.47-.3,8.85-.54,12.29a14.57,14.57,0,0,0,.15,3.47,14.07,14.07,0,0,0,1.33,4.05,36,36,0,0,0,5.53,7.44l0,0c4.05,4.56,8.73,9.67,10.81,18.27,1.29,5.32.63,9.89,0,14.39l-.21,1.46c-.7,5.06-1.13,10.12,1.51,16.13a.36.36,0,0,1,0,.09q.25.57.54,1.14a.59.59,0,0,1,0,.08A34,34,0,0,0,333.55,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.8,407.89h0a29.49,29.49,0,0,1-5.49-8.83,15.22,15.22,0,0,1-1-5.33,34,34,0,0,1,.54-5.29c.05-.31.11-.63.16-.94.08-.47.17-.94.25-1.41.48-2.62,1-5.18,1.22-7.74a26.63,26.63,0,0,0-.61-9.73,22.77,22.77,0,0,0-4.55-8.55,79.62,79.62,0,0,0-7.17-7.18l-1-.89,0,0a32.07,32.07,0,0,1-5.88-7.07c-.14-.24-.28-.49-.41-.74a17.43,17.43,0,0,1-1.91-9.38,18.91,18.91,0,0,0,1.34,5.7,17.25,17.25,0,0,0,2,3.75c.25.36.51.7.78,1a44.75,44.75,0,0,0,6.36,6.08,63.33,63.33,0,0,1,7.74,7.08,23.87,23.87,0,0,1,5.26,9.45,27.18,27.18,0,0,1,.63,10.75,94.08,94.08,0,0,1-2,9.62c-.05.2-.09.41-.14.61s-.11.5-.17.74c-.68,3.06-1.11,6.06-.23,9A36.47,36.47,0,0,0,335.8,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,308.47c-1.77,3.89-2.53,8.14-3.29,12.32s-1.17,8.43-1.6,12.64l-.69,6.28a31.29,31.29,0,0,1-1.17,6c-1.18,3.86-3.49,7.18-6.08,10.55a48.21,48.21,0,0,0-3.6,5.43,29.62,29.62,0,0,0-2.55,6.13,42.49,42.49,0,0,0-1.15,6.46,26.92,26.92,0,0,0,.11,6.59c.3,2.18.83,4.26,1.27,6.29a32.71,32.71,0,0,1,.75,6.14c.16,4.06-2.14,8-5.51,10.56a13.24,13.24,0,0,0,6.82-10.52,32,32,0,0,0-.3-6.49c-.29-2.14-.75-4.19-.9-6.22a33.73,33.73,0,0,1,1.42-12.08,28.87,28.87,0,0,1,2.39-5.54,46,46,0,0,1,3.47-5.11c1.24-1.69,2.54-3.44,3.67-5.34a26.76,26.76,0,0,0,2.69-6.09,34.62,34.62,0,0,0,1.08-6.49c.19-2.13.31-4.25.42-6.37.25-4.23.44-8.44.8-12.65A61.42,61.42,0,0,1,261.4,308.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.27,367.36h0c-.32,3.31-2.62,7.57-5.09,10.6A147.87,147.87,0,0,1,264,397.73c-1.39,1.15-2.81,2.28-4.24,3.41-2,1.56-4,3.1-6.08,4.59l-1,.71-.48.35-.68.48-.87.62H190.34a142.79,142.79,0,0,1-8.81-29.41c-.1-.57-.2-1.14-.29-1.71-.29-1.75-.53-3.5-.73-5.25a88,88,0,0,1-.58-11.63c.08-4.08,36.5-3.39,37.71,2.2.38,1.77,1.07,4.68,1.88,7.93l.8,3.15c1.48,5.75,3.15,11.76,4.11,14.15.18.44,1.75,0,4.26-.92q1.14-.43,2.52-1l.55-.23,1.23-.53.81-.36,1.64-.74.41-.19,1.84-.84,3.68-1.72,2.08-1,2.63-1.27c9-4.36,18.81-9.25,24.78-12a65,65,0,0,1,7-2.86c.52-.17,1-.32,1.49-.45l.07,0h.07C287.35,360.94,289.65,363.51,289.27,367.36Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,366.17c-.23,3.19-2.89,8.34-9.48,16.34a128.94,128.94,0,0,1-10.11,10.84c-.51.5-1,1-1.57,1.48q-2.82,2.66-5.79,5.17c-1.38,1.19-2.78,2.34-4.19,3.48-1,.84-2.09,1.66-3.14,2.47l-2.55,1.94h0l-.7.52c-.11-.17-.21-.35-.31-.52H189c-5.53-14.05-9.75-29.09-9.75-29.09l2.31-.32,38.79-5.31,3.1-.43.16,0s0,.17,0,.46c0,2.41.25,13.49,1.4,13.89a14.49,14.49,0,0,0,3.45-1.27l2.54-1.14.53-.25,1.17-.53.8-.38,1.61-.75.35-.17,1.92-.91,3.89-1.86,2.17-1.05,2.54-1.23c10.16-4.95,21-10.33,24.94-12.23a44.55,44.55,0,0,1,7.61-2.73l.9-.23h.06c4.26-1,8.56-1.22,10.37.79A3.91,3.91,0,0,1,290.71,366.17Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22,378.8l44.36-6.08s.62-4-.39-4.17-2.61,3.25-2.61,3.25-1.7-3.7-3.65-3.46-2.44,4.54-2.44,4.54-2.44-4.27-4-4-2,4.81-2,4.81-2.46-4.5-4.5-4.2-3.26,5.11-3.26,5.11-2.17-4.34-4.59-3.71-1.92,5-1.92,5-2.44-3.65-4.55-3.36S187,377,187,377s-2.12-3.46-3.69-3.32-1.65,3.57-1.65,3.57-2.44-2.65-3.6-1.9S179.22,378.8,179.22,378.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.83,366.06h0c-.16,3.14-2.82,8.36-9.57,16.61a117.74,117.74,0,0,1-10.14,10.67c-.51.5-1,1-1.57,1.48-1.84,1.71-3.78,3.43-5.79,5.14q-2.06,1.77-4.19,3.48c-1,.85-2.09,1.68-3.14,2.5l-2.55,1.94h0l-.7.52c-.11-.17-.21-.35-.31-.52h-1.68c.12-.2.24-.41.35-.62l.47-.82,0-.05c1.27-2.18,2.73-4.58,4.31-7.09v0q1.59-2.54,3.3-5.18c4.26-6.62,8.93-13.61,12.79-19.58,3-4.62,5.5-8.63,6.95-11.37a.54.54,0,0,1,.07-.13.61.61,0,0,0,.05-.12l.22-.41c4.15-.92,8.27-1.18,10.11.62A3.61,3.61,0,0,1,290.83,366.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.86,407.89H240.8c-.85-1.44-1.7-2.87-2.52-4.27a.05.05,0,0,1,0-.05C234.32,397,231,391.2,230,389.44c-.26-.49-.72-1.54-1.33-3l-.25-.6c-1.2-3-2.91-7.44-4.85-12.62l-.17-.44c-.42-1.13-.86-2.29-1.31-3.48-1.2-3.24-2.48-6.66-3.75-10.11l-2.45-6.59c-1.31-3.54-2.59-7-3.79-10.21-.11-.32-.22-.63-.34-.94-1.13-3.06-2.18-5.87-3.08-8.27-.14-.37-.27-.73-.41-1.08-.37-1-.71-1.9-1-2.71-.78-2.05-1.35-3.5-1.64-4.15a18.3,18.3,0,0,1-.7-2s0,0,0-.07c-.7-2.34-1.62-6-2.57-10.2-2.72-12-5.69-28.29-4.85-29.74,1.25-2.14,8.2-7.56,10.77-4.57,3.18,3.69,4.21,27.27,7.76,41,.27,1,.55,2,.85,2.95.17.53.78,2.34,1.7,5,.1.33.22.66.33,1l3,8.87c0,.16.11.32.16.48l2.81,8.24c4.61,13.46,10,28.88,12.49,35.42.12.29.22.56.33.82a13.93,13.93,0,0,0,1.06,2.35c.41.46,2.18,3.27,4.59,7.21l1.29,2.12h0l2,3.3c1.71,2.84,3.54,5.9,5.34,8.91l0,.06.21.34C252.42,407.16,252.64,407.53,252.86,407.89Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.86,407.89H240.8c-.85-1.44-1.7-2.87-2.52-4.27a.05.05,0,0,1,0-.05C234.32,397,231,391.2,230,389.44c-.26-.49-.72-1.54-1.33-3l-.25-.6c-1.2-3-2.91-7.44-4.85-12.62l-.17-.44c-.42-1.13-.86-2.29-1.31-3.48-1.2-3.24-2.48-6.66-3.75-10.11l-2.45-6.59c-1.31-3.54-2.59-7-3.79-10.21-.11-.32-.22-.63-.34-.94-1.13-3.06-2.18-5.87-3.08-8.27-.14-.37-.27-.73-.41-1.08-.37-1-.71-1.9-1-2.71-.78-2.05-1.35-3.5-1.64-4.15a18.3,18.3,0,0,1-.7-2s0,0,0-.07c-.7-2.34-1.62-6-2.57-10.2-2.72-12-5.69-28.29-4.85-29.74,1.25-2.14,8.2-7.56,10.77-4.57,3.18,3.69,4.21,27.27,7.76,41,.27,1,.55,2,.85,2.95.17.53.78,2.34,1.7,5,.1.33.22.66.33,1l3,8.87c0,.16.11.32.16.48l2.81,8.24c4.61,13.46,10,28.88,12.49,35.42.12.29.22.56.33.82a13.93,13.93,0,0,0,1.06,2.35c.41.46,2.18,3.27,4.59,7.21l1.29,2.12h0l2,3.3c1.71,2.84,3.54,5.9,5.34,8.91l0,.06.21.34C252.42,407.16,252.64,407.53,252.86,407.89Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.53,281c0-.19-.35-.19-.35,0-.13,3.79-3.71,4.66-6.45,6.14-.27.14-.18.62.16.55C204.08,287,207.81,284.61,207.53,281Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.87,370.74c-4.53-12.9-9-25.83-13.47-38.73-4.6-13.14-8.69-26.39-11-40.15a.16.16,0,0,0-.32.05c1.11,13.65,5.58,26.76,10.17,39.58,4.71,13.14,9.66,26.2,14.44,39.32C226.76,370.91,226.91,370.84,226.87,370.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.36,407.89h-.77c-.43-.6-.88-1.19-1.33-1.79-1.12-1.49-2.27-3-3.41-4.44-.49-.63-1-1.26-1.46-1.88-.14-.2-.3-.4-.45-.6a73.73,73.73,0,0,1-8.11-12.7q-.44-.93-.84-1.86c-.11-.25-.21-.49-.31-.74-4.37-10.63-5.44-22.39-10.69-32.71,0-.06.07-.1.1,0,6,10,7,21.76,11.39,32.37.1.26.2.51.32.76.26.63.54,1.25.83,1.86a75,75,0,0,0,7.71,12.26l.52.69,1.46,1.95c1.28,1.71,2.57,3.41,3.81,5.14C248.55,406.73,249,407.31,249.36,407.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.94,407.89h-.28c-.24-.63-.45-1.28-.64-1.93l-.09-.29c0-.09.12-.13.15-.05l.12.35C245.42,406.62,245.67,407.26,245.94,407.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.4,399.43c-4.11-6.62-8.17-13.14-11.66-20.13,0-.08-.17,0-.13.06a82.07,82.07,0,0,0,11.63,20.2C245.32,399.66,245.47,399.54,245.4,399.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87,403.21a85.18,85.18,0,0,1-8.16-13.14c-2.17-4.55-3.11-9.57-5.53-14-.07-.12-.26,0-.2.09,2.27,4.83,3.07,10.18,5.47,15,2.21,4.41,5.31,8.29,8.26,12.23C241.79,403.45,242,403.32,241.87,403.21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.6,333.87c-5.79-12.18-6.58-25.76-10.71-38.45,0-.15-.29-.07-.26.08,2.93,12.93,4.56,26.56,10.77,38.46C217.46,334.08,217.66,334,217.6,333.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.3,351.73a73.8,73.8,0,0,0-6.69-15.26c0-.06-.14,0-.1,0,2.44,5,4.51,10.14,6.59,15.3C224.15,352,224.33,351.86,224.3,351.73Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.27,305.73a96.79,96.79,0,0,0-2.63-19,.05.05,0,0,0-.1,0c.93,6.33,1.63,12.69,2.49,19A.12.12,0,0,0,211.27,305.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.52,371.54s-3.53-8.58-2.7-21.05c.57-8.62,3.92-27.24,27-38.85,5.47-2.75,12.57.12,7.21,5.66s-9.42,6.7-11.85,10.44c0,0,12.39,1.41,14.93,7,1.14,2.49,4,7.73,5.5,13.41,0,0-1,2.31-2.61,3,0,0,2.21,5.3-1.18,13.36Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.15,348.94c2.25-3.93,7.16-12.18,13.52-17.54,7.07-5.94,22.29-15.49,26.62-10.23,3.18,3.86-2.31,8-2.31,8s7.12-2.62,9.23,1.5c1.93,3.74-2.51,6.71-2.51,6.71s4.59-.85,5.75,3.12c1.39,4.77-8.47,5.76-11.24,11.81C217.59,353.68,179.15,348.94,179.15,348.94Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,339.92c2.72-3.35,10.86-9.37,19.09-10.81.19,0,.31.1.15.16A90,90,0,0,0,197.77,340,0,0,0,0,1,197.71,339.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,346.88c2.65-2.65,11.31-8.48,19.7-9.65.19,0,.31.11.14.17A96.84,96.84,0,0,0,204,347S203.89,346.91,203.92,346.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,407.89h-66.7c-.14-.21-.27-.42-.39-.64a14.15,14.15,0,0,1-2.08-7.25v0c0-.18,0-.36,0-.55a16.36,16.36,0,0,1,.2-1.69c.94-5.82,4.85-15.4,8.46-23.2,2.15-4.67,4.21-8.7,5.46-10.92.23-.41.44-.76.61-1a5.55,5.55,0,0,1,.49-.7c.12-.12.23-.25.36-.37l0,0h0a23.84,23.84,0,0,1,2.37-2.16l.06,0a18.53,18.53,0,0,1,2-1.38c.14-.08.28-.17.42-.24a14.44,14.44,0,0,1,3.06-1.32,11,11,0,0,1,1.13-.29,12.42,12.42,0,0,1,3.24-.26h.08a10.79,10.79,0,0,1,1.48.16h0a15.44,15.44,0,0,1,3.5,1h0a21.91,21.91,0,0,1,3.82,2.11l.38.27c.56.4,1.13.83,1.71,1.31,10.24,8.44,20.16,25.94,27.62,41.61a.36.36,0,0,1,0,.09l.54,1.14a.59.59,0,0,1,0,.08Q332,405.77,332.93,407.89Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,407.89h-66.7c-.14-.21-.27-.42-.39-.64a14.15,14.15,0,0,1-2.08-7.25v0c0-.18,0-.36,0-.55a16.36,16.36,0,0,1,.2-1.69c.94-5.82,4.85-15.4,8.46-23.2,2.15-4.67,4.21-8.7,5.46-10.92.23-.41.44-.76.61-1a5.55,5.55,0,0,1,.49-.7c.12-.12.23-.25.36-.37l0,0h0a23.84,23.84,0,0,1,2.37-2.16l.06,0a18.53,18.53,0,0,1,2-1.38c.14-.08.28-.17.42-.24a14.44,14.44,0,0,1,3.06-1.32,11,11,0,0,1,1.13-.29,12.42,12.42,0,0,1,3.24-.26h.08a10.79,10.79,0,0,1,1.48.16h0a15.44,15.44,0,0,1,3.5,1h0a21.91,21.91,0,0,1,3.82,2.11l.38.27c.56.4,1.13.83,1.71,1.31,10.24,8.44,20.16,25.94,27.62,41.61a.36.36,0,0,1,0,.09l.54,1.14a.59.59,0,0,1,0,.08Q332,405.77,332.93,407.89Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.72,358.58c-.35,1.59-7.75,12-15,11.76-2.36-.08-2.5-13-2.5-13l-.23-.95-3.19-13.29,15.51-10.29,2.25-1.37s.63,3.7,1.37,8.3c0,.22.07.43.1.66s.1.5.14.75c.12.68.23,1.39.34,2.09.08.53.16,1.05.23,1.61s.14,1.12.22,1.68A87.08,87.08,0,0,1,296.72,358.58Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,359.21s.09,11.05,2.45,11.12c7.24.24,14.64-10.15,15-11.75a22.76,22.76,0,0,0-.11-4.74C296.23,354.11,288.35,359.93,279.28,359.21Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,353.86s-8.5,6.34-17.33,5.35c0,0-1-1.7-.54-2.26s1.89,1.66,1.89,1.66.17-1.75,1.13-2.13,2.3,1.75,2.3,1.75.5-2.29,1.79-2.5S288,357.3,288,357.3s.58-2.69,1.71-2.93,2,1.49,2,1.49.62-2.26,1.34-2.52,1.58,1.11,1.58,1.11,1.06-2.24,1.65-2.3S296.61,353.86,296.61,353.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.82,343.13l2.7,11.27c8.59-1,14.4-9.19,16.68-13.08a.77.77,0,0,0,0-.15c0-.23-.09-.48-.14-.74s-.06-.44-.1-.66c-.74-4.6-1.37-8.29-1.37-8.29l-2.25,1.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,322.18C255,346,268.94,350.36,274.08,351c4.67.54,20.62,1.79,25.84-21.62s-5-32.23-15.57-34S260.55,298.36,257.77,322.18Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74,317.75c.55,0,1.06-.13,1.61-.2A2.63,2.63,0,0,0,270,317a.83.83,0,0,0,.08-1,2.08,2.08,0,0,0-2-.65,3.06,3.06,0,0,0-2,.92A.89.89,0,0,0,266.74,317.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.65,319.12c-.55-.11-1-.3-1.56-.46a2.63,2.63,0,0,1-1.5-.78.82.82,0,0,1,.09-1,2.05,2.05,0,0,1,2.07-.32,3,3,0,0,1,1.82,1.23A.89.89,0,0,1,283.65,319.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,324.57c0-.06.12.09.11.15-.22,1.59-.2,3.44,1.18,4.12.05,0,0,.1,0,.09C279,328.5,279,326,279.47,324.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,323.05c2.58.08,2.25,5.23-.14,5.16S278.9,323,281.06,323.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,323.39c.43.32.84.87,1.38,1s1.13-.41,1.57-.9c.05-.05.09,0,.09.06-.05,1-.5,2-1.57,2.06s-1.61-.85-1.79-1.86C281.71,323.52,281.88,323.26,282.06,323.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,323.54c0-.07-.13.06-.13.13,0,1.6-.36,3.43-1.83,3.87-.05,0-.05.1,0,.09C269.59,327.49,270,325.06,269.77,323.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.44,321.79c-2.56-.35-3.05,4.79-.68,5.11S270.59,322.07,268.44,321.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,322c-.44.23-.89.69-1.37.68s-.93-.62-1.24-1.19c0-.06-.08,0-.08.05-.13,1,.1,2,1,2.32s1.56-.53,1.89-1.49C267.62,322.22,267.51,321.93,267.34,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.91,337.76c-.39.36-.79.87-1.37.91a4.17,4.17,0,0,1-1.71-.44c-.05,0-.1,0-.07.08a2.13,2.13,0,0,0,2,.91,1.7,1.7,0,0,0,1.29-1.39C277.09,337.74,277,337.7,276.91,337.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,331.48s-.51,2.36-.6,3.48c0,.1.26.18.64.23h0a5.37,5.37,0,0,0,5.34-1.59.12.12,0,0,0-.16-.17,8,8,0,0,1-5,1c-.06-.32,1-4,.83-4a9.64,9.64,0,0,0-2.59.39c.92-4.95,2.63-9.7,3.48-14.63,0-.18-.23-.25-.29-.1-2.14,4.86-3.33,10.52-4.42,15.6C267.84,332.3,270.22,331.63,270.68,331.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.88,335a6.76,6.76,0,0,0,2.5,2.32,3.08,3.08,0,0,0,1.81.28c1.36-.23,1.5-1.44,1.35-2.5a7.2,7.2,0,0,0-.45-1.65A8.66,8.66,0,0,1,270.88,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.38,337.3a3.08,3.08,0,0,0,1.81.28c1.36-.23,1.5-1.44,1.35-2.5A3.1,3.1,0,0,0,273.38,337.3Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.84,331.07c-3.41.25-3.2-14.05-3.2-14.05a15.46,15.46,0,0,1-10.18-8.35s-7.4,4.21-18.07,2.19c-7.31-1.38-9.49-7.52-8.12-12.06,1.91-6.34,10.34-9.25,19.06-8.25,11,1.27,18.17,10,18.17,10s4.72,1.6,7.53,8.33C305.15,314,301.93,330.76,297.84,331.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.94,338.12a4.56,4.56,0,0,1-1.12.25,3.88,3.88,0,0,1-1.13,0,3.33,3.33,0,0,1-1.37-.49,4,4,0,0,1-.88-.73,4.47,4.47,0,0,1-.87-1.37l1.52-6.37s5.46-7.32,8.79-5.35S303,336.76,298.94,338.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.59,327.1c.06,0,.07.08,0,.1-2.83,1.05-4.38,3.6-5.49,6.26a2.24,2.24,0,0,1,3.37-.51c.07.05,0,.16-.08.14a2.5,2.5,0,0,0-2.77.79,12.14,12.14,0,0,0-1.38,2.18c-.14.25-.59.1-.49-.18l0-.07C295.83,332.25,298.75,327.34,302.59,327.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.83,353.27c-2.65-5.68-25.41-33.93-36-39.25-11.71-5.86-28.65-11.19-37.32-18.48-14-11.82-32.32-15.38-35-15.08,8.59-1.84,42.58,8,42.58,8s1.68,0,21.54,10.15c21,10.72,30,23.84,31.08,25.48C329.4,335.64,334.06,349.6,334.83,353.27Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.76,300.27c-.58,2.47-1.75-1.94-2.16-6.52-.25-2.81-.78-5.43-1.9-6.46-2.54-2.3-9.37-8.56-9.37-8.56s.55,5.45-2.8,5.5-3.55.35-3.55.35-.71,4.39-2.41,5.46-5.84,1.53-5.36,4.53-4.94,21.15-4.94,21.15c-1.34-2.05-44.37-26.93-44.37-26.93s39.65-21.92,46.27-22.81c6.9-.94,16.19-.19,20,2.91s11.05,15.92,11.15,17.89S347.67,296.36,346.76,300.27Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.21,293.52a5.2,5.2,0,0,0-.48-1.64,9.93,9.93,0,0,0-.85-2.2,15.19,15.19,0,0,1-1.48-4.25s0,0,0,0a16.57,16.57,0,0,0,.79,3.66c.18.45.4.88.6,1.31a8.17,8.17,0,0,0-1.28-1.17,48.79,48.79,0,0,0-5.41-3.35c-.06,0-.11.08-.05.12,2.94,2,6.3,3.63,7.92,7.59C319,293.78,319.24,293.75,319.21,293.52Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,284.54c-1.43-2.13-3.62-2.7-5.11-4.77,0,0,0,0,0,0a9.21,9.21,0,0,0,2.07,2.63c.47.39,1,.65,1.48,1s1,.86,1.51,1.22C327,284.71,327.09,284.61,327,284.54Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.42,315.22s-16-15.69-44.52-26.43c-.67-.25,7.89-5.43,8.52-5.65s24,9.11,37.95,25.18C317,309,314.42,315.22,314.42,315.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,288.53c-.16-.24-.6-.9-5.16-3.36-4.17-2.26-5.33-2.45-5.77-2.45h-.14c-.29,0-.55,0-1.37.88-.48.48-1.15,1.24-2.14,2.44a41.92,41.92,0,0,0-3.11,4.19l-.07.13-.11.25,0,.09a2.29,2.29,0,0,0-.16.65,2.51,2.51,0,0,0,.05.76c.18.8.38,1.16,3.3,3l.59.37.35.22c1.78,1.1,3.72,2.23,5.16,3a14.66,14.66,0,0,0,2.24,1,1.33,1.33,0,0,0,1.35-.16,2.48,2.48,0,0,0,.36-.39c.27-.33.65-.85,1.08-1.48,0-.08.1-.16.15-.24l.47-.71.25-.38.42-.69c1.28-2.09,2.54-4.43,2.66-5.49a2.68,2.68,0,0,0,0-.39A2.4,2.4,0,0,0,292.39,288.53Zm-6,7.14,0,.06c-.06.1-.13.2-.19.28l0,0c-.28-.13-.65-.31-1.07-.53l-.21-.12-.94-.51c-2-1.12-4.56-2.67-6.07-3.67.12-.17.26-.34.4-.53a51.16,51.16,0,0,1,3.55-4.23,55.73,55.73,0,0,1,7.74,4c-.49,1-1.31,2.37-2.08,3.59C287.08,294.64,286.7,295.22,286.39,295.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,407.89H315.11q-1.49-3-2.89-5.93c-1.55-3.22-3-6.33-4.42-9.29-.39-.85-.77-1.68-1.15-2.49l-.86-1.87c-.84-1.84-1.63-3.58-2.35-5.2-.26-.57-.5-1.14-.74-1.69a.38.38,0,0,1-.06-.13c-.89-2-1.69-3.93-2.39-5.66a60.65,60.65,0,0,1-2.76-8.2c0-.1-.05-.2-.07-.3-1.65-7,.2-9.26,3.56-7.8a12.16,12.16,0,0,1,2.95,1.9c7.53,6.25,16.11,15,24.87,24.89.41.45.82.91,1.22,1.38.62.7,1.24,1.4,1.85,2.11C337,395.49,342.16,401.68,347.17,407.89Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44,407.89H315q-1.41-3-2.75-5.81c-1.56-3.29-3.05-6.45-4.42-9.41-.39-.85-.77-1.68-1.15-2.49l-.86-1.87c-.84-1.84-1.63-3.58-2.35-5.2l-1-2.32,0,0c-1.73-4-3-7-3.58-8.8-.5-1.51-1-3-1.31-4.52,0-.1-.05-.2-.07-.3-1.24-5.29-1.1-9.59,3.18-8.07a10.88,10.88,0,0,1,1.72.79c6.8,3.8,16.37,13.17,26.69,24.81l1.26,1.43c.64.71,1.27,1.44,1.91,2.17C337.54,394.45,343.05,401.14,348.44,407.89Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,407.89h-.8l-1.09-2.26-1.33-2.83c-1.71-3.63-3.41-7.26-5.07-10.9-1.1-2.45-2.22-4.9-3.29-7.37-.12-.28-.25-.57-.37-.86h0c-.81-1.88-1.59-3.77-2.32-5.68.41.93.83,1.85,1.27,2.77l0,0c.08.17.15.33.24.5a.38.38,0,0,0,.06.13c.54,1.14,1.09,2.28,1.64,3.41l3.28,6.82,4.65,9.7,1.89,3.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,384.67a8.81,8.81,0,0,1-1.6-1.63,8.56,8.56,0,0,1-.63-.94,4.94,4.94,0,0,1-.49-1,14.07,14.07,0,0,1,1.52,1.68A10.25,10.25,0,0,1,304,384.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.86,225.21h-182a6.54,6.54,0,0,0-6.54-6.54V199.83l1-1.06c7.44-8,13.52-14.48,16.57-17.58,11.5-11.66,25.94-24.38,25.94-24.38a23.4,23.4,0,0,0-.53-3.66c0-.25-.11-.49-.18-.74a2.49,2.49,0,0,0-.09-.37c-.08-.31-.16-.62-.26-.93-.16-.56-.35-1.13-.55-1.69-.11-.31-.22-.62-.35-.94s-.17-.44-.26-.66c-.22-.53-.45-1.07-.69-1.6-.14-.3-.28-.61-.43-.91s-.37-.77-.57-1.15-.27-.52-.41-.78c-.68-1.28-1.43-2.56-2.23-3.82-.2-.32-.4-.64-.61-.95s-.4-.62-.62-.93-.42-.63-.64-.94a3,3,0,0,0-.2-.29c-.36-.52-.73-1-1.11-1.54l-.17-.24c-.39-.53-.79-1-1.19-1.57-.22-.3-.45-.6-.69-.89l-1.41-1.75-.07-.09c-1.29-1.56-2.59-3.07-3.89-4.49-.52-.57-1-1.13-1.55-1.67-.25-.28-.51-.55-.76-.81s-.54-.57-.82-.85c-.45-.48-.91-.94-1.35-1.38-3.6-3.62-6.68-6.37-8.31-7.78l-.48-.41-.65-.55h0l-.07-.06C85.46,99.85,101.53,94.27,115.63,93l1.09-.1a69.69,69.69,0,0,1,25.06,2.51c1.35.38,2.66.8,3.94,1.25l1.26.45,1.15.44a84,84,0,0,1,35,26.43l0,0h0a55.68,55.68,0,0,0-13.29,6.91c-.59.42-1.17.84-1.74,1.27l0,0c-.55.42-1.09.85-1.62,1.28l-.83.68q-.76.64-1.5,1.32c-.49.44-1,.89-1.45,1.35l-1.21,1.2c-.78.79-1.52,1.59-2.23,2.38-.36.4-.7.8-1,1.19l0,0c-1,1.12-1.82,2.22-2.61,3.29h0c-.39.53-.77,1.06-1.14,1.58s-.71,1-1,1.51h0c-.65,1-1.23,1.91-1.74,2.78-.31.51-.59,1-.85,1.47-.17.3-.33.6-.48.88a37.08,37.08,0,0,0-1.65,3.4h0l.34.14.42.18.92.39.79.34,3.2,1.38,1.32.57,1.43.62,2.35,1,1.7.74.88.39,1.82.8c2.19,1,4.54,2,7,3.11l4.36,2,4.55,2.06,4.7,2.15,2.39,1.1c3.19,1.48,6.43,3,9.65,4.53l2.41,1.15,4.76,2.31,5.56,2.76c1.21.61,2.41,1.21,3.58,1.82l.87.45c.87.45,1.73.89,2.57,1.34l1.66.88,1.62.87.79.43,1.54.85c1,.56,2,1.12,2.95,1.66l1.37.81.68.39,1.28.78h0l1.21.76h0l1.14.74a37.05,37.05,0,0,1,5.57,4.22l.28.28,0,0,0,0,.41.47c.15.19.31.4.46.61a15.11,15.11,0,0,1,1.34,2.32c.14.28.27.57.4.87.22.5.44,1,.64,1.58,0,.11.09.23.13.34s.18.48.26.73h0c.09.25.18.51.26.79h0c.05.15.09.29.13.44h0s0,0,0,0,0,.09,0,.14v0l.06.22c.12.38.24.78.36,1.19.29,1.05.58,2.16.85,3.33a1.33,1.33,0,0,1,.05.19l.06.24v0a.15.15,0,0,1,0,.07c.14.58.28,1.19.4,1.81.1.46.2.93.29,1.41s.21,1,.3,1.57.2,1.08.29,1.63C243.38,222.06,243.63,223.6,243.86,225.21Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.86,225.21h-182a6.54,6.54,0,0,0-6.54-6.54V199.83l1-1.06c7.44-8,13.52-14.48,16.57-17.58,11.5-11.66,25.94-24.38,25.94-24.38a23.4,23.4,0,0,0-.53-3.66c0-.25-.11-.49-.18-.74a2.49,2.49,0,0,0-.09-.37c-.08-.31-.16-.62-.26-.93-.16-.56-.35-1.13-.55-1.69-.11-.31-.22-.62-.35-.94s-.17-.44-.26-.66c-.22-.53-.45-1.07-.69-1.6-.14-.3-.28-.61-.43-.91s-.37-.77-.57-1.15-.27-.52-.41-.78c-.68-1.28-1.43-2.56-2.23-3.82-.2-.32-.4-.64-.61-.95s-.4-.62-.62-.93-.42-.63-.64-.94a3,3,0,0,0-.2-.29c-.36-.52-.73-1-1.11-1.54l-.17-.24c-.39-.53-.79-1-1.19-1.57-.22-.3-.45-.6-.69-.89l-1.41-1.75-.07-.09c-1.29-1.56-2.59-3.07-3.89-4.49-.52-.57-1-1.13-1.55-1.67-.25-.28-.51-.55-.76-.81s-.54-.57-.82-.85c-.45-.48-.91-.94-1.35-1.38-3.6-3.62-6.68-6.37-8.31-7.78l-.48-.41-.65-.55h0l-.07-.06C85.46,99.85,101.53,94.27,115.63,93l1.09-.1a69.69,69.69,0,0,1,25.06,2.51c1.35.38,2.66.8,3.94,1.25l1.26.45,1.15.44a84,84,0,0,1,35,26.43l0,0h0a55.68,55.68,0,0,0-13.29,6.91c-.59.42-1.17.84-1.74,1.27l0,0c-.55.42-1.09.85-1.62,1.28l-.83.68q-.76.64-1.5,1.32c-.49.44-1,.89-1.45,1.35l-1.21,1.2c-.78.79-1.52,1.59-2.23,2.38-.36.4-.7.8-1,1.19l0,0c-1,1.12-1.82,2.22-2.61,3.29h0c-.39.53-.77,1.06-1.14,1.58s-.71,1-1,1.51h0c-.65,1-1.23,1.91-1.74,2.78-.31.51-.59,1-.85,1.47-.17.3-.33.6-.48.88a37.08,37.08,0,0,0-1.65,3.4h0l.34.14.42.18.92.39.79.34,3.2,1.38,1.32.57,1.43.62,2.35,1,1.7.74.88.39,1.82.8c2.19,1,4.54,2,7,3.11l4.36,2,4.55,2.06,4.7,2.15,2.39,1.1c3.19,1.48,6.43,3,9.65,4.53l2.41,1.15,4.76,2.31,5.56,2.76c1.21.61,2.41,1.21,3.58,1.82l.87.45c.87.45,1.73.89,2.57,1.34l1.66.88,1.62.87.79.43,1.54.85c1,.56,2,1.12,2.95,1.66l1.37.81.68.39,1.28.78h0l1.21.76h0l1.14.74a37.05,37.05,0,0,1,5.57,4.22l.28.28,0,0,0,0,.41.47c.15.19.31.4.46.61a15.11,15.11,0,0,1,1.34,2.32c.14.28.27.57.4.87.22.5.44,1,.64,1.58,0,.11.09.23.13.34s.18.48.26.73h0c.09.25.18.51.26.79h0c.05.15.09.29.13.44h0s0,0,0,0,0,.09,0,.14v0l.06.22c.12.38.24.78.36,1.19.29,1.05.58,2.16.85,3.33a1.33,1.33,0,0,1,.05.19l.06.24v0a.15.15,0,0,1,0,.07c.14.58.28,1.19.4,1.81.1.46.2.93.29,1.41s.21,1,.3,1.57.2,1.08.29,1.63C243.38,222.06,243.63,223.6,243.86,225.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.86,225.21h-1.63c-.53-2.23-1.07-4.48-1.59-6.55a2.68,2.68,0,0,1-.07-.27.13.13,0,0,1,0-.06,1.05,1.05,0,0,1-.06-.24c-.4-1.54-.77-3-1.1-4.17-1.25-4.51-4.49-9-8.47-13.11l-.29-.3h0a.18.18,0,0,0-.07-.08l0,0a5.93,5.93,0,0,0-.44-.43,67.93,67.93,0,0,0-6.62-5.72c-.71-.54-1.42-1.06-2.12-1.55l0,0-1-.72c-7.89-5.34-73.18-35.45-73.18-35.45s6.85-17.22,13.27-23.4c6.2-6,21.65-8.95,22.68-9.15a55.68,55.68,0,0,0-13.29,6.91c-.6.41-1.18.83-1.74,1.27l0,0c-.56.42-1.1.84-1.62,1.28l-.83.68q-.76.64-1.5,1.32c-.49.44-1,.89-1.45,1.35s-.82.8-1.21,1.2c-.79.79-1.53,1.59-2.23,2.38-.36.4-.7.8-1,1.19l0,0c-1,1.12-1.82,2.22-2.61,3.29h0c-.4.53-.78,1.06-1.14,1.58s-.71,1-1,1.51h0c-.65,1-1.23,1.91-1.74,2.78-.31.51-.59,1-.85,1.47-.17.3-.33.6-.48.88a37.08,37.08,0,0,0-1.65,3.4h0l.34.14.42.18.92.39.79.34c.87.37,2,.83,3.2,1.38l1.32.57,1.43.62,2.35,1,1.7.74.88.39,1.82.8c2.19,1,4.54,2,7,3.11l4.36,2,4.55,2.06,4.7,2.15,2.39,1.1c3.19,1.48,6.43,3,9.65,4.53l2.41,1.15,4.76,2.31c1.88.92,3.74,1.84,5.56,2.76,1.21.61,2.41,1.21,3.58,1.82l.87.45c.87.45,1.73.89,2.57,1.34l1.66.88,1.62.87.79.43c.52.28,1,.56,1.54.85,1,.56,2,1.12,2.95,1.66l1.37.81.68.39,1.28.78h0l1.21.76h0l1.14.74a37.05,37.05,0,0,1,5.57,4.22l.28.28h0l0,0,0,0,.41.47c.15.19.31.4.46.61a15.11,15.11,0,0,1,1.34,2.32c.14.28.27.57.4.87.22.5.44,1,.64,1.58,0,.11.09.23.13.34s.18.48.26.73h0c.09.25.18.51.26.79h0c.05.14.1.29.14.44s0,0,0,0,0,.09,0,.14v0l.06.22c.12.38.24.78.36,1.19.29,1.05.58,2.16.85,3.33a1.33,1.33,0,0,1,.05.19l.06.24v0a.15.15,0,0,1,0,.07c.14.58.28,1.19.4,1.81.1.46.2.93.29,1.41s.21,1,.3,1.57.2,1.08.29,1.63C243.38,222.06,243.63,223.6,243.86,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.64,157.81s-1.77,1.86-4.71,4.92l-.74.77-6.61,6.88-.08.08c-9,9.34-21.33,22.12-31.16,32.07-.67.69-1.34,1.36-2,2v-4.71l1-1.06c7.44-8,13.52-14.48,16.57-17.58,11.5-11.66,25.94-24.38,25.94-24.38a23.4,23.4,0,0,0-.53-3.66c0-.25-.11-.49-.18-.74a2.49,2.49,0,0,0-.09-.37c-.08-.31-.16-.62-.26-.93-.16-.56-.35-1.13-.55-1.69-.11-.31-.22-.62-.35-.94s-.17-.44-.26-.66c-.22-.53-.45-1.07-.69-1.6-.14-.3-.28-.61-.43-.91s-.37-.77-.57-1.15-.27-.52-.41-.78c-.68-1.28-1.43-2.56-2.23-3.82-.2-.32-.4-.64-.61-.95s-.4-.62-.62-.93-.42-.63-.64-.94a3,3,0,0,0-.2-.29c-.36-.52-.73-1-1.11-1.54l-.17-.24c-.39-.53-.78-1-1.19-1.57-.22-.3-.45-.6-.69-.89-.46-.59-.93-1.18-1.41-1.75l-.07-.09c-1.29-1.56-2.59-3.07-3.89-4.49-.52-.57-1-1.13-1.55-1.67-.25-.28-.51-.55-.76-.81s-.54-.57-.82-.85c-.45-.48-.91-.94-1.35-1.38-3.6-3.62-6.68-6.37-8.31-7.78l-.48-.41-.65-.55c1.68,1,24.44,14.71,28.05,20C99.56,137.85,100.64,157.81,100.64,157.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,213.48a5.83,5.83,0,0,1,0,.59v0a7.73,7.73,0,0,1-.38,1.89.14.14,0,0,1,0,.06,3.8,3.8,0,0,1-.18.54l0,0v0a9.31,9.31,0,0,1-.72,1.45c-1.59,2.63-4.48,5-8.22,7.12H197.76c-6.2-4.19-13.67-9.63-21.39-15.46l-.4-.3-1.54-1.17-.22-.16-1.72-1.32,0,0-1.77-1.35-.88-.68c-1.47-1.13-3-2.27-4.41-3.41L163,199.5l-1-.78-5.27-4.15-2.49-2-.82-.65-1.61-1.29h0l-.14-.11-1.46-1.16q-.39-.33-.78-.63l-.14-.11h0c-1-.79-1.95-1.57-2.89-2.34-2.94-2.38-5.64-4.6-8-6.58h0l-.08-.06-1.74-1.45a.43.43,0,0,0-.1-.09q-1.83-1.53-3.32-2.82l-.1-.08a3.47,3.47,0,0,1-.29-.25c-.19-.16-.38-.32-.56-.49l-.44-.38-.72-.63-.1-.09-.57-.5h0l-.14-.14-.16-.14-.05,0h0l-.12-.11s0,0,0,0l-1-1-.21-.2-.2-.2c-.52-.51-1-1-1.53-1.58s-1-1.17-1.54-1.77l-.2-.25h0l-.49-.62a27.37,27.37,0,0,1-3.16-4.9c-.91-1.94-1.26-3.67-.7-4.91a2.36,2.36,0,0,1,.35-.57,1.79,1.79,0,0,1,.23-.25.31.31,0,0,1,.11-.09h0l.17-.14a3.46,3.46,0,0,1,.66-.38h0a9.84,9.84,0,0,1,4.89-.42s0,0,0,0c.68.08,1.42.19,2.22.34a52.62,52.62,0,0,1,5.28,1.32l.58.18c.58.17,1.18.35,1.78.55.75.22,1.53.47,2.32.72l.26.08.14,0,.13,0c22.91,7.34,59.13,21.55,81.33,34.28l0,0c1.23.71,2.42,1.41,3.56,2.11,6.77,4.13,11.86,8.05,14.28,11.47.29.41.55.81.79,1.2h0a13.37,13.37,0,0,1,1.52,3.4,6.23,6.23,0,0,1,.15.62h0a8.76,8.76,0,0,1,.2,1.58C241.86,213.23,241.86,213.35,241.86,213.48Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,213.48a5.83,5.83,0,0,1,0,.59v0a7.73,7.73,0,0,1-.38,1.89.14.14,0,0,1,0,.06,3.8,3.8,0,0,1-.18.54l0,0v0a9.31,9.31,0,0,1-.72,1.45c-1.59,2.63-4.48,5-8.22,7.12H197.76c-6.2-4.19-13.67-9.63-21.39-15.46l-.4-.3-1.54-1.17-.22-.16-1.72-1.32,0,0-1.77-1.35-.88-.68c-1.47-1.13-3-2.27-4.41-3.41L163,199.5l-1-.78-5.27-4.15-2.49-2-.82-.65-1.61-1.29h0l-.14-.11-1.46-1.16q-.39-.33-.78-.63l-.14-.11h0c-1-.79-1.95-1.57-2.89-2.34-2.94-2.38-5.64-4.6-8-6.58h0l-.08-.06-1.74-1.45a.43.43,0,0,0-.1-.09q-1.83-1.53-3.32-2.82l-.1-.08a3.47,3.47,0,0,1-.29-.25c-.19-.16-.38-.32-.56-.49l-.44-.38-.72-.63-.1-.09-.57-.5h0l-.14-.14-.16-.14-.05,0h0l-.12-.11s0,0,0,0l-1-1-.21-.2-.2-.2c-.52-.51-1-1-1.53-1.58s-1-1.17-1.54-1.77l-.2-.25h0l-.49-.62a27.37,27.37,0,0,1-3.16-4.9c-.91-1.94-1.26-3.67-.7-4.91a2.36,2.36,0,0,1,.35-.57,1.79,1.79,0,0,1,.23-.25.31.31,0,0,1,.11-.09h0l.17-.14a3.46,3.46,0,0,1,.66-.38h0a9.84,9.84,0,0,1,4.89-.42s0,0,0,0c.68.08,1.42.19,2.22.34a52.62,52.62,0,0,1,5.28,1.32l.58.18c.58.17,1.18.35,1.78.55.75.22,1.53.47,2.32.72l.26.08.14,0,.13,0c22.91,7.34,59.13,21.55,81.33,34.28l0,0c1.23.71,2.42,1.41,3.56,2.11,6.77,4.13,11.86,8.05,14.28,11.47.29.41.55.81.79,1.2h0a13.37,13.37,0,0,1,1.52,3.4,6.23,6.23,0,0,1,.15.62h0a8.76,8.76,0,0,1,.2,1.58C241.86,213.23,241.86,213.35,241.86,213.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,171.41c4.58,4.46,26.91,22.77,47.52,38.34l-46.89-54.31C114.5,152.63,121.23,164,128.85,171.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,225.21H76.64c.21-.82.43-1.65.67-2.48.41-1.56.84-3.12,1.28-4.69.25-.93.51-1.87.78-2.81l.39-1.36c.26-.86.51-1.72.76-2.59,0,0,0,0,0,0,.45-1.52.92-3.05,1.39-4.57,0,0,0,0,0,0q.72-2.28,1.46-4.55s0,0,0,0l.85-2.55c1.17-3.46,2.38-6.86,3.65-10.17.31-.82.63-1.63,1-2.43q1-2.46,2-4.83c.5-1.17,1-2.32,1.52-3.45s1-2.29,1.58-3.4L95,173.09s0,0,0,0c.36-.71.72-1.41,1.08-2.09v0l.94-1.75c1.36-2.46,2.76-4.78,4.19-6.92.59-.87,1.19-1.72,1.79-2.53s1.22-1.61,1.83-2.36l.07-.08,0,0,.54-.64L106,156c.65-.72,1.29-1.39,1.94-2s1.28-1.23,1.94-1.78a14.52,14.52,0,0,1,2.28-1.58,15,15,0,0,1,2.14-1c.28-.12.57-.22.85-.31a23.61,23.61,0,0,1,9-1.05c5.93.37,11.19,2.53,12.53,4.29l.18.25.17.24.17.25a30.7,30.7,0,0,1,2.3,4.34h0a3.26,3.26,0,0,0,.18.38h0c0,.12.09.23.14.35s.11.24.15.36h0c.1.25.21.5.32.76s.26.64.39,1h0c.52,1.32,1.05,2.76,1.59,4.3l.3.86c.2.59.41,1.19.61,1.81s.37,1.1.55,1.67l0,.11h0c.18.55.36,1.12.54,1.69h0c.27.86.54,1.74.81,2.63a.13.13,0,0,1,0,.06h0l.48,1.63c0,.05,0,.1.05.15l0,.09v0c1.19,4.07,2.39,8.48,3.58,13.09h0c.24,1,.49,1.9.72,2.86.3,1.17.6,2.34.88,3.52.13.53.27,1.07.4,1.6a0,0,0,0,0,0,0c.19.76.37,1.51.55,2.27h0c.3,1.21.59,2.43.87,3.65,0,.14.07.27.1.4.36,1.53.71,3,1.05,4.57.18.77.35,1.53.53,2.3.3,1.32.59,2.63.88,3.94h0c0,.12.05.25.08.37.07.34.15.67.22,1q1.06,4.82,2,9.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,225.21H76.66c.21-.83.43-1.65.65-2.48.41-1.56.84-3.12,1.28-4.69.25-.93.51-1.87.78-2.81l.39-1.36c.26-.86.51-1.72.76-2.59,0,0,0,0,0,0,.45-1.52.92-3.05,1.39-4.57,0,0,0,0,0,0q.72-2.28,1.46-4.55s0,0,0,0l.85-2.55c1.17-3.46,2.38-6.86,3.65-10.17.31-.82.63-1.63,1-2.43q1-2.46,2-4.83c.5-1.17,1-2.32,1.52-3.45s1-2.29,1.58-3.4L95,173.09s0,0,0,0c.36-.71.72-1.41,1.08-2.09v0l.94-1.75c1.36-2.46,2.76-4.78,4.19-6.92.59-.87,1.19-1.72,1.79-2.53s1.22-1.61,1.83-2.36h0l.06-.08h0l0,0h0l.53-.64L106,156c.65-.72,1.29-1.39,1.94-2s1.29-1.22,1.94-1.77c.09.19.19.39.28.59,1.59,3.3,3.68,7.57,6.08,12.14q.38.73.78,1.47v0c2.39,4.51,5,9.25,7.76,13.58l.74,1.18h0l.26.41c3.36,5.2,6.76,9.67,9.85,12.29a128.53,128.53,0,0,0,2.73-14.19h0c.1-.7.2-1.43.3-2.18h0l.09-.68c0-.17.05-.34.07-.51s.05-.4.08-.61c.11-1,.23-2,.34-3a0,0,0,0,0,0,0c.16-1.45.32-3,.45-4.53v0l.06-.67c.14-1.61.26-3.29.36-5v0c0-.49.07-1,.09-1.5s.05-.9.07-1.35c.13.32.26.64.39,1h0c.52,1.32,1.05,2.76,1.59,4.3l.3.86c.2.59.41,1.19.61,1.81s.37,1.1.55,1.67l0,.11h0c.18.55.36,1.12.54,1.69h0c.27.86.54,1.74.81,2.63a.13.13,0,0,1,0,.06h0l.48,1.63c0,.05,0,.1.05.15l0,.09v0c1.19,4.07,2.39,8.48,3.58,13.09h0c.24,1,.49,1.9.72,2.86.3,1.17.6,2.34.88,3.52.13.53.27,1.07.4,1.6a0,0,0,0,0,0,0c.19.76.37,1.51.55,2.27h0c.3,1.21.59,2.43.87,3.65h0a2.59,2.59,0,0,0,.09.4c.36,1.53.71,3,1.05,4.57.18.77.35,1.53.53,2.3.3,1.32.59,2.63.88,3.94,0,.13.06.26.08.39.08.34.15.67.23,1q1.06,4.82,2,9.53C157.7,224.86,157.74,225,157.78,225.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,225.21h-1.45l-.09-1.77q-.33-6.24-.63-12.49-.15-3.07-.33-6.15c-.13-2.19-.15-4.38-.24-6.57a.06.06,0,0,1,.12,0c.31,2.17.66,4.31.89,6.5q.33,3,.62,6.11.63,6.31,1,12.66C139,224.06,139.08,224.64,139.11,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,225.21h-4.25a1.18,1.18,0,0,1-.06-.27,2.2,2.2,0,1,1,4.37-.59A2.06,2.06,0,0,1,134.1,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86,209.28a2.21,2.21,0,1,0,1.89-2.49A2.22,2.22,0,0,0,128.86,209.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.86,192.33v.4l-.45,19.53-.3,13H154.93c-1.2-1.34-2.25-3-2.13-4.76a12,12,0,0,1,2.59-6.29h0l.2-.23-.28-.14h0c-1.17-.62-5.55-3.18-5-6.62a9.15,9.15,0,0,1,2.41-4.59h0a9.49,9.49,0,0,1,1.13-1,7.72,7.72,0,0,1-2-2.61h0a5.58,5.58,0,0,1-.55-2.27,0,0,0,0,1,0,0,5.88,5.88,0,0,1,.38-2.29,6.24,6.24,0,0,1,1.75-2.38,20.69,20.69,0,0,1,4.85-3.1,48.51,48.51,0,0,1,7-2.71l.11,0a1.29,1.29,0,0,1,.26-.08l.36-.11c1.29-.38,2.56-.69,3.73-.93l.95-.2c.68-.13,1.32-.23,1.91-.31,6.13-.78,25.73,4.55,33.74,6.84l.21.06,1.58.46Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19,200.85c6.75-2.55,13.88-3,21-3.8a.13.13,0,0,1,0,.25c-7.07.74-13.89,2.87-20.92,3.88A.17.17,0,0,1,154.19,200.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.74,213.37a18.62,18.62,0,0,1,4.87-.66c1.74-.12,3.48-.2,5.22-.26,3.49-.11,7-.15,10.47-.08.15,0,.18.24,0,.25-3.47.12-6.94.29-10.41.56-1.73.13-3.47.28-5.2.44a22.46,22.46,0,0,1-4.91.22A.25.25,0,0,1,155.74,213.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,213c0,.27,0,.54,0,.8a10.83,10.83,0,0,1-.32,2.15.14.14,0,0,1,0,.06,9.89,9.89,0,0,1-.86,2.35,18.17,18.17,0,0,1-6.61,6.82H205l1.36-33.4,0-.47v0A95.44,95.44,0,0,1,230,200.1l.12.07.45.25a44.61,44.61,0,0,1,4.5,2.89l.1.07a20.53,20.53,0,0,1,5.23,5.34h0s0,0,0,0A8.52,8.52,0,0,1,241.78,213Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73,213c0,.2,0,.4,0,.6a11.43,11.43,0,0,1-.47,2.94l0,0v0a10.56,10.56,0,0,1-.66,1.69,18.24,18.24,0,0,1-6.64,6.88H205l1.36-33.41,0-.47h.05l.21,0,1.57.36.08,0,.35.09.45.12a100,100,0,0,1,18,6.65c.31.15.62.3.92.46.9.45,1.78.93,2.64,1.42h0c1.18.68,2.32,1.37,3.37,2.11l.06,0a21.77,21.77,0,0,1,6.37,6.22v0A8.48,8.48,0,0,1,241.73,213Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.86,213.48a5.15,5.15,0,0,1,0,.68,11.38,11.38,0,0,1-1.2,4.5,21.21,21.21,0,0,1-5.33,6.55H210.19c-.25-4-.53-8.54-.79-13-.56-9.16-1.06-17.79-1.19-20,0-.2,0-.35,0-.44a.82.82,0,0,1,0-.1l.08,0,.35.09.45.12a121.46,121.46,0,0,1,18,6.65c.31.15.62.3.92.46.67.32,1.34.67,2,1l.12.07.43.23c1.25.69,2.46,1.42,3.58,2.17l.18.13a21.44,21.44,0,0,1,6,5.58h0a9.47,9.47,0,0,1,1.25,2.61,6.23,6.23,0,0,1,.15.62h0a11,11,0,0,1,.2,1.58C241.86,213.23,241.86,213.35,241.86,213.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,220.86c0-.07,0-.14,0-.22,0-.3.07-.59.1-.89a3.32,3.32,0,0,1,.81-1.51,2.5,2.5,0,0,1,1.06-.73,2.57,2.57,0,0,1,1.28-.33,3.8,3.8,0,0,1,2.4.9,3.29,3.29,0,0,1,.91,1.46v0l.15.88v.07c0,.15,0,.3,0,.46s0,.3-.05.45v.07c-.1.27-.2.53-.31.8a.08.08,0,0,1,0,0,3.12,3.12,0,0,1-.26.37,2.45,2.45,0,0,1-.9.88l-.79.36a3.2,3.2,0,0,1-1.79,0,3.26,3.26,0,0,1-2-1.4c-.07-.13-.12-.27-.19-.41s0,0,0,0l-.07-.14-.07-.15v0a1.94,1.94,0,0,1-.19-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,225.21h-5.58a2.73,2.73,0,0,1,.34-.44,2.5,2.5,0,0,1,1.06-.73,2.47,2.47,0,0,1,1.28-.33,2.5,2.5,0,0,1,1.3.24,2.64,2.64,0,0,1,1.1.66A3.19,3.19,0,0,1,221.87,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19,203.42a44.38,44.38,0,0,0-7.76-4.91c-2.74-1.4-5.57-2.62-8.43-3.74s-5.79-2-8.74-2.91c-1.47-.43-3-.81-4.44-1.22l-4.45-1.14-8.91-2.22c-3-.72-5.94-1.49-9-2.11-1.5-.32-3-.62-4.53-.84a17.65,17.65,0,0,0-4.65-.19,72,72,0,0,0-9,2,84.73,84.73,0,0,1,9-1.49,17.9,17.9,0,0,1,4.49.33c1.5.28,3,.62,4.47,1,5.93,1.46,11.85,3,17.78,4.55l4.46,1.1c1.47.39,2.95.75,4.42,1.17,2.94.82,5.84,1.75,8.73,2.75s5.71,2.15,8.47,3.44A49.56,49.56,0,0,1,235.19,203.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.33,225.21h-99.7c-1.5-17.61-2.1-30.07-1-31a21.91,21.91,0,0,1,4.45-2.68c.56-.27,1.16-.56,1.8-.84h0c1.77-.8,3.78-1.63,5.92-2.43h0a66.31,66.31,0,0,1,16.28-4h0a21.49,21.49,0,0,1,3.49,0,11.65,11.65,0,0,1,1.37.17h0c.74.14,1.6.28,2.57.44h.13c8.92,1.42,26.81,3.84,41.79,9.46l1.44.56a63.43,63.43,0,0,1,11.33,5.68l.08,0,0,0C240.38,203.29,243.69,212.37,246.33,225.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,177.7c-7.65,15.86-16.65,32.47-25.3,47.51H61.89a6.54,6.54,0,0,0-6.54-6.54v-14l2-2.13C68,191.13,79,179.63,88.5,170.46l.08-.08c2.87-2.79,5.6-5.36,8.13-7.64a25.57,25.57,0,0,1,8.12-5.34h0c2.48-.89,4.48-.74,5.92.24a6.49,6.49,0,0,1,2.52,4.44h0C114,165.89,113,171.45,109.94,177.7Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,174.57c-2.66,8.61-13.83,29.81-25.37,50.64H61.89a6.54,6.54,0,0,0-6.54-6.54V203.74c16.21-16.87,32.84-33.92,39.84-40.24.73-.65,1.35-1.19,1.86-1.6s1.25-1,1.87-1.43l.35-.24.1-.06a22.48,22.48,0,0,1,4.59-2.51l.11,0c.28-.11.56-.21.83-.29h0a7.62,7.62,0,0,1,5.65,0,4.06,4.06,0,0,1,.92.58h0a3.36,3.36,0,0,1,.49.44l0,0a5.33,5.33,0,0,1,1.09,1.72h0a6.58,6.58,0,0,1,.44,1.34h0a10,10,0,0,1,.25,1.53h0C114.06,165.79,113.55,169.64,112,174.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,163.89a29.41,29.41,0,0,1-.83,7.61c-1.29,5.66-7.87,19.46-15.84,34.94-3.15,6.13-6.52,12.52-9.87,18.77H61.89a6.54,6.54,0,0,0-6.54-6.54V202.21c15.3-15.81,31.83-32.37,40.58-39.48,1.13-.92,2.13-1.68,3-2.26l.35-.24.1-.06a30.5,30.5,0,0,1,4.59-2.51l.11,0c.3-.13.59-.24.87-.34h0a8.68,8.68,0,0,1,5.3-.55,4.33,4.33,0,0,1,.74.27l.19.09h0a6.14,6.14,0,0,1,2.86,4.5,10,10,0,0,1,.16,1h0C114.27,163,114.3,163.44,114.32,163.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35,195.46c-2.73,5.68-5.62,11.3-8.57,16.88.7-.86,1.41-1.7,2.1-2.57,1.29-1.64,2.53-3.31,3.76-5a.15.15,0,0,1,.25.15,35.59,35.59,0,0,1-3.42,5.31,27.63,27.63,0,0,1-3.76,4.11q-1.78,3.36-3.58,6.71c-.75,1.38-1.5,2.77-2.26,4.15H87.08q4.35-8,8.87-15.89c.55-1,1.12-1.93,1.7-2.88.8-1.33,1.62-2.65,2.4-4,1.4-2.35,2.72-4.75,4.16-7.08A.08.08,0,0,1,104.35,195.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,165.68c-5.42,2.75-15.67-4.86-19.59-12-.26-.49.39-19.82.38-23.73,0-.8,24.52,5.87,24.52,5.87s-2.39,8.2-2.32,15a8.92,8.92,0,0,0,.17,1.6c0,.08,0,.17,0,.27C137.66,155.78,136.74,164.27,134,165.68Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134,165.68c-5.42,2.75-15.67-4.86-19.59-12-.26-.49.39-19.82.38-23.73,0-.8,24.52,5.87,24.52,5.87s-2.39,8.2-2.32,15a8.92,8.92,0,0,0,.17,1.6c0,.08,0,.17,0,.27C137.66,155.78,136.74,164.27,134,165.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.16,152.74a16.72,16.72,0,0,1-2.52.14c-12.86-.24-17.52-16-19-22.87,4.5.66,23.59,5.85,23.59,5.85s-2.39,8.2-2.32,15a8,8,0,0,0,.17,1.59C137.12,152.54,137.16,152.64,137.16,152.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,101.74c-2.49,8.73,2.56,33.74,8.84,39.22,9.1,7.94,23.78,8.45,30.47-2.44,6.49-10.56-.67-43-7.66-48C132.28,83.23,114.61,88.84,110.93,101.74Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.93,101.74c-2.49,8.73,2.56,33.74,8.84,39.22,9.1,7.94,23.78,8.45,30.47-2.44,6.49-10.56-.67-43-7.66-48C132.28,83.23,114.61,88.84,110.93,101.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,116.06c0-.06-.11.1-.1.17.39,1.68.55,3.66-.87,4.52,0,0,0,.11,0,.09C134.59,120.22,134.36,117.58,133.72,116.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.87,114.59c-2.75.33-1.89,5.81.66,5.51S134.18,114.32,131.87,114.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07,114.42c0-.07.14.06.15.13.21,1.7.74,3.62,2.37,3.94,0,0,.06.1,0,.1C143.67,118.62,143,116.07,143.07,114.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,112.41c2.69-.64,3.76,4.81,1.27,5.39S142,112.94,144.31,112.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,112a21.5,21.5,0,0,0,2.27,0,3.7,3.7,0,0,0,2.34-.39,1.18,1.18,0,0,0,.32-1.39,2.88,2.88,0,0,0-2.63-1.32,4.28,4.28,0,0,0-3,.85A1.26,1.26,0,0,0,129.53,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.94,109a21.68,21.68,0,0,1-2.12.83,3.63,3.63,0,0,1-2.32.43,1.17,1.17,0,0,1-.79-1.19,2.94,2.94,0,0,1,2-2.15,4.32,4.32,0,0,1,3.08-.21A1.26,1.26,0,0,1,146.94,109Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.48,131.7c.47.34,1,.82,1.59.78a4.59,4.59,0,0,0,1.76-.72.06.06,0,0,1,.08.08,2.31,2.31,0,0,1-2,1.26,1.84,1.84,0,0,1-1.57-1.3C134.29,131.71,134.42,131.65,134.48,131.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,127.75a7,7,0,0,1-2.53,2.45,3.18,3.18,0,0,1-1.87.33c-1.4-.21-1.58-1.46-1.44-2.56a7.36,7.36,0,0,1,.42-1.7A9,9,0,0,0,141,127.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42,130.2a3.18,3.18,0,0,1-1.87.33c-1.4-.21-1.58-1.46-1.44-2.56A3.22,3.22,0,0,1,138.42,130.2Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,128a3.72,3.72,0,0,1-1.54,2,3.32,3.32,0,0,0,.12-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.33,126.9a3.23,3.23,0,0,0,.45,2.61,5.07,5.07,0,0,1,.8-2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,126.34a5.85,5.85,0,0,0,4.26,2,7.48,7.48,0,0,0,2.1-.23,2.5,2.5,0,0,0,.39-.11,3,3,0,0,0,.36-.12.41.41,0,0,0,.28-.43h0a1,1,0,0,0,0-.17v0l0-.14c-.17-1.32-.61-3.28-.61-3.28.52.16,3.12.87,3,.2-1.22-5.6-2.58-11.83-5-17.14a.16.16,0,0,0-.31.09c1,5.43,2.88,10.65,3.93,16.09a9.7,9.7,0,0,0-2.86-.4c-.18.08.91,3.78.94,4.38a.09.09,0,0,1,0,.06c-2.15.63-3.91.22-6.27-.92C135.47,126.09,135.35,126.22,135.47,126.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.21,123.19c5.24-.82,6.45-7.43,6.85-12.16s1.26-11.94,7.73-13.93,12,5.48,12,5.48.85-7.86,4.18-7.47c2.54.3,4.71,3.68,5.59,6.07v0s-.79-13.42-6.67-15.92c-11.73-5-21.66,3-28.6,10,0,0-5,2.46-5.9,5.5C106.11,105.2,110.36,115,112.21,123.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,122.09s-6-7.89-9.58-5.73,1.11,13.75,5.49,15.2a4.4,4.4,0,0,0,5.8-2.59Z",
    style: {
      fill: "#ffc4c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,122.09s-6-7.89-9.58-5.73,1.11,13.75,5.49,15.2a4.4,4.4,0,0,0,5.8-2.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,119.65c-.07,0-.08.09,0,.12,3.08,1.1,4.78,3.85,6,6.72-.94-1.08-2.19-1.65-3.66-.52-.07.06,0,.18.09.16a2.68,2.68,0,0,1,3,.83,13.12,13.12,0,0,1,1.52,2.35c.15.26.64.1.52-.21l0-.07C115.89,125.17,112.68,119.88,108.52,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,152.66l-6,13.82-16.92-18.15-5.09,5.53s16.26,28.56,16.4,27.29l6.1-11.89,8.1,8.61-.1-21.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.34,167.46c-.13-3.48-.17-7-.46-10.45,0-.12-.21-.18-.24,0-.79,3.33-.21,16.62-.31,19.8l0,0c-.34-.38-7.52-7.59-7.6-7.48-1.3,1.88-5.78,10.54-6.09,11.33-2.57-4.54-13.52-22.44-16.59-26.74a.12.12,0,0,0-.21.11c2.25,4.78,16.38,28.39,16.59,28.33a133.06,133.06,0,0,0,6.38-12.57c1.21,1.57,8.44,9.68,8.48,9.16A111.53,111.53,0,0,0,140.34,167.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,170.25s-10.83-7.48-14.32-5,4,8.66,3.66,9.86-1.46,5.85,1.46,6.49,10.12-6.77,10.12-6.77Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,170.26l.92,4.6s-.53.56-1.36,1.31a8.66,8.66,0,0,1-3.64-2.84c-.73-1.38.5-3.23,1.69-4.59C128.92,169.6,129.87,170.26,129.87,170.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,169.33s5.26-10.71,8.66-9.58.06,9.47.76,10.44,3.08,4.94,1.19,6.54-9.69-2.79-9.69-2.79Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,169.34l.92,4.6s.58.33,1.45.75a8.39,8.39,0,0,0,1.65-3.91c.05-1.53-1.48-2.82-2.82-3.68C134.92,168.4,134.46,169.34,134.46,169.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,174.12c-.54.81-3.3.66-3.3.66s-2.49,1.2-3.3.66-1.51-4.87-1.12-5.57,2.76-.55,3.3-.66,2.71-1.13,3.31-.66S137,173.34,136.44,174.12Z",
    style: {
      fill: "#C18AFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--texts-2--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,293.93V278.36a1.44,1.44,0,0,1,1.45-1.46A1.46,1.46,0,0,1,78,278.36v6.33h6.84v-6.33a1.43,1.43,0,0,1,1.45-1.46,1.46,1.46,0,0,1,1.48,1.46v15.57a1.45,1.45,0,0,1-1.48,1.45,1.43,1.43,0,0,1-1.45-1.45V287.6H78v6.33a1.45,1.45,0,0,1-1.48,1.45A1.43,1.43,0,0,1,75,293.93Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,291H95l-1.29,3.43a1.49,1.49,0,0,1-1.38.92,1.38,1.38,0,0,1-.5-.08,1.5,1.5,0,0,1-.87-1.9l5.83-15.54a1.47,1.47,0,0,1,1.4-.93,1.44,1.44,0,0,1,1.4.93l5.84,15.54a1.5,1.5,0,0,1-.88,1.9,1.25,1.25,0,0,1-.5.08,1.41,1.41,0,0,1-1.34-.92Zm-1.08-2.91-2.14-5.67-2.14,5.67Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,293.93V278.36a1.45,1.45,0,0,1,1.45-1.46,1.48,1.48,0,0,1,1.48,1.46v14.09h7.15a1.47,1.47,0,0,1,0,2.93h-8.63A1.44,1.44,0,0,1,109.07,293.93Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,293.93V278.36a1.45,1.45,0,0,1,1.45-1.46,1.48,1.48,0,0,1,1.48,1.46v14.09H134a1.47,1.47,0,0,1,0,2.93h-8.63A1.44,1.44,0,0,1,123.93,293.93Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,279.2a9.69,9.69,0,0,1,0,13.36,8.65,8.65,0,0,1-6.31,2.82,8.92,8.92,0,0,1-6.46-2.82,9.83,9.83,0,0,1,0-13.36,8.8,8.8,0,0,1,6.46-2.82A8.54,8.54,0,0,1,152.3,279.2Zm-.34,6.68a6.81,6.81,0,0,0-1.8-4.62,5.65,5.65,0,0,0-4.17-1.87,5.72,5.72,0,0,0-4.27,1.87,6.72,6.72,0,0,0-1.8,4.62,6.57,6.57,0,0,0,1.8,4.59,5.75,5.75,0,0,0,4.27,1.9,5.68,5.68,0,0,0,4.17-1.9A6.66,6.66,0,0,0,152,285.88Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58,279.1l-6.47,15.39a.58.58,0,0,1-.13.23l0,0a.46.46,0,0,1-.13.16s0,0,0,.08a.59.59,0,0,0-.19.13h0a1,1,0,0,1-.24.16h0s0,0,0,0a.76.76,0,0,0-.21.06H176a1.06,1.06,0,0,1-.26,0,1,1,0,0,1-.24,0h-.08a.58.58,0,0,0-.19-.06s0,0,0,0a.72.72,0,0,1-.24-.16h0a1.3,1.3,0,0,0-.19-.13l0-.08-.11-.16s0,0,0,0a.54.54,0,0,1-.1-.23L171,286.3l-3.46,8.19a1.67,1.67,0,0,1-.11.23s0,0,0,0l-.16.16s0,0,0,.08a.58.58,0,0,0-.15.13H167c-.08.05-.16.13-.21.16h0a0,0,0,0,0,0,0,.35.35,0,0,0-.21.06h-.08a1,1,0,0,1-.24,0,1.14,1.14,0,0,1-.26,0h-.08a.58.58,0,0,0-.19-.06s0,0-.05,0a.84.84,0,0,1-.24-.16h0c-.08-.05-.11-.11-.19-.13a.16.16,0,0,1-.05-.08c0-.05-.08-.11-.13-.16v0c-.06-.05-.08-.15-.14-.23l-6.49-15.39a1.43,1.43,0,0,1,.79-1.88A1.42,1.42,0,0,1,161,278l5.17,12.22,3.41-8.1a1.44,1.44,0,0,1,1.37-.9,1.49,1.49,0,0,1,1.37.9l3.41,8.1L180.91,278a1.47,1.47,0,0,1,1.93-.77A1.43,1.43,0,0,1,183.58,279.1Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,293.93V278.36a1.43,1.43,0,0,1,1.45-1.46h8.63a1.47,1.47,0,0,1,1.45,1.46,1.48,1.48,0,0,1-1.45,1.48h-7.15v4.83h6.15a1.47,1.47,0,0,1,0,2.93h-6.15v4.85h7.15a1.47,1.47,0,0,1,0,2.93h-8.55c-.05,0-.05,0-.05,0l0,0A1.44,1.44,0,0,1,187.8,293.93Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.45,293.93V278.36a1.43,1.43,0,0,1,1.45-1.46h8.63a1.47,1.47,0,0,1,1.46,1.46,1.49,1.49,0,0,1-1.46,1.48h-7.15v4.83h6.15a1.47,1.47,0,0,1,0,2.93h-6.15v4.85h7.15a1.47,1.47,0,0,1,0,2.93H205s0,0,0,0l0,0A1.44,1.44,0,0,1,203.45,293.93Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,293.93a1.44,1.44,0,1,1-2.87,0V278.57a1.42,1.42,0,0,1,.58-1.22,1.45,1.45,0,0,1,2,.32l8.53,11.8V278.59a1.43,1.43,0,0,1,1.43-1.42,1.46,1.46,0,0,1,1.45,1.42v15.34a1.43,1.43,0,0,1-2.54.93,1.53,1.53,0,0,1-.13-.16L222,283Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,309.39a7.06,7.06,0,0,1,7.06-6.92,7.2,7.2,0,0,1,4.44,1.5,1.14,1.14,0,0,1,.19,1.54,1.12,1.12,0,0,1-1.54.21,4.78,4.78,0,0,0-3.09-1.06,5.06,5.06,0,0,0-3.46,1.39,4.67,4.67,0,0,0,0,6.69,5.1,5.1,0,0,0,3.46,1.38,4.77,4.77,0,0,0,3.09-1.06,1.18,1.18,0,0,1,1.54.21,1.13,1.13,0,0,1-.19,1.54,7.14,7.14,0,0,1-4.44,1.5A7,7,0,0,1,73.68,309.39Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33,304.53a7,7,0,0,1,0,9.73,6.27,6.27,0,0,1-4.59,2.05A6.47,6.47,0,0,1,90,314.26a7.15,7.15,0,0,1,0-9.73,6.4,6.4,0,0,1,4.71-2.06A6.2,6.2,0,0,1,99.33,304.53Zm-.25,4.86a5,5,0,0,0-1.3-3.36,4.15,4.15,0,0,0-3-1.37A4.19,4.19,0,0,0,91.62,306a5,5,0,0,0,0,6.71,4.13,4.13,0,0,0,6.16,0A4.94,4.94,0,0,0,99.08,309.39Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,313a1,1,0,0,1,1.4-.14,6.3,6.3,0,0,0,3.68,1.48,4.16,4.16,0,0,0,2.4-.71,1.72,1.72,0,0,0,.83-1.38,1.08,1.08,0,0,0-.18-.62,1.8,1.8,0,0,0-.57-.57,7.57,7.57,0,0,0-2.64-.91h0a10.13,10.13,0,0,1-2.48-.75,4.1,4.1,0,0,1-1.79-1.5,3,3,0,0,1-.44-1.57,3.56,3.56,0,0,1,1.54-2.81,5.71,5.71,0,0,1,3.33-1,7.5,7.5,0,0,1,4.19,1.54,1,1,0,0,1,.27,1.36,1,1,0,0,1-1.37.29,5.59,5.59,0,0,0-3.09-1.23,3.65,3.65,0,0,0-2.16.66,1.51,1.51,0,0,0-.73,1.21.87.87,0,0,0,.14.53,1.67,1.67,0,0,0,.52.5,6.47,6.47,0,0,0,2.4.85h0a11,11,0,0,1,2.65.81,4.43,4.43,0,0,1,1.92,1.59,3.14,3.14,0,0,1,.47,1.64,3.73,3.73,0,0,1-1.66,3,6,6,0,0,1-3.55,1.09,8.29,8.29,0,0,1-4.93-1.92A1,1,0,0,1,104.55,313Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,305h-3.06v10.27a1,1,0,0,1-1.05,1.05,1.05,1.05,0,0,1-1.06-1.05V305h-3a1.08,1.08,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1.05h8.21a1.05,1.05,0,0,1,1.06,1.05A1.08,1.08,0,0,1,125.74,305Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,316.31a5.55,5.55,0,0,1-5.56-5.55v-6.85a1,1,0,0,1,1.06-1.05,1.07,1.07,0,0,1,1.08,1.05v6.85a3.42,3.42,0,1,0,6.84,0v-6.85a1.06,1.06,0,0,1,1.08-1.05,1,1,0,0,1,1.06,1.05v6.85A5.56,5.56,0,0,1,135.55,316.31Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,303.91v11.35a1.08,1.08,0,0,1-1.08,1.05,1,1,0,0,1-1-1.05v-8.1L151.34,311a1,1,0,0,1-.87.44h0a1.08,1.08,0,0,1-.89-.44l-2.75-3.85v8.1a1.07,1.07,0,0,1-2.13,0V303.91a1.07,1.07,0,0,1,1.06-1.05h.05a1,1,0,0,1,.85.44l3.82,5.3,3.83-5.3a1,1,0,0,1,.87-.44h0A1.09,1.09,0,0,1,156.24,303.91Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,315.26V303.91a1,1,0,0,1,1.06-1.05h6.28a1.06,1.06,0,0,1,1.06,1.05,1.08,1.08,0,0,1-1.06,1.08h-5.21v3.52h4.48a1.08,1.08,0,0,1,1.06,1.06,1.07,1.07,0,0,1-1.06,1.07h-4.48v3.54h5.21a1.07,1.07,0,0,1,0,2.13h-6.23s0,0,0,0v0A1.05,1.05,0,0,1,159.94,315.26Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,311.08h-2.36v4.18a1.08,1.08,0,0,1-1.08,1.05,1.07,1.07,0,0,1-1.06-1.05V303.91a1.05,1.05,0,0,1,1.06-1.05h3.44a4.11,4.11,0,1,1,0,8.22ZM179.25,309h2.36a2,2,0,1,0,0-4h-2.36Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84,313.14h-4.67l-.94,2.5a1.09,1.09,0,0,1-1,.67,1.44,1.44,0,0,1-.37-.05,1.1,1.1,0,0,1-.63-1.39l4.25-11.32a1.08,1.08,0,0,1,1-.68,1.05,1.05,0,0,1,1,.68l4.25,11.32a1.09,1.09,0,0,1-.63,1.39,1.32,1.32,0,0,1-.37.05,1,1,0,0,1-1-.67Zm-.79-2.11-1.55-4.14L189.94,311Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,314.72a1,1,0,0,1-.67,1.34,1.64,1.64,0,0,1-.42.06h0a1.43,1.43,0,0,1-.75-.21,1.91,1.91,0,0,1-.62-.67,5.18,5.18,0,0,1-.4-2.31,1.67,1.67,0,0,0-.23-.83,2,2,0,0,0-.58-.56,3.94,3.94,0,0,0-1.07-.46h-2.27v4.18a1.07,1.07,0,0,1-1.08,1.05,1.05,1.05,0,0,1-1.06-1.05V303.91a1,1,0,0,1,1.06-1.05h3.44a4.11,4.11,0,0,1,2.62,7.28,2.85,2.85,0,0,1,.67.71,3.68,3.68,0,0,1,.63,2.08,4.6,4.6,0,0,0,.08,1.13A1,1,0,0,1,208.3,314.72ZM205.61,307a2,2,0,0,0-2-2h-2.36v4h2.36A2,2,0,0,0,205.61,307Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,305h-3.06v10.27a1,1,0,0,1-1.06,1.05,1.05,1.05,0,0,1-1.06-1.05V305h-3a1.07,1.07,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1.05h8.21a1,1,0,0,1,1,1.05A1.08,1.08,0,0,1,219.27,305Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,304.66l-3.94,5.41v5.19a1,1,0,0,1-1.06,1.05,1.06,1.06,0,0,1-1.05-1.05v-5.19l-3.91-5.41a1,1,0,0,1,.22-1.46,1,1,0,0,1,1.46.23l3.28,4.5,3.29-4.5a1.05,1.05,0,0,1,1.71,1.23Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,384v5.33l2.85,1.08a1.23,1.23,0,0,1,.77,1.14,1.1,1.1,0,0,1-.07.41,1.24,1.24,0,0,1-1.58.73l-12.92-4.85a1.21,1.21,0,0,1-.76-1.16,1.18,1.18,0,0,1,.76-1.16l12.92-4.85a1.25,1.25,0,0,1,1.58.72,1.06,1.06,0,0,1,.07.42,1.19,1.19,0,0,1-.77,1.12Zm-2.41.9-4.72,1.78,4.72,1.77Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,377.65H377.23a1.2,1.2,0,0,1-1.21-1.21v-2.58a7.68,7.68,0,0,1,15.36,0v2.58A1.21,1.21,0,0,1,390.17,377.65Zm-1.23-2.43v-1.36a5.24,5.24,0,0,0-10.48,0v1.36Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,348.67h12.94a1.24,1.24,0,0,1,1.21,1.23,1.21,1.21,0,0,1-1.21,1.21h-9.23l4.39,3.16a1.21,1.21,0,0,1,.5,1v.05a1.28,1.28,0,0,1-.5,1l-4.39,3.13h9.23a1.22,1.22,0,0,1,0,2.44H377.23a1.22,1.22,0,0,1-1.21-1.21v-.06a1.19,1.19,0,0,1,.51-1l6.05-4.37-6.05-4.36a1.2,1.2,0,0,1-.51-1v0A1.26,1.26,0,0,1,377.23,348.67Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,343.21A1.2,1.2,0,0,1,376,342a1.22,1.22,0,0,1,1.21-1.23h12.94a1.22,1.22,0,0,1,1.21,1.23,1.2,1.2,0,0,1-1.21,1.21Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46,327.28v3.49h11.71a1.21,1.21,0,1,1,0,2.41H378.46v3.47a1.22,1.22,0,0,1-1.23,1.2,1.19,1.19,0,0,1-1.21-1.2v-9.37a1.2,1.2,0,0,1,1.21-1.2A1.23,1.23,0,0,1,378.46,327.28Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,303.76a8.07,8.07,0,0,1,11.1,0,7.19,7.19,0,0,1,2.35,5.25,7.39,7.39,0,0,1-2.35,5.37,8.18,8.18,0,0,1-11.1,0,7.31,7.31,0,0,1-2.34-5.37A7.11,7.11,0,0,1,377.93,303.76Zm5.55.29a5.69,5.69,0,0,0-3.84,1.49,4.75,4.75,0,0,0,0,7,5.6,5.6,0,0,0,3.84,1.49,5.5,5.5,0,0,0,3.82-1.49,4.69,4.69,0,0,0,0-7A5.59,5.59,0,0,0,383.48,304.05Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,295.38a1.22,1.22,0,0,1,1.21,1.19,1.2,1.2,0,0,1-1.21,1.2H377.41a1.15,1.15,0,0,1-1-.48,1.2,1.2,0,0,1,.26-1.67l9.81-7.08h-9a1.2,1.2,0,0,1-1.19-1.19,1.21,1.21,0,0,1,1.19-1.2h12.74a1.22,1.22,0,0,1,1.21,1.2,1.19,1.19,0,0,1-.44.9.42.42,0,0,1-.13.11l-9.74,7Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,282.31H377.23A1.2,1.2,0,0,1,376,281.1v-7.17a1.22,1.22,0,0,1,1.21-1.21,1.24,1.24,0,0,1,1.23,1.21v5.94h4v-5.11a1.22,1.22,0,0,1,2.44,0v5.11h4v-5.94a1.22,1.22,0,0,1,2.44,0V281c0,.05,0,.05,0,.05l0,0A1.21,1.21,0,0,1,390.17,282.31Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,389.81v2.64a.3.3,0,0,1-.31.3.29.29,0,0,1-.3-.3v-5.87a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.63h7.84a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,383.89a.3.3,0,0,1-.3-.3.31.31,0,0,1,.3-.32h8.15a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,376a4.68,4.68,0,0,1,1-2.82.31.31,0,0,1,.44-.05.29.29,0,0,1,.07.42,4,4,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.42.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0A4.61,4.61,0,0,1,410,376a4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,370.52a.31.31,0,0,1-.31-.3.31.31,0,0,1,.31-.32h5.07l-5.29-5.29a.31.31,0,0,1,0-.42.3.3,0,0,1,.44,0l3.35,3.35,4.35-3.43a.34.34,0,0,1,.44.05.31.31,0,0,1,.06.2.25.25,0,0,1-.11.23l-4.3,3.39,1.92,1.92h2.19a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,361.57a.29.29,0,0,1-.3-.3v-4.5a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3V361h3.46V357.3a.31.31,0,0,1,.32-.3.3.3,0,0,1,.3.3V361h3.45v-4.19a.31.31,0,0,1,.61,0v4.53a.3.3,0,0,1-.3.27Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,351.89v2.64a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3v-5.88a.3.3,0,0,1,.3-.3.31.31,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,0,.6Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.53,341.66h7.17a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3h-8a.3.3,0,0,1-.26-.53l7.35-5.31h-7.13a.31.31,0,0,1,0-.61h8.07a.31.31,0,0,1,.3.31.3.3,0,0,1-.11.24l-.05.05Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,330.18a3.07,3.07,0,1,1,3.07,2.9A3,3,0,0,1,403.87,330.18Zm5.53,0a2.48,2.48,0,1,0-2.46,2.3A2.4,2.4,0,0,0,409.4,330.18Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,324.74a.63.63,0,0,1,.63-.63.63.63,0,0,1,0,1.26A.63.63,0,0,1,408.75,324.74Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,389.66a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,387.38Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,384.54a5.53,5.53,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.7,5.7,0,0,1,3.06-.85,5.64,5.64,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.47,5.47,0,0,1,418.05,384.54Zm0-.62a4.93,4.93,0,0,0,2.71-.73,2.1,2.1,0,0,0,1.06-1.68,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2.05,2.05,0,0,0,1.06,1.68A4.93,4.93,0,0,0,418.05,383.92Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,374.82a3.54,3.54,0,0,1-1.91-3.07.31.31,0,0,1,.29-.31.34.34,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.78,5.78,0,0,0,1.75.63,2.88,2.88,0,1,1,2,.72,3.69,3.69,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,374.82Zm4,.21.16,0h.09a2.35,2.35,0,1,0-.3,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,367.76l-3.69-4.09a2.3,2.3,0,0,0-1.68-.75,2.27,2.27,0,0,0-1.66,3.78l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.43a2.92,2.92,0,0,1-.74-1.93,2.88,2.88,0,0,1,2.85-2.86,2.89,2.89,0,0,1,2.13.94l3.17,3.5v-4.14a.3.3,0,0,1,.31-.3.31.31,0,0,1,.3.3v4.93a.3.3,0,0,1-.09.23A.33.33,0,0,1,421.89,367.76Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,359l.73,1.24a.33.33,0,0,1,0,.15.32.32,0,0,1-.15.26.29.29,0,0,1-.42-.11l-1-1.69a.32.32,0,0,1,.11-.42.34.34,0,0,1,.22,0h8.05a.29.29,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.22,350.89l2.33,2.27a2.87,2.87,0,0,1,.8-1.5,2.94,2.94,0,0,1,2.1-.87,2.91,2.91,0,0,1,2.1.88,3,3,0,0,1,.88,2.1,2.92,2.92,0,0,1-.88,2.09.31.31,0,0,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.26,2.26,0,0,0-1.65.69,2.3,2.3,0,0,0-.69,1.65.35.35,0,0,1-.12.25h0a.33.33,0,0,1-.45,0l-2.24-2.18v3.36a.32.32,0,0,1-.63,0v-4.09a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0A.24.24,0,0,1,414.22,350.89Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,348.57l-3.69-4.09a2.24,2.24,0,0,0-3.18-.17,2.27,2.27,0,0,0-.16,3.19l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.42a2.92,2.92,0,0,1-.74-1.94,2.88,2.88,0,0,1,2.85-2.85,2.88,2.88,0,0,1,2.13.93l3.17,3.51v-4.14a.3.3,0,0,1,.31-.3.3.3,0,0,1,.3.3v4.92a.3.3,0,0,1-.09.23A.34.34,0,0,1,421.89,348.57Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.57,341a.31.31,0,0,1-.44,0,.31.31,0,0,1,0-.45,2.36,2.36,0,0,0,.67-1.65,2.34,2.34,0,0,0-2.34-2.34,2.33,2.33,0,0,0-1.65,4,.29.29,0,0,1,0,.43.16.16,0,0,1-.1.08h-.21l-3.53-.42a.25.25,0,0,1-.22-.13.28.28,0,0,1-.08-.2v-4.08a.31.31,0,0,1,.31-.31.31.31,0,0,1,.32.31v3.82l2.6.31a3,3,0,0,1-.4-1.49,2.89,2.89,0,0,1,.86-2.09,2.93,2.93,0,0,1,2.1-.86,3,3,0,0,1,2.11.86,3.06,3.06,0,0,1,.86,2.11A3,3,0,0,1,421.57,341Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,332.64a3.54,3.54,0,0,1-1.91-3.06.31.31,0,0,1,.29-.31.33.33,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.51,5.51,0,0,0,1.75.62,2.87,2.87,0,1,1,2,.73,5.52,5.52,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,332.64Zm4,.22a.76.76,0,0,0,.16,0h.09a2.28,2.28,0,1,0-.3,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,309.68a4.45,4.45,0,1,1,4.44,4.23A4.31,4.31,0,0,1,401.12,309.68Zm8.27,0a3.83,3.83,0,0,0-7.64,0,3.83,3.83,0,0,0,7.64,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,299.1a4.68,4.68,0,0,1,1-2.83.31.31,0,0,1,.44,0,.3.3,0,0,1,.07.43,3.94,3.94,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.43.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0,4.61,4.61,0,0,1,.95,2.83,4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,291.36V294a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3v-5.88a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.8,277.08l2.32,2.27a3,3,0,0,1,.8-1.5A3,3,0,0,1,407,277a2.93,2.93,0,0,1,2.1.88A3,3,0,0,1,410,280a2.94,2.94,0,0,1-.87,2.09.31.31,0,1,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.34,2.34,0,0,0-2.34,2.34.31.31,0,0,1-.13.25h0a.31.31,0,0,1-.45,0L401.87,278v3.35a.31.31,0,0,1-.31.31.31.31,0,0,1-.31-.31V277.3a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,273.32l.73,1.24a.27.27,0,0,1,.05.15.3.3,0,0,1-.15.26.28.28,0,0,1-.41-.11l-1-1.69a.32.32,0,0,1,.11-.41.38.38,0,0,1,.23,0h8a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,311.1a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,308.82Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,305.08a.63.63,0,0,1,.63-.63.62.62,0,0,1,.62.63.61.61,0,0,1-.62.62A.62.62,0,0,1,415.92,305.08Zm5.26,0a.62.62,0,0,1,.62-.63.63.63,0,0,1,.63.63.62.62,0,0,1-.63.62A.61.61,0,0,1,421.18,305.08Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,303a5.61,5.61,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.55,5.55,0,0,1,418.05,303Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,302.36Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,294.1a5.53,5.53,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.47,5.47,0,0,1,418.05,294.1Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,293.48Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,284.94a.25.25,0,0,1-.25-.25v-2.06a2.09,2.09,0,0,1,4.17,0l0,1.8h2.87a.26.26,0,0,1,.25.26.25.25,0,0,1-.25.25Zm3.43-2.31a1.61,1.61,0,0,0-1.59-1.58,1.58,1.58,0,0,0-1.58,1.58v1.8h3.17Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17,273.22l3.24,2.34a.26.26,0,0,1,.12.21v0a.25.25,0,0,1-.12.22l-3.23,2.34h6a.25.25,0,0,1,.25.25.26.26,0,0,1-.25.26h-6.77a.24.24,0,0,1-.2-.11l0,0a.26.26,0,0,1,.07-.35l3.6-2.6-3.6-2.59a.26.26,0,0,1-.07-.35l.09-.08a.33.33,0,0,1,.13,0h6.77a.26.26,0,0,1,.25.25.25.25,0,0,1-.25.25Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.12,
    y: 319.39,
    width: 21.31,
    height: 0.95,
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,344.36a6.13,6.13,0,0,1,0,8.43,5.46,5.46,0,0,1-4,1.78,5.63,5.63,0,0,1-4.08-1.78,6.21,6.21,0,0,1,0-8.43,5.56,5.56,0,0,1,4.08-1.78A5.39,5.39,0,0,1,83.39,344.36Zm-.22,4.22A4.32,4.32,0,0,0,82,345.66a3.58,3.58,0,0,0-2.63-1.18,3.62,3.62,0,0,0-2.7,1.18,4.23,4.23,0,0,0-1.13,2.92,4.13,4.13,0,0,0,1.13,2.89,3.56,3.56,0,0,0,5.33,0A4.23,4.23,0,0,0,83.17,348.58Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,348.58a6.11,6.11,0,0,1,6.11-6,6.23,6.23,0,0,1,3.85,1.3,1,1,0,0,1-1.17,1.52,4.15,4.15,0,0,0-2.68-.92,4.42,4.42,0,0,0-3,1.2,4.09,4.09,0,0,0-1.22,2.9,4,4,0,0,0,1.22,2.89,4.37,4.37,0,0,0,3,1.2,4.18,4.18,0,0,0,2.68-.91,1,1,0,0,1,1.33.18,1,1,0,0,1-.16,1.33,6.23,6.23,0,0,1-3.85,1.3A6.08,6.08,0,0,1,87.34,348.58Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,344.76h-2.65v8.9a.9.9,0,0,1-.92.91.91.91,0,0,1-.91-.91v-8.9h-2.63a.93.93,0,0,1-.92-.93.91.91,0,0,1,.92-.92h7.11a.91.91,0,0,1,.91.92A.93.93,0,0,1,107.82,344.76Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.65,369.64a10.64,10.64,0,0,1,3.18,7.61A10.79,10.79,0,0,1,74.4,384.9a2.46,2.46,0,1,1,3.48-3.48,5.77,5.77,0,0,0,4.12,1.7,6,6,0,0,0,4.18-1.7,5.82,5.82,0,0,0,1.73-4.17,5.66,5.66,0,0,0-1.73-4.13,5.88,5.88,0,0,0-4.13-1.74,2.12,2.12,0,0,1-1.78-.78s0,0,0,0a2.46,2.46,0,0,1-.08-3.48l4.43-4.52h-7a2.46,2.46,0,0,1,0-4.91H90.35a2.44,2.44,0,0,1,2.48,2.43,2.55,2.55,0,0,1-.31,1.18,3.26,3.26,0,0,1-.43.6l-5.48,5.65A10.06,10.06,0,0,1,89.65,369.64Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.73,360.08v25.64a2.41,2.41,0,0,1-2.43,2.39,2.35,2.35,0,0,1-2.39-2.39V364.34l-1.74,1a2.16,2.16,0,0,1-1.21.35,2.34,2.34,0,0,1-2-1.22,2.32,2.32,0,0,1,.78-3.26L105,358s.13,0,.17-.09.14-.08.22-.13.18,0,.26,0a.3.3,0,0,1,.18,0,.61.61,0,0,1,.3-.05h.48c0,.05.13.05.17.05a.47.47,0,0,1,.26.08.25.25,0,0,1,.18.05c.13.08.17.13.26.13a.92.92,0,0,0,.17.13,2,2,0,0,1,.18.13c.08,0,.13.13.17.17a.56.56,0,0,1,.13.18l.17.17,0,.09s0,.08,0,.13.09.13.09.21,0,.18.08.22a1.88,1.88,0,0,0,.05.22.37.37,0,0,0,.08.3Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,344a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,344Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,349.4a1.12,1.12,0,1,1-1.11-1.12A1.12,1.12,0,0,1,117.5,349.4Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,354.77a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,354.77Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,360.14a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,360.14Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,365.51a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,365.51Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,370.89a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,370.89Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,376.26a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,376.26Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,381.63a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,381.63Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,387a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,387Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,375.79v-9.72a.9.9,0,0,1,.91-.91.92.92,0,0,1,.92.91v8.8h4.47a.92.92,0,0,1,0,1.83h-5.39A.9.9,0,0,1,122.26,375.79Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,366.07a.89.89,0,0,1,.91-.91.92.92,0,0,1,.92.91v9.72a.92.92,0,0,1-.92.91.9.9,0,0,1-.91-.91Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,376.53l-.11-.08s0,0,0-.05a.39.39,0,0,1-.08-.1h0a.35.35,0,0,0-.08-.13l-4-9.63a.9.9,0,0,1,1.67-.69l3.21,7.63,3.22-7.63a.89.89,0,0,1,1.18-.48.91.91,0,0,1,.5,1.17l-4.08,9.63a.49.49,0,0,1-.06.13h0s-.06.07-.08.1l0,.05-.1.08,0,0a.64.64,0,0,1-.14.08l0,0a.61.61,0,0,0-.13,0h0a.56.56,0,0,1-.17,0,.44.44,0,0,1-.16,0h0l-.13,0a0,0,0,0,0,0,0h0l-.15-.1Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53,375.79v-9.72a.89.89,0,0,1,.9-.91h5.4a.91.91,0,0,1,.9.91.93.93,0,0,1-.9.92h-4.47v3h3.84a.92.92,0,0,1,0,1.83h-3.84v3h4.47a.92.92,0,0,1,0,1.83h-5.35s0,0,0,0l0,0A.9.9,0,0,1,148.53,375.79Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,347.22a4,4,0,0,1,8-.41s0,0,0,0c0,.31,0,.63,0,.94a9.68,9.68,0,0,1-.57,3.38A5.74,5.74,0,0,1,127,354a4.69,4.69,0,0,1-2.47.77.92.92,0,0,1-1-.87,1,1,0,0,1,.89-1,2.9,2.9,0,0,0,1.55-.46,3.42,3.42,0,0,0,1-1.15,2.86,2.86,0,0,0,.21-.43,3.92,3.92,0,0,1-1.58.33A4,4,0,0,1,121.71,347.22Zm1.83,0a2.17,2.17,0,1,0,4.33,0,2.17,2.17,0,0,0-4.33,0Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,345.87a1.24,1.24,0,0,1,1.24,1.23,1.23,1.23,0,0,1-1.24,1.22,1.21,1.21,0,0,1-1.22-1.22A1.23,1.23,0,0,1,133.86,345.87Zm0,6.56a1.23,1.23,0,1,1,0,2.46,1.23,1.23,0,0,1,0-2.46Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.23,349a7.06,7.06,0,0,1,1.13-3.94,3.47,3.47,0,0,1,6.11,0,7.55,7.55,0,0,1,0,7.88,3.47,3.47,0,0,1-6.11,0A7.08,7.08,0,0,1,136.23,349Zm6.52,0a5.38,5.38,0,0,0-.8-2.93,1.88,1.88,0,0,0-1.53-1,2,2,0,0,0-1.56,1,5.75,5.75,0,0,0,0,5.85,2,2,0,0,0,1.56,1,1.92,1.92,0,0,0,1.53-1A5.34,5.34,0,0,0,142.75,349Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,349a7.13,7.13,0,0,1,1.12-3.94,3.47,3.47,0,0,1,6.12,0,7.61,7.61,0,0,1,0,7.88,3.47,3.47,0,0,1-6.12,0A7.16,7.16,0,0,1,147.94,349Zm6.51,0a5.46,5.46,0,0,0-.79-2.93,1.88,1.88,0,0,0-1.53-1,2,2,0,0,0-1.57,1,5.81,5.81,0,0,0,0,5.85,2,2,0,0,0,1.57,1,1.92,1.92,0,0,0,1.53-1A5.43,5.43,0,0,0,154.45,349Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,381.21v6.28a.6.6,0,0,1-.6.58.58.58,0,0,1-.58-.58V383l-1.53,2.13a.61.61,0,0,1-.48.24h0a.6.6,0,0,1-.49-.24L123.06,383v4.48a.6.6,0,0,1-1.19,0v-6.28a.6.6,0,0,1,.59-.59h0a.59.59,0,0,1,.47.25l2.12,2.94,2.11-2.94a.59.59,0,0,1,.48-.25h0A.62.62,0,0,1,128.28,381.21Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,388.07a3.06,3.06,0,0,1-3.07-3.07v-3.79a.58.58,0,0,1,.58-.59.6.6,0,0,1,.6.59V385a1.89,1.89,0,1,0,3.78,0v-3.79a.59.59,0,0,1,.6-.59.58.58,0,0,1,.58.59V385A3.07,3.07,0,0,1,133.94,388.07Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28,386.22a.55.55,0,0,1,.78-.07,3.43,3.43,0,0,0,2,.81,2.33,2.33,0,0,0,1.33-.39,1,1,0,0,0,.46-.76.55.55,0,0,0-.1-.34.88.88,0,0,0-.32-.32,4,4,0,0,0-1.45-.5h0a6.1,6.1,0,0,1-1.37-.42,2.36,2.36,0,0,1-1-.83,1.6,1.6,0,0,1-.24-.87,2,2,0,0,1,.85-1.55,3.09,3.09,0,0,1,1.84-.57,4.17,4.17,0,0,1,2.32.85.56.56,0,0,1,.15.76.55.55,0,0,1-.76.16,3.08,3.08,0,0,0-1.71-.68,2.05,2.05,0,0,0-1.19.36.85.85,0,0,0-.41.67.56.56,0,0,0,.08.3,1,1,0,0,0,.29.27,3.49,3.49,0,0,0,1.33.47h0a6.42,6.42,0,0,1,1.46.45,2.51,2.51,0,0,1,1.07.88,1.75,1.75,0,0,1,.25.91,2,2,0,0,1-.91,1.64,3.27,3.27,0,0,1-2,.61,4.54,4.54,0,0,1-2.72-1.06A.57.57,0,0,1,139.28,386.22Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,381.21a.58.58,0,0,1,.58-.59.6.6,0,0,1,.6.59v6.28a.59.59,0,0,1-.6.58.57.57,0,0,1-.58-.58Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,384.24a3.91,3.91,0,0,1,3.9-3.83,4,4,0,0,1,2.46.83.61.61,0,0,1-.74,1,2.7,2.7,0,0,0-1.72-.59,2.81,2.81,0,0,0-1.91.77,2.63,2.63,0,0,0-.78,1.85,2.57,2.57,0,0,0,.78,1.85,2.81,2.81,0,0,0,1.91.77,2.66,2.66,0,0,0,1.72-.59.65.65,0,0,1,.85.12.62.62,0,0,1-.11.85,4,4,0,0,1-2.46.83A3.89,3.89,0,0,1,149.53,384.24Z",
    style: {
      fill: "#C18AFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,293.93V278.36a1.44,1.44,0,0,1,1.45-1.46A1.46,1.46,0,0,1,78,278.36v6.33h6.84v-6.33a1.43,1.43,0,0,1,1.45-1.46,1.46,1.46,0,0,1,1.48,1.46v15.57a1.45,1.45,0,0,1-1.48,1.45,1.43,1.43,0,0,1-1.45-1.45V287.6H78v6.33a1.45,1.45,0,0,1-1.48,1.45A1.43,1.43,0,0,1,75,293.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,291H95l-1.29,3.43a1.49,1.49,0,0,1-1.38.92,1.38,1.38,0,0,1-.5-.08,1.5,1.5,0,0,1-.87-1.9l5.83-15.54a1.47,1.47,0,0,1,1.4-.93,1.44,1.44,0,0,1,1.4.93l5.84,15.54a1.5,1.5,0,0,1-.88,1.9,1.25,1.25,0,0,1-.5.08,1.41,1.41,0,0,1-1.34-.92Zm-1.08-2.91-2.14-5.67-2.14,5.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,293.93V278.36a1.45,1.45,0,0,1,1.45-1.46,1.48,1.48,0,0,1,1.48,1.46v14.09h7.15a1.47,1.47,0,0,1,0,2.93h-8.63A1.44,1.44,0,0,1,109.07,293.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,293.93V278.36a1.45,1.45,0,0,1,1.45-1.46,1.48,1.48,0,0,1,1.48,1.46v14.09H134a1.47,1.47,0,0,1,0,2.93h-8.63A1.44,1.44,0,0,1,123.93,293.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,279.2a9.69,9.69,0,0,1,0,13.36,8.65,8.65,0,0,1-6.31,2.82,8.92,8.92,0,0,1-6.46-2.82,9.83,9.83,0,0,1,0-13.36,8.8,8.8,0,0,1,6.46-2.82A8.54,8.54,0,0,1,152.3,279.2Zm-.34,6.68a6.81,6.81,0,0,0-1.8-4.62,5.65,5.65,0,0,0-4.17-1.87,5.72,5.72,0,0,0-4.27,1.87,6.72,6.72,0,0,0-1.8,4.62,6.57,6.57,0,0,0,1.8,4.59,5.75,5.75,0,0,0,4.27,1.9,5.68,5.68,0,0,0,4.17-1.9A6.66,6.66,0,0,0,152,285.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58,279.1l-6.47,15.39a.58.58,0,0,1-.13.23l0,0a.46.46,0,0,1-.13.16s0,0,0,.08a.59.59,0,0,0-.19.13h0a1,1,0,0,1-.24.16h0s0,0,0,0a.76.76,0,0,0-.21.06H176a1.06,1.06,0,0,1-.26,0,1,1,0,0,1-.24,0h-.08a.58.58,0,0,0-.19-.06s0,0,0,0a.72.72,0,0,1-.24-.16h0a1.3,1.3,0,0,0-.19-.13l0-.08-.11-.16s0,0,0,0a.54.54,0,0,1-.1-.23L171,286.3l-3.46,8.19a1.67,1.67,0,0,1-.11.23s0,0,0,0l-.16.16s0,0,0,.08a.58.58,0,0,0-.15.13H167c-.08.05-.16.13-.21.16h0a0,0,0,0,0,0,0,.35.35,0,0,0-.21.06h-.08a1,1,0,0,1-.24,0,1.14,1.14,0,0,1-.26,0h-.08a.58.58,0,0,0-.19-.06s0,0-.05,0a.84.84,0,0,1-.24-.16h0c-.08-.05-.11-.11-.19-.13a.16.16,0,0,1-.05-.08c0-.05-.08-.11-.13-.16v0c-.06-.05-.08-.15-.14-.23l-6.49-15.39a1.43,1.43,0,0,1,.79-1.88A1.42,1.42,0,0,1,161,278l5.17,12.22,3.41-8.1a1.44,1.44,0,0,1,1.37-.9,1.49,1.49,0,0,1,1.37.9l3.41,8.1L180.91,278a1.47,1.47,0,0,1,1.93-.77A1.43,1.43,0,0,1,183.58,279.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,293.93V278.36a1.43,1.43,0,0,1,1.45-1.46h8.63a1.47,1.47,0,0,1,1.45,1.46,1.48,1.48,0,0,1-1.45,1.48h-7.15v4.83h6.15a1.47,1.47,0,0,1,0,2.93h-6.15v4.85h7.15a1.47,1.47,0,0,1,0,2.93h-8.55c-.05,0-.05,0-.05,0l0,0A1.44,1.44,0,0,1,187.8,293.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.45,293.93V278.36a1.43,1.43,0,0,1,1.45-1.46h8.63a1.47,1.47,0,0,1,1.46,1.46,1.49,1.49,0,0,1-1.46,1.48h-7.15v4.83h6.15a1.47,1.47,0,0,1,0,2.93h-6.15v4.85h7.15a1.47,1.47,0,0,1,0,2.93H205s0,0,0,0l0,0A1.44,1.44,0,0,1,203.45,293.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,293.93a1.44,1.44,0,1,1-2.87,0V278.57a1.42,1.42,0,0,1,.58-1.22,1.45,1.45,0,0,1,2,.32l8.53,11.8V278.59a1.43,1.43,0,0,1,1.43-1.42,1.46,1.46,0,0,1,1.45,1.42v15.34a1.43,1.43,0,0,1-2.54.93,1.53,1.53,0,0,1-.13-.16L222,283Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.68,309.39a7.06,7.06,0,0,1,7.06-6.92,7.2,7.2,0,0,1,4.44,1.5,1.14,1.14,0,0,1,.19,1.54,1.12,1.12,0,0,1-1.54.21,4.78,4.78,0,0,0-3.09-1.06,5.06,5.06,0,0,0-3.46,1.39,4.67,4.67,0,0,0,0,6.69,5.1,5.1,0,0,0,3.46,1.38,4.77,4.77,0,0,0,3.09-1.06,1.18,1.18,0,0,1,1.54.21,1.13,1.13,0,0,1-.19,1.54,7.14,7.14,0,0,1-4.44,1.5A7,7,0,0,1,73.68,309.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33,304.53a7,7,0,0,1,0,9.73,6.27,6.27,0,0,1-4.59,2.05A6.47,6.47,0,0,1,90,314.26a7.15,7.15,0,0,1,0-9.73,6.4,6.4,0,0,1,4.71-2.06A6.2,6.2,0,0,1,99.33,304.53Zm-.25,4.86a5,5,0,0,0-1.3-3.36,4.15,4.15,0,0,0-3-1.37A4.19,4.19,0,0,0,91.62,306a5,5,0,0,0,0,6.71,4.13,4.13,0,0,0,6.16,0A4.94,4.94,0,0,0,99.08,309.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,313a1,1,0,0,1,1.4-.14,6.3,6.3,0,0,0,3.68,1.48,4.16,4.16,0,0,0,2.4-.71,1.72,1.72,0,0,0,.83-1.38,1.08,1.08,0,0,0-.18-.62,1.8,1.8,0,0,0-.57-.57,7.57,7.57,0,0,0-2.64-.91h0a10.13,10.13,0,0,1-2.48-.75,4.1,4.1,0,0,1-1.79-1.5,3,3,0,0,1-.44-1.57,3.56,3.56,0,0,1,1.54-2.81,5.71,5.71,0,0,1,3.33-1,7.5,7.5,0,0,1,4.19,1.54,1,1,0,0,1,.27,1.36,1,1,0,0,1-1.37.29,5.59,5.59,0,0,0-3.09-1.23,3.65,3.65,0,0,0-2.16.66,1.51,1.51,0,0,0-.73,1.21.87.87,0,0,0,.14.53,1.67,1.67,0,0,0,.52.5,6.47,6.47,0,0,0,2.4.85h0a11,11,0,0,1,2.65.81,4.43,4.43,0,0,1,1.92,1.59,3.14,3.14,0,0,1,.47,1.64,3.73,3.73,0,0,1-1.66,3,6,6,0,0,1-3.55,1.09,8.29,8.29,0,0,1-4.93-1.92A1,1,0,0,1,104.55,313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.74,305h-3.06v10.27a1,1,0,0,1-1.05,1.05,1.05,1.05,0,0,1-1.06-1.05V305h-3a1.08,1.08,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1.05h8.21a1.05,1.05,0,0,1,1.06,1.05A1.08,1.08,0,0,1,125.74,305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,316.31a5.55,5.55,0,0,1-5.56-5.55v-6.85a1,1,0,0,1,1.06-1.05,1.07,1.07,0,0,1,1.08,1.05v6.85a3.42,3.42,0,1,0,6.84,0v-6.85a1.06,1.06,0,0,1,1.08-1.05,1,1,0,0,1,1.06,1.05v6.85A5.56,5.56,0,0,1,135.55,316.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,303.91v11.35a1.08,1.08,0,0,1-1.08,1.05,1,1,0,0,1-1-1.05v-8.1L151.34,311a1,1,0,0,1-.87.44h0a1.08,1.08,0,0,1-.89-.44l-2.75-3.85v8.1a1.07,1.07,0,0,1-2.13,0V303.91a1.07,1.07,0,0,1,1.06-1.05h.05a1,1,0,0,1,.85.44l3.82,5.3,3.83-5.3a1,1,0,0,1,.87-.44h0A1.09,1.09,0,0,1,156.24,303.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,315.26V303.91a1,1,0,0,1,1.06-1.05h6.28a1.06,1.06,0,0,1,1.06,1.05,1.08,1.08,0,0,1-1.06,1.08h-5.21v3.52h4.48a1.08,1.08,0,0,1,1.06,1.06,1.07,1.07,0,0,1-1.06,1.07h-4.48v3.54h5.21a1.07,1.07,0,0,1,0,2.13h-6.23s0,0,0,0v0A1.05,1.05,0,0,1,159.94,315.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,311.08h-2.36v4.18a1.08,1.08,0,0,1-1.08,1.05,1.07,1.07,0,0,1-1.06-1.05V303.91a1.05,1.05,0,0,1,1.06-1.05h3.44a4.11,4.11,0,1,1,0,8.22ZM179.25,309h2.36a2,2,0,1,0,0-4h-2.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.84,313.14h-4.67l-.94,2.5a1.09,1.09,0,0,1-1,.67,1.44,1.44,0,0,1-.37-.05,1.1,1.1,0,0,1-.63-1.39l4.25-11.32a1.08,1.08,0,0,1,1-.68,1.05,1.05,0,0,1,1,.68l4.25,11.32a1.09,1.09,0,0,1-.63,1.39,1.32,1.32,0,0,1-.37.05,1,1,0,0,1-1-.67Zm-.79-2.11-1.55-4.14L189.94,311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,314.72a1,1,0,0,1-.67,1.34,1.64,1.64,0,0,1-.42.06h0a1.43,1.43,0,0,1-.75-.21,1.91,1.91,0,0,1-.62-.67,5.18,5.18,0,0,1-.4-2.31,1.67,1.67,0,0,0-.23-.83,2,2,0,0,0-.58-.56,3.94,3.94,0,0,0-1.07-.46h-2.27v4.18a1.07,1.07,0,0,1-1.08,1.05,1.05,1.05,0,0,1-1.06-1.05V303.91a1,1,0,0,1,1.06-1.05h3.44a4.11,4.11,0,0,1,2.62,7.28,2.85,2.85,0,0,1,.67.71,3.68,3.68,0,0,1,.63,2.08,4.6,4.6,0,0,0,.08,1.13A1,1,0,0,1,208.3,314.72ZM205.61,307a2,2,0,0,0-2-2h-2.36v4h2.36A2,2,0,0,0,205.61,307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,305h-3.06v10.27a1,1,0,0,1-1.06,1.05,1.05,1.05,0,0,1-1.06-1.05V305h-3a1.07,1.07,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1.05h8.21a1,1,0,0,1,1,1.05A1.08,1.08,0,0,1,219.27,305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,304.66l-3.94,5.41v5.19a1,1,0,0,1-1.06,1.05,1.06,1.06,0,0,1-1.05-1.05v-5.19l-3.91-5.41a1,1,0,0,1,.22-1.46,1,1,0,0,1,1.46.23l3.28,4.5,3.29-4.5a1.05,1.05,0,0,1,1.71,1.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,384v5.33l2.85,1.08a1.23,1.23,0,0,1,.77,1.14,1.1,1.1,0,0,1-.07.41,1.24,1.24,0,0,1-1.58.73l-12.92-4.85a1.21,1.21,0,0,1-.76-1.16,1.18,1.18,0,0,1,.76-1.16l12.92-4.85a1.25,1.25,0,0,1,1.58.72,1.06,1.06,0,0,1,.07.42,1.19,1.19,0,0,1-.77,1.12Zm-2.41.9-4.72,1.78,4.72,1.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,377.65H377.23a1.2,1.2,0,0,1-1.21-1.21v-2.58a7.68,7.68,0,0,1,15.36,0v2.58A1.21,1.21,0,0,1,390.17,377.65Zm-1.23-2.43v-1.36a5.24,5.24,0,0,0-10.48,0v1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,348.67h12.94a1.24,1.24,0,0,1,1.21,1.23,1.21,1.21,0,0,1-1.21,1.21h-9.23l4.39,3.16a1.21,1.21,0,0,1,.5,1v.05a1.28,1.28,0,0,1-.5,1l-4.39,3.13h9.23a1.22,1.22,0,0,1,0,2.44H377.23a1.22,1.22,0,0,1-1.21-1.21v-.06a1.19,1.19,0,0,1,.51-1l6.05-4.37-6.05-4.36a1.2,1.2,0,0,1-.51-1v0A1.26,1.26,0,0,1,377.23,348.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,343.21A1.2,1.2,0,0,1,376,342a1.22,1.22,0,0,1,1.21-1.23h12.94a1.22,1.22,0,0,1,1.21,1.23,1.2,1.2,0,0,1-1.21,1.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46,327.28v3.49h11.71a1.21,1.21,0,1,1,0,2.41H378.46v3.47a1.22,1.22,0,0,1-1.23,1.2,1.19,1.19,0,0,1-1.21-1.2v-9.37a1.2,1.2,0,0,1,1.21-1.2A1.23,1.23,0,0,1,378.46,327.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,303.76a8.07,8.07,0,0,1,11.1,0,7.19,7.19,0,0,1,2.35,5.25,7.39,7.39,0,0,1-2.35,5.37,8.18,8.18,0,0,1-11.1,0,7.31,7.31,0,0,1-2.34-5.37A7.11,7.11,0,0,1,377.93,303.76Zm5.55.29a5.69,5.69,0,0,0-3.84,1.49,4.75,4.75,0,0,0,0,7,5.6,5.6,0,0,0,3.84,1.49,5.5,5.5,0,0,0,3.82-1.49,4.69,4.69,0,0,0,0-7A5.59,5.59,0,0,0,383.48,304.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,295.38a1.22,1.22,0,0,1,1.21,1.19,1.2,1.2,0,0,1-1.21,1.2H377.41a1.15,1.15,0,0,1-1-.48,1.2,1.2,0,0,1,.26-1.67l9.81-7.08h-9a1.2,1.2,0,0,1-1.19-1.19,1.21,1.21,0,0,1,1.19-1.2h12.74a1.22,1.22,0,0,1,1.21,1.2,1.19,1.19,0,0,1-.44.9.42.42,0,0,1-.13.11l-9.74,7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,282.31H377.23A1.2,1.2,0,0,1,376,281.1v-7.17a1.22,1.22,0,0,1,1.21-1.21,1.24,1.24,0,0,1,1.23,1.21v5.94h4v-5.11a1.22,1.22,0,0,1,2.44,0v5.11h4v-5.94a1.22,1.22,0,0,1,2.44,0V281c0,.05,0,.05,0,.05l0,0A1.21,1.21,0,0,1,390.17,282.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,389.81v2.64a.3.3,0,0,1-.31.3.29.29,0,0,1-.3-.3v-5.87a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.63h7.84a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,383.89a.3.3,0,0,1-.3-.3.31.31,0,0,1,.3-.32h8.15a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,376a4.68,4.68,0,0,1,1-2.82.31.31,0,0,1,.44-.05.29.29,0,0,1,.07.42,4,4,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.42.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0A4.61,4.61,0,0,1,410,376a4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,370.52a.31.31,0,0,1-.31-.3.31.31,0,0,1,.31-.32h5.07l-5.29-5.29a.31.31,0,0,1,0-.42.3.3,0,0,1,.44,0l3.35,3.35,4.35-3.43a.34.34,0,0,1,.44.05.31.31,0,0,1,.06.2.25.25,0,0,1-.11.23l-4.3,3.39,1.92,1.92h2.19a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,361.57a.29.29,0,0,1-.3-.3v-4.5a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3V361h3.46V357.3a.31.31,0,0,1,.32-.3.3.3,0,0,1,.3.3V361h3.45v-4.19a.31.31,0,0,1,.61,0v4.53a.3.3,0,0,1-.3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,351.89v2.64a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3v-5.88a.3.3,0,0,1,.3-.3.31.31,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,0,.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.53,341.66h7.17a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3h-8a.3.3,0,0,1-.26-.53l7.35-5.31h-7.13a.31.31,0,0,1,0-.61h8.07a.31.31,0,0,1,.3.31.3.3,0,0,1-.11.24l-.05.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,330.18a3.07,3.07,0,1,1,3.07,2.9A3,3,0,0,1,403.87,330.18Zm5.53,0a2.48,2.48,0,1,0-2.46,2.3A2.4,2.4,0,0,0,409.4,330.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,324.74a.63.63,0,0,1,.63-.63.63.63,0,0,1,0,1.26A.63.63,0,0,1,408.75,324.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,389.66a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,387.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,384.54a5.53,5.53,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.7,5.7,0,0,1,3.06-.85,5.64,5.64,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.47,5.47,0,0,1,418.05,384.54Zm0-.62a4.93,4.93,0,0,0,2.71-.73,2.1,2.1,0,0,0,1.06-1.68,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2.05,2.05,0,0,0,1.06,1.68A4.93,4.93,0,0,0,418.05,383.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,374.82a3.54,3.54,0,0,1-1.91-3.07.31.31,0,0,1,.29-.31.34.34,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.78,5.78,0,0,0,1.75.63,2.88,2.88,0,1,1,2,.72,3.69,3.69,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,374.82Zm4,.21.16,0h.09a2.35,2.35,0,1,0-.3,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,367.76l-3.69-4.09a2.3,2.3,0,0,0-1.68-.75,2.27,2.27,0,0,0-1.66,3.78l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.43a2.92,2.92,0,0,1-.74-1.93,2.88,2.88,0,0,1,2.85-2.86,2.89,2.89,0,0,1,2.13.94l3.17,3.5v-4.14a.3.3,0,0,1,.31-.3.31.31,0,0,1,.3.3v4.93a.3.3,0,0,1-.09.23A.33.33,0,0,1,421.89,367.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,359l.73,1.24a.33.33,0,0,1,0,.15.32.32,0,0,1-.15.26.29.29,0,0,1-.42-.11l-1-1.69a.32.32,0,0,1,.11-.42.34.34,0,0,1,.22,0h8.05a.29.29,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.22,350.89l2.33,2.27a2.87,2.87,0,0,1,.8-1.5,2.94,2.94,0,0,1,2.1-.87,2.91,2.91,0,0,1,2.1.88,3,3,0,0,1,.88,2.1,2.92,2.92,0,0,1-.88,2.09.31.31,0,0,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.26,2.26,0,0,0-1.65.69,2.3,2.3,0,0,0-.69,1.65.35.35,0,0,1-.12.25h0a.33.33,0,0,1-.45,0l-2.24-2.18v3.36a.32.32,0,0,1-.63,0v-4.09a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0A.24.24,0,0,1,414.22,350.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,348.57l-3.69-4.09a2.24,2.24,0,0,0-3.18-.17,2.27,2.27,0,0,0-.16,3.19l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.42a2.92,2.92,0,0,1-.74-1.94,2.88,2.88,0,0,1,2.85-2.85,2.88,2.88,0,0,1,2.13.93l3.17,3.51v-4.14a.3.3,0,0,1,.31-.3.3.3,0,0,1,.3.3v4.92a.3.3,0,0,1-.09.23A.34.34,0,0,1,421.89,348.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.57,341a.31.31,0,0,1-.44,0,.31.31,0,0,1,0-.45,2.36,2.36,0,0,0,.67-1.65,2.34,2.34,0,0,0-2.34-2.34,2.33,2.33,0,0,0-1.65,4,.29.29,0,0,1,0,.43.16.16,0,0,1-.1.08h-.21l-3.53-.42a.25.25,0,0,1-.22-.13.28.28,0,0,1-.08-.2v-4.08a.31.31,0,0,1,.31-.31.31.31,0,0,1,.32.31v3.82l2.6.31a3,3,0,0,1-.4-1.49,2.89,2.89,0,0,1,.86-2.09,2.93,2.93,0,0,1,2.1-.86,3,3,0,0,1,2.11.86,3.06,3.06,0,0,1,.86,2.11A3,3,0,0,1,421.57,341Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,332.64a3.54,3.54,0,0,1-1.91-3.06.31.31,0,0,1,.29-.31.33.33,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.51,5.51,0,0,0,1.75.62,2.87,2.87,0,1,1,2,.73,5.52,5.52,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,332.64Zm4,.22a.76.76,0,0,0,.16,0h.09a2.28,2.28,0,1,0-.3,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,309.68a4.45,4.45,0,1,1,4.44,4.23A4.31,4.31,0,0,1,401.12,309.68Zm8.27,0a3.83,3.83,0,0,0-7.64,0,3.83,3.83,0,0,0,7.64,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,299.1a4.68,4.68,0,0,1,1-2.83.31.31,0,0,1,.44,0,.3.3,0,0,1,.07.43,3.94,3.94,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.43.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0,4.61,4.61,0,0,1,.95,2.83,4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,291.36V294a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3v-5.88a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.8,277.08l2.32,2.27a3,3,0,0,1,.8-1.5A3,3,0,0,1,407,277a2.93,2.93,0,0,1,2.1.88A3,3,0,0,1,410,280a2.94,2.94,0,0,1-.87,2.09.31.31,0,1,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.34,2.34,0,0,0-2.34,2.34.31.31,0,0,1-.13.25h0a.31.31,0,0,1-.45,0L401.87,278v3.35a.31.31,0,0,1-.31.31.31.31,0,0,1-.31-.31V277.3a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,273.32l.73,1.24a.27.27,0,0,1,.05.15.3.3,0,0,1-.15.26.28.28,0,0,1-.41-.11l-1-1.69a.32.32,0,0,1,.11-.41.38.38,0,0,1,.23,0h8a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,311.1a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,308.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,305.08a.63.63,0,0,1,.63-.63.62.62,0,0,1,.62.63.61.61,0,0,1-.62.62A.62.62,0,0,1,415.92,305.08Zm5.26,0a.62.62,0,0,1,.62-.63.63.63,0,0,1,.63.63.62.62,0,0,1-.63.62A.61.61,0,0,1,421.18,305.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,303a5.61,5.61,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.55,5.55,0,0,1,418.05,303Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,302.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,294.1a5.53,5.53,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.47,5.47,0,0,1,418.05,294.1Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,293.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,284.94a.25.25,0,0,1-.25-.25v-2.06a2.09,2.09,0,0,1,4.17,0l0,1.8h2.87a.26.26,0,0,1,.25.26.25.25,0,0,1-.25.25Zm3.43-2.31a1.61,1.61,0,0,0-1.59-1.58,1.58,1.58,0,0,0-1.58,1.58v1.8h3.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17,273.22l3.24,2.34a.26.26,0,0,1,.12.21v0a.25.25,0,0,1-.12.22l-3.23,2.34h6a.25.25,0,0,1,.25.25.26.26,0,0,1-.25.26h-6.77a.24.24,0,0,1-.2-.11l0,0a.26.26,0,0,1,.07-.35l3.6-2.6-3.6-2.59a.26.26,0,0,1-.07-.35l.09-.08a.33.33,0,0,1,.13,0h6.77a.26.26,0,0,1,.25.25.25.25,0,0,1-.25.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.12,
    y: 319.39,
    width: 21.31,
    height: 0.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,344.36a6.13,6.13,0,0,1,0,8.43,5.46,5.46,0,0,1-4,1.78,5.63,5.63,0,0,1-4.08-1.78,6.21,6.21,0,0,1,0-8.43,5.56,5.56,0,0,1,4.08-1.78A5.39,5.39,0,0,1,83.39,344.36Zm-.22,4.22A4.32,4.32,0,0,0,82,345.66a3.58,3.58,0,0,0-2.63-1.18,3.62,3.62,0,0,0-2.7,1.18,4.23,4.23,0,0,0-1.13,2.92,4.13,4.13,0,0,0,1.13,2.89,3.56,3.56,0,0,0,5.33,0A4.23,4.23,0,0,0,83.17,348.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,348.58a6.11,6.11,0,0,1,6.11-6,6.23,6.23,0,0,1,3.85,1.3,1,1,0,0,1-1.17,1.52,4.15,4.15,0,0,0-2.68-.92,4.42,4.42,0,0,0-3,1.2,4.09,4.09,0,0,0-1.22,2.9,4,4,0,0,0,1.22,2.89,4.37,4.37,0,0,0,3,1.2,4.18,4.18,0,0,0,2.68-.91,1,1,0,0,1,1.33.18,1,1,0,0,1-.16,1.33,6.23,6.23,0,0,1-3.85,1.3A6.08,6.08,0,0,1,87.34,348.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,344.76h-2.65v8.9a.9.9,0,0,1-.92.91.91.91,0,0,1-.91-.91v-8.9h-2.63a.93.93,0,0,1-.92-.93.91.91,0,0,1,.92-.92h7.11a.91.91,0,0,1,.91.92A.93.93,0,0,1,107.82,344.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.65,369.64a10.64,10.64,0,0,1,3.18,7.61A10.79,10.79,0,0,1,74.4,384.9a2.46,2.46,0,1,1,3.48-3.48,5.77,5.77,0,0,0,4.12,1.7,6,6,0,0,0,4.18-1.7,5.82,5.82,0,0,0,1.73-4.17,5.66,5.66,0,0,0-1.73-4.13,5.88,5.88,0,0,0-4.13-1.74,2.12,2.12,0,0,1-1.78-.78s0,0,0,0a2.46,2.46,0,0,1-.08-3.48l4.43-4.52h-7a2.46,2.46,0,0,1,0-4.91H90.35a2.44,2.44,0,0,1,2.48,2.43,2.55,2.55,0,0,1-.31,1.18,3.26,3.26,0,0,1-.43.6l-5.48,5.65A10.06,10.06,0,0,1,89.65,369.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.73,360.08v25.64a2.41,2.41,0,0,1-2.43,2.39,2.35,2.35,0,0,1-2.39-2.39V364.34l-1.74,1a2.16,2.16,0,0,1-1.21.35,2.34,2.34,0,0,1-2-1.22,2.32,2.32,0,0,1,.78-3.26L105,358s.13,0,.17-.09.14-.08.22-.13.18,0,.26,0a.3.3,0,0,1,.18,0,.61.61,0,0,1,.3-.05h.48c0,.05.13.05.17.05a.47.47,0,0,1,.26.08.25.25,0,0,1,.18.05c.13.08.17.13.26.13a.92.92,0,0,0,.17.13,2,2,0,0,1,.18.13c.08,0,.13.13.17.17a.56.56,0,0,1,.13.18l.17.17,0,.09s0,.08,0,.13.09.13.09.21,0,.18.08.22a1.88,1.88,0,0,0,.05.22.37.37,0,0,0,.08.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,344a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,344Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,349.4a1.12,1.12,0,1,1-1.11-1.12A1.12,1.12,0,0,1,117.5,349.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,354.77a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,354.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,360.14a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,360.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,365.51a1.12,1.12,0,1,1-1.11-1.11A1.12,1.12,0,0,1,117.5,365.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,370.89a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,370.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,376.26a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,376.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,381.63a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,381.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,387a1.12,1.12,0,1,1-1.11-1.12A1.11,1.11,0,0,1,117.5,387Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,375.79v-9.72a.9.9,0,0,1,.91-.91.92.92,0,0,1,.92.91v8.8h4.47a.92.92,0,0,1,0,1.83h-5.39A.9.9,0,0,1,122.26,375.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,366.07a.89.89,0,0,1,.91-.91.92.92,0,0,1,.92.91v9.72a.92.92,0,0,1-.92.91.9.9,0,0,1-.91-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,376.53l-.11-.08s0,0,0-.05a.39.39,0,0,1-.08-.1h0a.35.35,0,0,0-.08-.13l-4-9.63a.9.9,0,0,1,1.67-.69l3.21,7.63,3.22-7.63a.89.89,0,0,1,1.18-.48.91.91,0,0,1,.5,1.17l-4.08,9.63a.49.49,0,0,1-.06.13h0s-.06.07-.08.1l0,.05-.1.08,0,0a.64.64,0,0,1-.14.08l0,0a.61.61,0,0,0-.13,0h0a.56.56,0,0,1-.17,0,.44.44,0,0,1-.16,0h0l-.13,0a0,0,0,0,0,0,0h0l-.15-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53,375.79v-9.72a.89.89,0,0,1,.9-.91h5.4a.91.91,0,0,1,.9.91.93.93,0,0,1-.9.92h-4.47v3h3.84a.92.92,0,0,1,0,1.83h-3.84v3h4.47a.92.92,0,0,1,0,1.83h-5.35s0,0,0,0l0,0A.9.9,0,0,1,148.53,375.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,347.22a4,4,0,0,1,8-.41s0,0,0,0c0,.31,0,.63,0,.94a9.68,9.68,0,0,1-.57,3.38A5.74,5.74,0,0,1,127,354a4.69,4.69,0,0,1-2.47.77.92.92,0,0,1-1-.87,1,1,0,0,1,.89-1,2.9,2.9,0,0,0,1.55-.46,3.42,3.42,0,0,0,1-1.15,2.86,2.86,0,0,0,.21-.43,3.92,3.92,0,0,1-1.58.33A4,4,0,0,1,121.71,347.22Zm1.83,0a2.17,2.17,0,1,0,4.33,0,2.17,2.17,0,0,0-4.33,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,345.87a1.24,1.24,0,0,1,1.24,1.23,1.23,1.23,0,0,1-1.24,1.22,1.21,1.21,0,0,1-1.22-1.22A1.23,1.23,0,0,1,133.86,345.87Zm0,6.56a1.23,1.23,0,1,1,0,2.46,1.23,1.23,0,0,1,0-2.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.23,349a7.06,7.06,0,0,1,1.13-3.94,3.47,3.47,0,0,1,6.11,0,7.55,7.55,0,0,1,0,7.88,3.47,3.47,0,0,1-6.11,0A7.08,7.08,0,0,1,136.23,349Zm6.52,0a5.38,5.38,0,0,0-.8-2.93,1.88,1.88,0,0,0-1.53-1,2,2,0,0,0-1.56,1,5.75,5.75,0,0,0,0,5.85,2,2,0,0,0,1.56,1,1.92,1.92,0,0,0,1.53-1A5.34,5.34,0,0,0,142.75,349Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,349a7.13,7.13,0,0,1,1.12-3.94,3.47,3.47,0,0,1,6.12,0,7.61,7.61,0,0,1,0,7.88,3.47,3.47,0,0,1-6.12,0A7.16,7.16,0,0,1,147.94,349Zm6.51,0a5.46,5.46,0,0,0-.79-2.93,1.88,1.88,0,0,0-1.53-1,2,2,0,0,0-1.57,1,5.81,5.81,0,0,0,0,5.85,2,2,0,0,0,1.57,1,1.92,1.92,0,0,0,1.53-1A5.43,5.43,0,0,0,154.45,349Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,381.21v6.28a.6.6,0,0,1-.6.58.58.58,0,0,1-.58-.58V383l-1.53,2.13a.61.61,0,0,1-.48.24h0a.6.6,0,0,1-.49-.24L123.06,383v4.48a.6.6,0,0,1-1.19,0v-6.28a.6.6,0,0,1,.59-.59h0a.59.59,0,0,1,.47.25l2.12,2.94,2.11-2.94a.59.59,0,0,1,.48-.25h0A.62.62,0,0,1,128.28,381.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.94,388.07a3.06,3.06,0,0,1-3.07-3.07v-3.79a.58.58,0,0,1,.58-.59.6.6,0,0,1,.6.59V385a1.89,1.89,0,1,0,3.78,0v-3.79a.59.59,0,0,1,.6-.59.58.58,0,0,1,.58.59V385A3.07,3.07,0,0,1,133.94,388.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28,386.22a.55.55,0,0,1,.78-.07,3.43,3.43,0,0,0,2,.81,2.33,2.33,0,0,0,1.33-.39,1,1,0,0,0,.46-.76.55.55,0,0,0-.1-.34.88.88,0,0,0-.32-.32,4,4,0,0,0-1.45-.5h0a6.1,6.1,0,0,1-1.37-.42,2.36,2.36,0,0,1-1-.83,1.6,1.6,0,0,1-.24-.87,2,2,0,0,1,.85-1.55,3.09,3.09,0,0,1,1.84-.57,4.17,4.17,0,0,1,2.32.85.56.56,0,0,1,.15.76.55.55,0,0,1-.76.16,3.08,3.08,0,0,0-1.71-.68,2.05,2.05,0,0,0-1.19.36.85.85,0,0,0-.41.67.56.56,0,0,0,.08.3,1,1,0,0,0,.29.27,3.49,3.49,0,0,0,1.33.47h0a6.42,6.42,0,0,1,1.46.45,2.51,2.51,0,0,1,1.07.88,1.75,1.75,0,0,1,.25.91,2,2,0,0,1-.91,1.64,3.27,3.27,0,0,1-2,.61,4.54,4.54,0,0,1-2.72-1.06A.57.57,0,0,1,139.28,386.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.69,381.21a.58.58,0,0,1,.58-.59.6.6,0,0,1,.6.59v6.28a.59.59,0,0,1-.6.58.57.57,0,0,1-.58-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53,384.24a3.91,3.91,0,0,1,3.9-3.83,4,4,0,0,1,2.46.83.61.61,0,0,1-.74,1,2.7,2.7,0,0,0-1.72-.59,2.81,2.81,0,0,0-1.91.77,2.63,2.63,0,0,0-.78,1.85,2.57,2.57,0,0,0,.78,1.85,2.81,2.81,0,0,0,1.91.77,2.66,2.66,0,0,0,1.72-.59.65.65,0,0,1,.85.12.62.62,0,0,1-.11.85,4,4,0,0,1-2.46.83A3.89,3.89,0,0,1,149.53,384.24Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--texts-1--inject-135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.51,111.25V95.68A1.43,1.43,0,0,1,175,94.22a1.46,1.46,0,0,1,1.48,1.46V102h6.83V95.68a1.44,1.44,0,0,1,1.46-1.46,1.46,1.46,0,0,1,1.47,1.46v15.57a1.45,1.45,0,0,1-1.47,1.45,1.43,1.43,0,0,1-1.46-1.45v-6.33h-6.83v6.33A1.45,1.45,0,0,1,175,112.7,1.43,1.43,0,0,1,173.51,111.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,108.35h-6.42l-1.29,3.43a1.48,1.48,0,0,1-1.37.92,1.31,1.31,0,0,1-.5-.08,1.49,1.49,0,0,1-.87-1.9l5.83-15.54a1.48,1.48,0,0,1,1.4-.93,1.45,1.45,0,0,1,1.4.93l5.83,15.54a1.49,1.49,0,0,1-.87,1.9,1.28,1.28,0,0,1-.5.08,1.42,1.42,0,0,1-1.35-.92Zm-1.08-2.91-2.14-5.67-2.14,5.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.55,111.25V95.68A1.46,1.46,0,0,1,209,94.22a1.48,1.48,0,0,1,1.47,1.46v14.09h7.16a1.47,1.47,0,0,1,0,2.93H209A1.45,1.45,0,0,1,207.55,111.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,111.25V95.68a1.46,1.46,0,0,1,1.46-1.46,1.48,1.48,0,0,1,1.47,1.46v14.09h7.16a1.47,1.47,0,0,1,0,2.93h-8.63A1.45,1.45,0,0,1,222.41,111.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.79,96.52a9.72,9.72,0,0,1,0,13.36,8.63,8.63,0,0,1-6.31,2.82,8.89,8.89,0,0,1-6.47-2.82,9.85,9.85,0,0,1,0-13.36,8.81,8.81,0,0,1,6.47-2.82A8.56,8.56,0,0,1,250.79,96.52Zm-.35,6.68a6.85,6.85,0,0,0-1.79-4.62,5.69,5.69,0,0,0-4.17-1.87,5.75,5.75,0,0,0-4.28,1.87,6.71,6.71,0,0,0-1.79,4.62,6.57,6.57,0,0,0,1.79,4.59,5.65,5.65,0,0,0,8.45,0A6.7,6.7,0,0,0,250.44,103.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.07,96.42l-6.47,15.39a.73.73,0,0,1-.13.23l0,0a.91.91,0,0,1-.13.16s0,0,0,.08a.68.68,0,0,0-.18.13h0c-.08,0-.13.13-.24.16h0s0,0,0,0a.76.76,0,0,0-.21.06h-.05a1.1,1.1,0,0,1-.27,0,1,1,0,0,1-.24,0h-.08a.54.54,0,0,0-.18-.06l-.05,0a.56.56,0,0,1-.24-.16h0c-.08,0-.13-.11-.18-.13a.16.16,0,0,1-.05-.08l-.11-.16s0,0,0,0a.55.55,0,0,1-.11-.23l-3.46-8.19L266,111.81a1.67,1.67,0,0,1-.11.23,0,0,0,0,0,0,0l-.15.16s0,0,0,.08a.61.61,0,0,0-.16.13h-.05c-.08,0-.16.13-.21.16h0s0,0,0,0a.4.4,0,0,0-.21.06h-.08a.93.93,0,0,1-.23,0,1.23,1.23,0,0,1-.27,0h-.08a.62.62,0,0,0-.18-.06l-.05,0a.84.84,0,0,1-.24-.16h0c-.08,0-.1-.11-.18-.13a.28.28,0,0,1-.06-.08c-.05,0-.08-.11-.13-.16v0a1.57,1.57,0,0,1-.13-.23l-6.49-15.39a1.43,1.43,0,0,1,.79-1.88,1.41,1.41,0,0,1,1.87.77l5.18,12.22,3.4-8.1a1.46,1.46,0,0,1,1.37-.9,1.52,1.52,0,0,1,1.38.9l3.4,8.1,5.15-12.22a1.47,1.47,0,0,1,1.93-.77A1.44,1.44,0,0,1,282.07,96.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.28,111.25V95.68a1.44,1.44,0,0,1,1.46-1.46h8.63a1.47,1.47,0,0,1,1.45,1.46,1.49,1.49,0,0,1-1.45,1.48h-7.16V102h6.15a1.47,1.47,0,0,1,0,2.93h-6.15v4.85h7.16a1.47,1.47,0,0,1,0,2.93h-8.56c-.05,0-.05,0-.05,0l0,0A1.45,1.45,0,0,1,286.28,111.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,111.25V95.68a1.44,1.44,0,0,1,1.46-1.46H312a1.47,1.47,0,0,1,1.45,1.46A1.49,1.49,0,0,1,312,97.16h-7.16V102H311a1.47,1.47,0,0,1,0,2.93h-6.16v4.85H312a1.47,1.47,0,0,1,0,2.93h-8.55c-.06,0-.06,0-.06,0l0,0A1.45,1.45,0,0,1,301.93,111.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.49,111.25a1.44,1.44,0,1,1-2.88,0V95.89a1.43,1.43,0,0,1,2.59-.9l8.53,11.8V95.91a1.43,1.43,0,0,1,1.42-1.42,1.46,1.46,0,0,1,1.45,1.42v15.34a1.46,1.46,0,0,1-1.45,1.45,1.44,1.44,0,0,1-1.08-.52.83.83,0,0,1-.13-.16l-8.45-11.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.17,126.71a7.05,7.05,0,0,1,7.05-6.92,7.2,7.2,0,0,1,4.44,1.5,1.14,1.14,0,0,1,.2,1.54,1.13,1.13,0,0,1-1.54.21,4.83,4.83,0,0,0-3.1-1.06,5.1,5.1,0,0,0-3.46,1.39,4.7,4.7,0,0,0,0,6.69,5.14,5.14,0,0,0,3.46,1.38,4.81,4.81,0,0,0,3.1-1.06,1.17,1.17,0,0,1,1.54.22,1.12,1.12,0,0,1-.2,1.53,7.14,7.14,0,0,1-4.44,1.5A7,7,0,0,1,172.17,126.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,121.85a7.07,7.07,0,0,1,0,9.73,6.31,6.31,0,0,1-4.6,2,6.5,6.5,0,0,1-4.71-2,7.18,7.18,0,0,1,0-9.73,6.44,6.44,0,0,1,4.71-2.06A6.24,6.24,0,0,1,197.82,121.85Zm-.25,4.86a5,5,0,0,0-1.31-3.36,4.14,4.14,0,0,0-6.15,0,5,5,0,0,0,0,6.71,4.12,4.12,0,0,0,6.15,0A4.9,4.9,0,0,0,197.57,126.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,130.29a1,1,0,0,1,1.41-.14,6.21,6.21,0,0,0,3.67,1.48,4.07,4.07,0,0,0,2.4-.71,1.72,1.72,0,0,0,.83-1.38,1.15,1.15,0,0,0-.17-.62,1.85,1.85,0,0,0-.58-.57,7.58,7.58,0,0,0-2.63-.91h0a10,10,0,0,1-2.48-.75,4,4,0,0,1-1.79-1.5,2.93,2.93,0,0,1-.44-1.57,3.53,3.53,0,0,1,1.54-2.81,5.68,5.68,0,0,1,3.32-1,7.47,7.47,0,0,1,4.19,1.54,1,1,0,0,1,.27,1.36,1,1,0,0,1-1.36.29,5.62,5.62,0,0,0-3.1-1.23,3.64,3.64,0,0,0-2.15.66,1.51,1.51,0,0,0-.73,1.21,1,1,0,0,0,.13.53,1.79,1.79,0,0,0,.52.5,6.54,6.54,0,0,0,2.4.85h0a11.07,11.07,0,0,1,2.66.81,4.43,4.43,0,0,1,1.92,1.59,3.13,3.13,0,0,1,.46,1.64,3.72,3.72,0,0,1-1.65,3,6,6,0,0,1-3.56,1.09,8.17,8.17,0,0,1-4.92-1.92A1,1,0,0,1,203,130.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,122.31h-3.06v10.27a1,1,0,0,1-1.06,1,1.05,1.05,0,0,1-1.06-1V122.31h-3a1.07,1.07,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1h8.21a1,1,0,0,1,1.05,1A1.08,1.08,0,0,1,224.23,122.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,133.63a5.54,5.54,0,0,1-5.55-5.55v-6.85a1,1,0,0,1,1.06-1,1.07,1.07,0,0,1,1.07,1v6.85a3.43,3.43,0,0,0,6.85,0v-6.85a1.05,1.05,0,0,1,1.07-1,1,1,0,0,1,1.06,1v6.85A5.56,5.56,0,0,1,234,133.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73,121.23v11.35a1.08,1.08,0,0,1-1.08,1,1.05,1.05,0,0,1-1.06-1v-8.1l-2.77,3.85a1,1,0,0,1-.86.44h0a1.06,1.06,0,0,1-.88-.44l-2.75-3.85v8.1a1.07,1.07,0,0,1-2.14,0V121.23a1.07,1.07,0,0,1,1.06-1h.06a1,1,0,0,1,.84.44l3.83,5.3,3.83-5.3a1,1,0,0,1,.86-.44h0A1.09,1.09,0,0,1,254.73,121.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,132.58V121.23a1,1,0,0,1,1.06-1h6.29a1.06,1.06,0,0,1,1.06,1,1.08,1.08,0,0,1-1.06,1.08h-5.21v3.52H265a1.08,1.08,0,0,1,1,1.06,1.07,1.07,0,0,1-1,1.07h-4.48v3.54h5.21a1.07,1.07,0,0,1,0,2.13h-6.23s0,0,0,0l0,0A1.05,1.05,0,0,1,258.42,132.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1,128.4h-2.37v4.18a1.07,1.07,0,0,1-2.13,0V121.23a1,1,0,0,1,1-1h3.45a4.11,4.11,0,1,1,0,8.22Zm-2.37-2.13h2.37a2,2,0,1,0,0-4h-2.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,130.46h-4.68l-.94,2.5a1.07,1.07,0,0,1-1,.67,1.36,1.36,0,0,1-.36,0,1.1,1.1,0,0,1-.64-1.39L289,120.87a1.1,1.1,0,0,1,1-.68,1.07,1.07,0,0,1,1,.68l4.25,11.32a1.1,1.1,0,0,1-.64,1.39,1.25,1.25,0,0,1-.36,0,1,1,0,0,1-1-.67Zm-.79-2.11L290,124.21l-1.56,4.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.79,132a1.06,1.06,0,0,1-.67,1.34,1.74,1.74,0,0,1-.43.06h0a1.43,1.43,0,0,1-.75-.21,1.8,1.8,0,0,1-.61-.67,5.16,5.16,0,0,1-.41-2.31,1.49,1.49,0,0,0-.23-.83,1.8,1.8,0,0,0-.57-.56,4.1,4.1,0,0,0-1.08-.46h-2.27v4.18a1.07,1.07,0,0,1-1.08,1,1,1,0,0,1-1.05-1V121.23a1,1,0,0,1,1.05-1h3.45a4.11,4.11,0,0,1,2.61,7.28,2.85,2.85,0,0,1,.67.71,3.61,3.61,0,0,1,.64,2.08,4.6,4.6,0,0,0,.08,1.13A1.07,1.07,0,0,1,306.79,132Zm-2.69-7.73a2,2,0,0,0-2-2h-2.37v4h2.37A2,2,0,0,0,304.1,124.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.75,122.31h-3.06v10.27a1,1,0,0,1-1.05,1,1.05,1.05,0,0,1-1.06-1V122.31h-3a1.08,1.08,0,0,1-1.06-1.08,1,1,0,0,1,1.06-1h8.21a1.05,1.05,0,0,1,1.06,1A1.08,1.08,0,0,1,317.75,122.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.35,122l-3.94,5.41v5.19a1,1,0,0,1-1.06,1,1.06,1.06,0,0,1-1.06-1v-5.19l-3.9-5.41a1,1,0,0,1,.21-1.46,1,1,0,0,1,1.46.23l3.29,4.5,3.29-4.5a1.06,1.06,0,0,1,1.48-.23A1.07,1.07,0,0,1,331.35,122Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,201.31v5.33l2.85,1.08a1.23,1.23,0,0,1,.77,1.14,1.1,1.1,0,0,1-.07.41,1.24,1.24,0,0,1-1.58.73l-12.92-4.85a1.21,1.21,0,0,1-.76-1.16,1.18,1.18,0,0,1,.76-1.16L389.73,198a1.25,1.25,0,0,1,1.58.72,1.06,1.06,0,0,1,.07.42,1.19,1.19,0,0,1-.77,1.12Zm-2.41.9L380.63,204l4.72,1.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,195H377.23a1.2,1.2,0,0,1-1.21-1.21v-2.58a7.68,7.68,0,0,1,15.36,0v2.58A1.21,1.21,0,0,1,390.17,195Zm-1.23-2.43v-1.36a5.24,5.24,0,0,0-10.48,0v1.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,166h12.94a1.24,1.24,0,0,1,1.21,1.23,1.21,1.21,0,0,1-1.21,1.21h-9.23l4.39,3.16a1.21,1.21,0,0,1,.5,1v.05a1.28,1.28,0,0,1-.5,1l-4.39,3.13h9.23a1.22,1.22,0,0,1,0,2.44H377.23A1.22,1.22,0,0,1,376,178v-.06a1.19,1.19,0,0,1,.51-1l6.05-4.37-6.05-4.36a1.2,1.2,0,0,1-.51-1v0A1.26,1.26,0,0,1,377.23,166Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,160.53a1.2,1.2,0,0,1-1.21-1.21,1.22,1.22,0,0,1,1.21-1.23h12.94a1.22,1.22,0,0,1,1.21,1.23,1.2,1.2,0,0,1-1.21,1.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46,144.6v3.49h11.71a1.21,1.21,0,1,1,0,2.41H378.46V154a1.22,1.22,0,0,1-1.23,1.2A1.19,1.19,0,0,1,376,154V144.6a1.2,1.2,0,0,1,1.21-1.2A1.23,1.23,0,0,1,378.46,144.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,121.08a8.07,8.07,0,0,1,11.1,0,7.19,7.19,0,0,1,2.35,5.25A7.39,7.39,0,0,1,389,131.7a8.18,8.18,0,0,1-11.1,0,7.31,7.31,0,0,1-2.34-5.37A7.11,7.11,0,0,1,377.93,121.08Zm5.55.29a5.69,5.69,0,0,0-3.84,1.49,4.75,4.75,0,0,0,0,7,5.6,5.6,0,0,0,3.84,1.49,5.5,5.5,0,0,0,3.82-1.49,4.69,4.69,0,0,0,0-7A5.59,5.59,0,0,0,383.48,121.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,112.7a1.22,1.22,0,0,1,1.21,1.19,1.2,1.2,0,0,1-1.21,1.2H377.41a1.15,1.15,0,0,1-1-.48,1.2,1.2,0,0,1,.26-1.67l9.81-7.08h-9a1.2,1.2,0,0,1-1.19-1.19,1.21,1.21,0,0,1,1.19-1.2h12.74a1.22,1.22,0,0,1,1.21,1.2,1.19,1.19,0,0,1-.44.9.42.42,0,0,1-.13.11l-9.74,7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,99.63H377.23A1.2,1.2,0,0,1,376,98.42V91.25A1.22,1.22,0,0,1,377.23,90a1.24,1.24,0,0,1,1.23,1.21v5.94h4V92.08a1.22,1.22,0,0,1,2.44,0v5.11h4V91.25a1.22,1.22,0,0,1,2.44,0v7.1c0,.05,0,.05,0,.05l0,0A1.21,1.21,0,0,1,390.17,99.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,207.13v2.64a.3.3,0,0,1-.31.3.29.29,0,0,1-.3-.3V203.9a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.63h7.84a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,201.21a.3.3,0,0,1-.3-.3.31.31,0,0,1,.3-.32h8.15a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,193.31a4.68,4.68,0,0,1,1-2.82.31.31,0,0,1,.44-.05.29.29,0,0,1,.07.42,4,4,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.42.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0,4.61,4.61,0,0,1,.95,2.82,4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,187.84a.31.31,0,0,1-.31-.3.31.31,0,0,1,.31-.32h5.07l-5.29-5.29a.31.31,0,0,1,0-.42.3.3,0,0,1,.44,0l3.35,3.35,4.35-3.43a.34.34,0,0,1,.44,0,.31.31,0,0,1,.06.2.25.25,0,0,1-.11.23l-4.3,3.39,1.92,1.92h2.19a.31.31,0,0,1,.3.32.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,178.89a.29.29,0,0,1-.3-.3v-4.5a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v4.19h3.46v-3.66a.31.31,0,0,1,.32-.3.3.3,0,0,1,.3.3v3.66h3.45v-4.19a.31.31,0,0,1,.61,0v4.53a.3.3,0,0,1-.3.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,169.21v2.64a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3V166a.3.3,0,0,1,.3-.3.31.31,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,0,.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.53,159h7.17a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3h-8a.3.3,0,0,1-.26-.53l7.35-5.31h-7.13a.31.31,0,0,1,0-.61h8.07a.31.31,0,0,1,.3.31.3.3,0,0,1-.11.24s0,0-.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,147.5a3.07,3.07,0,1,1,3.07,2.9A3,3,0,0,1,403.87,147.5Zm5.53,0a2.48,2.48,0,1,0-2.46,2.3A2.4,2.4,0,0,0,409.4,147.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,142.06a.63.63,0,0,1,.63-.63.63.63,0,0,1,0,1.26A.63.63,0,0,1,408.75,142.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,207a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,204.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,201.86A5.53,5.53,0,0,1,415,201a2.48,2.48,0,0,1,0-4.38,5.7,5.7,0,0,1,3.06-.85,5.64,5.64,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.47,5.47,0,0,1,418.05,201.86Zm0-.62a4.93,4.93,0,0,0,2.71-.73,2.1,2.1,0,0,0,1.06-1.68,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2.05,2.05,0,0,0,1.06,1.68A4.93,4.93,0,0,0,418.05,201.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,192.14a3.54,3.54,0,0,1-1.91-3.07.31.31,0,0,1,.29-.31.34.34,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.78,5.78,0,0,0,1.75.63,2.88,2.88,0,1,1,2,.72,3.69,3.69,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,192.14Zm4,.21.16,0h.09a2.35,2.35,0,1,0-.3,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,185.08,418.2,181a2.3,2.3,0,0,0-1.68-.75,2.27,2.27,0,0,0-1.66,3.78l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.43a2.92,2.92,0,0,1-.74-1.93,2.88,2.88,0,0,1,2.85-2.86,2.89,2.89,0,0,1,2.13.94l3.17,3.5v-4.14a.3.3,0,0,1,.31-.3.31.31,0,0,1,.3.3v4.93a.3.3,0,0,1-.09.23A.33.33,0,0,1,421.89,185.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.56,176.27l.73,1.24a.33.33,0,0,1,0,.15.32.32,0,0,1-.15.26.29.29,0,0,1-.42-.11l-1-1.69a.32.32,0,0,1,.11-.42.34.34,0,0,1,.22,0h8.05a.29.29,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.22,168.21l2.33,2.27a2.87,2.87,0,0,1,.8-1.5,2.94,2.94,0,0,1,2.1-.87,2.91,2.91,0,0,1,2.1.88,3,3,0,0,1,.88,2.1,2.92,2.92,0,0,1-.88,2.09.31.31,0,0,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.26,2.26,0,0,0-1.65.69,2.3,2.3,0,0,0-.69,1.65.35.35,0,0,1-.12.25h0a.33.33,0,0,1-.45,0l-2.24-2.18v3.36a.32.32,0,0,1-.63,0v-4.09a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0A.24.24,0,0,1,414.22,168.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.89,165.89l-3.69-4.09a2.24,2.24,0,0,0-3.18-.17,2.27,2.27,0,0,0-.16,3.19l.39.43a.29.29,0,0,1,0,.42.29.29,0,0,1-.43,0l-.4-.42a2.92,2.92,0,0,1-.74-1.94,2.88,2.88,0,0,1,2.85-2.85,2.88,2.88,0,0,1,2.13.93l3.17,3.51v-4.14a.3.3,0,0,1,.31-.3.3.3,0,0,1,.3.3v4.92a.3.3,0,0,1-.09.23A.34.34,0,0,1,421.89,165.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.57,158.31a.31.31,0,0,1-.44,0,.31.31,0,0,1,0-.45,2.36,2.36,0,0,0,.67-1.65,2.34,2.34,0,0,0-2.34-2.34,2.33,2.33,0,0,0-1.65,4,.29.29,0,0,1,0,.43.16.16,0,0,1-.1.08h-.21L414,158a.25.25,0,0,1-.22-.13.28.28,0,0,1-.08-.2v-4.08a.31.31,0,0,1,.31-.31.31.31,0,0,1,.32.31v3.82l2.6.31a3,3,0,0,1-.4-1.49,2.89,2.89,0,0,1,.86-2.09,2.93,2.93,0,0,1,2.1-.86,3,3,0,0,1,2.11.86,3.06,3.06,0,0,1,.86,2.11A3,3,0,0,1,421.57,158.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.59,150a3.54,3.54,0,0,1-1.91-3.06.31.31,0,0,1,.29-.31.33.33,0,0,1,.33.3,3,3,0,0,0,1.59,2.55,5.51,5.51,0,0,0,1.75.62,2.87,2.87,0,1,1,2,.73,5.52,5.52,0,0,1-.58,0A7.16,7.16,0,0,1,415.59,150Zm4,.22a.76.76,0,0,0,.16,0h.09a2.28,2.28,0,1,0-.3,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,127a4.45,4.45,0,1,1,4.44,4.23A4.31,4.31,0,0,1,401.12,127Zm8.27,0a3.83,3.83,0,0,0-7.64,0,3.83,3.83,0,0,0,7.64,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,116.42a4.68,4.68,0,0,1,1-2.83.31.31,0,0,1,.44,0,.3.3,0,0,1,.07.43,3.94,3.94,0,0,0-.86,2.45,3.83,3.83,0,1,0,7.66,0,3.72,3.72,0,0,0-.85-2.43.31.31,0,0,1,.07-.44.3.3,0,0,1,.44,0,4.61,4.61,0,0,1,.95,2.83,4.44,4.44,0,1,1-8.88,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,108.68v2.64a.31.31,0,0,1-.31.3.3.3,0,0,1-.3-.3v-5.88a.29.29,0,0,1,.3-.3.3.3,0,0,1,.31.3v2.64h7.84a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.8,94.4l2.32,2.27a3,3,0,0,1,.8-1.5A3,3,0,0,1,407,94.3a2.93,2.93,0,0,1,2.1.88,3,3,0,0,1,.87,2.1,2.94,2.94,0,0,1-.87,2.09.31.31,0,1,1-.44-.44,2.35,2.35,0,0,0-1.66-4,2.34,2.34,0,0,0-2.34,2.34.31.31,0,0,1-.13.25h0a.31.31,0,0,1-.45,0l-2.24-2.17v3.35a.31.31,0,0,1-.31.31.31.31,0,0,1-.31-.31V94.62a.31.31,0,0,1,.31-.32.33.33,0,0,1,.14,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,90.64l.73,1.24a.27.27,0,0,1,.05.15.3.3,0,0,1-.15.26.28.28,0,0,1-.41-.11l-1-1.69a.32.32,0,0,1,.11-.41.38.38,0,0,1,.23,0h8a.3.3,0,0,1,.3.3.31.31,0,0,1-.3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67,128.42a2.87,2.87,0,0,1,2.55-2.87l.07,0,.75,0a7.25,7.25,0,0,1,3.49.84,3.6,3.6,0,0,1,1.9,3.06h0a.3.3,0,0,1-.29.32.32.32,0,0,1-.32-.3,3,3,0,0,0-1.59-2.56,5.53,5.53,0,0,0-1.75-.62,2.85,2.85,0,0,1,1,2.17,2.89,2.89,0,1,1-5.77,0Zm2.88-2.28a2.28,2.28,0,1,0,2.28,2.28A2.27,2.27,0,0,0,416.55,126.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,122.4a.63.63,0,0,1,.63-.63.62.62,0,0,1,.62.63.61.61,0,0,1-.62.62A.62.62,0,0,1,415.92,122.4Zm5.26,0a.62.62,0,0,1,.62-.63.63.63,0,0,1,.63.63.62.62,0,0,1-.63.62A.61.61,0,0,1,421.18,122.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,120.3a5.61,5.61,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.55,5.55,0,0,1,418.05,120.3Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,119.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,111.42a5.61,5.61,0,0,1-3.06-.84,2.48,2.48,0,0,1,0-4.38,5.62,5.62,0,0,1,3.06-.85,5.56,5.56,0,0,1,3.05.85,2.47,2.47,0,0,1,0,4.38A5.55,5.55,0,0,1,418.05,111.42Zm0-.62a4.93,4.93,0,0,0,2.71-.74,2.1,2.1,0,0,0,1.06-1.67,2.13,2.13,0,0,0-1.06-1.68,5.27,5.27,0,0,0-5.42,0,2.08,2.08,0,0,0-1.06,1.68,2,2,0,0,0,1.06,1.67A4.93,4.93,0,0,0,418.05,110.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,102.26a.25.25,0,0,1-.25-.25V100a2.09,2.09,0,0,1,4.17,0l0,1.8h2.87a.26.26,0,0,1,.25.26.25.25,0,0,1-.25.25ZM418.8,100a1.61,1.61,0,0,0-1.59-1.58,1.58,1.58,0,0,0-1.58,1.58v1.8h3.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17,90.54l3.24,2.34a.26.26,0,0,1,.12.21v0a.25.25,0,0,1-.12.22l-3.23,2.34h6a.25.25,0,0,1,.25.25.26.26,0,0,1-.25.26h-6.77a.24.24,0,0,1-.2-.11l0,0a.26.26,0,0,1,.07-.35l3.6-2.6-3.6-2.59a.26.26,0,0,1-.07-.35l.09-.08a.33.33,0,0,1,.13,0h6.77a.26.26,0,0,1,.25.25.25.25,0,0,1-.25.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.12,
    y: 136.71,
    width: 21.31,
    height: 0.95,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,161.68a6.13,6.13,0,0,1,0,8.43,5.46,5.46,0,0,1-4,1.78,5.62,5.62,0,0,1-4.08-1.78,6.21,6.21,0,0,1,0-8.43,5.54,5.54,0,0,1,4.08-1.78A5.39,5.39,0,0,1,258.71,161.68Zm-.22,4.22a4.32,4.32,0,0,0-1.13-2.92,3.58,3.58,0,0,0-2.63-1.18A3.62,3.62,0,0,0,252,163a4.23,4.23,0,0,0-1.13,2.92,4.13,4.13,0,0,0,1.13,2.89,3.56,3.56,0,0,0,5.33,0A4.23,4.23,0,0,0,258.49,165.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.65,165.9a6.13,6.13,0,0,1,6.12-6,6.2,6.2,0,0,1,3.84,1.3,1,1,0,0,1-1.16,1.52,4.15,4.15,0,0,0-2.68-.92,4.42,4.42,0,0,0-3,1.2,4.09,4.09,0,0,0-1.22,2.9,4,4,0,0,0,1.22,2.89,4.37,4.37,0,0,0,3,1.2,4.18,4.18,0,0,0,2.68-.91,1,1,0,0,1,1.33.18,1,1,0,0,1-.17,1.33,6.2,6.2,0,0,1-3.84,1.3A6.1,6.1,0,0,1,262.65,165.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,162.08h-2.65V171a.92.92,0,0,1-1.83,0v-8.9H276a.93.93,0,0,1-.92-.93.91.91,0,0,1,.92-.92h7.11a.91.91,0,0,1,.91.92A.93.93,0,0,1,283.14,162.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,187a10.63,10.63,0,0,1,3.17,7.61,10.78,10.78,0,0,1-18.42,7.65,2.46,2.46,0,0,1,3.47-3.48,5.79,5.79,0,0,0,4.13,1.7,6,6,0,0,0,4.18-1.7,5.82,5.82,0,0,0,1.73-4.17,5.66,5.66,0,0,0-1.73-4.13,5.9,5.9,0,0,0-4.13-1.74,2.15,2.15,0,0,1-1.79-.78s0,0,0,0a2.47,2.47,0,0,1-.09-3.48l4.44-4.52h-7a2.46,2.46,0,0,1,0-4.91h12.82a2.44,2.44,0,0,1,2.47,2.43,2.68,2.68,0,0,1-.3,1.18,3.26,3.26,0,0,1-.43.6l-5.48,5.65A10.06,10.06,0,0,1,265,187Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,177.4V203a2.42,2.42,0,0,1-2.43,2.39,2.35,2.35,0,0,1-2.39-2.39V181.66l-1.74,1a2.17,2.17,0,0,1-1.22.35,2.34,2.34,0,0,1-2-1.22,2.31,2.31,0,0,1,.78-3.26l5.35-3.17s.13,0,.17-.09.13-.08.22-.13.17,0,.26,0a.27.27,0,0,1,.17,0,.67.67,0,0,1,.31-.05H282c0,.05.13.05.17.05a.5.5,0,0,1,.26.08.25.25,0,0,1,.18.05c.13.08.17.13.26.13a.67.67,0,0,0,.17.13,1.92,1.92,0,0,1,.17.13c.09,0,.13.13.18.17a.76.76,0,0,1,.13.18l.17.17,0,.09s0,.08,0,.13.09.13.09.21,0,.18.08.22a1.88,1.88,0,0,0,.05.22.37.37,0,0,0,.08.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,161.35a1.12,1.12,0,1,1-1.12-1.12A1.12,1.12,0,0,1,292.82,161.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,166.72a1.12,1.12,0,1,1-1.12-1.12A1.12,1.12,0,0,1,292.82,166.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,172.09A1.12,1.12,0,1,1,291.7,171,1.12,1.12,0,0,1,292.82,172.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,177.46a1.12,1.12,0,1,1-1.12-1.11A1.12,1.12,0,0,1,292.82,177.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,182.83a1.12,1.12,0,1,1-1.12-1.11A1.12,1.12,0,0,1,292.82,182.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,188.21a1.12,1.12,0,1,1-1.12-1.12A1.12,1.12,0,0,1,292.82,188.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,193.58a1.12,1.12,0,1,1-1.12-1.12A1.12,1.12,0,0,1,292.82,193.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,199a1.12,1.12,0,1,1-1.12-1.12A1.12,1.12,0,0,1,292.82,199Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.82,204.32a1.12,1.12,0,1,1-1.12-1.12A1.11,1.11,0,0,1,292.82,204.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.58,193.11v-9.72a.9.9,0,0,1,.9-.91.92.92,0,0,1,.93.91v8.8h4.46a.92.92,0,0,1,0,1.83h-5.39A.9.9,0,0,1,297.58,193.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,183.39a.89.89,0,0,1,.91-.91.92.92,0,0,1,.92.91v9.72a.92.92,0,0,1-.92.91.89.89,0,0,1-.91-.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.73,193.85l-.11-.08s0,0,0-.05-.07-.06-.08-.1h0a.57.57,0,0,0-.08-.13l-4-9.63a.9.9,0,0,1,1.66-.69l3.22,7.63,3.21-7.63a.91.91,0,0,1,1.69.69l-4.08,9.63a.49.49,0,0,1-.06.13h0s-.07.07-.08.1l0,.05-.1.08,0,0a.41.41,0,0,1-.13.08l0,0a.61.61,0,0,0-.13,0h0a.47.47,0,0,1-.16,0,.5.5,0,0,1-.17,0h0l-.13,0a0,0,0,0,0,0,0h0a.56.56,0,0,1-.15-.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.85,193.11v-9.72a.89.89,0,0,1,.9-.91h5.39a.91.91,0,0,1,.91.91.93.93,0,0,1-.91.92h-4.46v3h3.84a.92.92,0,0,1,0,1.83h-3.84v3h4.46a.92.92,0,0,1,0,1.83H324.8s0,0,0,0l0,0A.9.9,0,0,1,323.85,193.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,164.54a4,4,0,0,1,8-.41s0,0,0,0c0,.31,0,.63,0,.94a9.68,9.68,0,0,1-.57,3.38,5.8,5.8,0,0,1-2.13,2.82,4.69,4.69,0,0,1-2.47.77.92.92,0,0,1-1-.87,1,1,0,0,1,.89-1,2.9,2.9,0,0,0,1.55-.46,3.42,3.42,0,0,0,1-1.15,2.86,2.86,0,0,0,.21-.43,4,4,0,0,1-1.58.33A4,4,0,0,1,297,164.54Zm1.83,0a2.17,2.17,0,1,0,4.34,0,2.17,2.17,0,0,0-4.34,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.18,163.19a1.24,1.24,0,0,1,1.23,1.23,1.23,1.23,0,0,1-1.23,1.22,1.21,1.21,0,0,1-1.22-1.22A1.23,1.23,0,0,1,309.18,163.19Zm0,6.56a1.23,1.23,0,1,1,0,2.46,1.23,1.23,0,0,1,0-2.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.55,166.32a7.13,7.13,0,0,1,1.12-3.94,3.47,3.47,0,0,1,6.12,0,7.61,7.61,0,0,1,0,7.88,3.47,3.47,0,0,1-6.12,0A7.16,7.16,0,0,1,311.55,166.32Zm6.51,0a5.46,5.46,0,0,0-.79-2.93,1.88,1.88,0,0,0-1.53-1,2,2,0,0,0-1.57,1,5.81,5.81,0,0,0,0,5.85,2,2,0,0,0,1.57,1,1.92,1.92,0,0,0,1.53-1A5.43,5.43,0,0,0,318.06,166.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.26,166.32a7.13,7.13,0,0,1,1.12-3.94,3.47,3.47,0,0,1,6.12,0,7.61,7.61,0,0,1,0,7.88,3.47,3.47,0,0,1-6.12,0A7.16,7.16,0,0,1,323.26,166.32Zm6.51,0a5.46,5.46,0,0,0-.79-2.93,1.89,1.89,0,0,0-1.53-1,2,2,0,0,0-1.57,1,5.81,5.81,0,0,0,0,5.85,2,2,0,0,0,1.57,1,1.93,1.93,0,0,0,1.53-1A5.43,5.43,0,0,0,329.77,166.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,198.53v6.28a.6.6,0,0,1-.6.58.58.58,0,0,1-.58-.58v-4.48l-1.54,2.13a.58.58,0,0,1-.47.24h0a.63.63,0,0,1-.49-.24l-1.52-2.13v4.48a.59.59,0,0,1-.59.58.6.6,0,0,1-.59-.58v-6.28a.6.6,0,0,1,.59-.59h0a.59.59,0,0,1,.47.25l2.12,2.94,2.11-2.94a.59.59,0,0,1,.48-.25h0A.62.62,0,0,1,303.6,198.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.26,205.39a3.07,3.07,0,0,1-3.08-3.07v-3.79a.58.58,0,0,1,.59-.59.6.6,0,0,1,.6.59v3.79a1.89,1.89,0,0,0,3.78,0v-3.79a.59.59,0,0,1,.6-.59.58.58,0,0,1,.58.59v3.79A3.07,3.07,0,0,1,309.26,205.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,203.54a.55.55,0,0,1,.78-.07,3.41,3.41,0,0,0,2,.81,2.33,2.33,0,0,0,1.33-.39,1,1,0,0,0,.46-.77.67.67,0,0,0-.1-.34,1,1,0,0,0-.32-.31,4,4,0,0,0-1.46-.5h0a6.1,6.1,0,0,1-1.37-.42,2.36,2.36,0,0,1-1-.83,1.6,1.6,0,0,1-.24-.87,2,2,0,0,1,.85-1.55,3.09,3.09,0,0,1,1.84-.57,4.2,4.2,0,0,1,2.32.85.56.56,0,0,1,.15.76.55.55,0,0,1-.76.16,3.08,3.08,0,0,0-1.71-.68,2,2,0,0,0-1.19.36.85.85,0,0,0-.41.67.48.48,0,0,0,.08.3,1,1,0,0,0,.28.27,3.63,3.63,0,0,0,1.33.47h0a6.36,6.36,0,0,1,1.47.45,2.51,2.51,0,0,1,1.07.88,1.74,1.74,0,0,1,.25.9,2,2,0,0,1-.91,1.65,3.3,3.3,0,0,1-2,.61,4.54,4.54,0,0,1-2.72-1.06A.57.57,0,0,1,314.6,203.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,198.53a.58.58,0,0,1,.58-.59.6.6,0,0,1,.6.59v6.28a.59.59,0,0,1-.6.58.57.57,0,0,1-.58-.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,201.56a3.9,3.9,0,0,1,3.9-3.83,4,4,0,0,1,2.46.83.61.61,0,0,1-.75,1,2.65,2.65,0,0,0-1.71-.59,2.81,2.81,0,0,0-1.91.77,2.63,2.63,0,0,0-.78,1.85,2.57,2.57,0,0,0,.78,1.85,2.81,2.81,0,0,0,1.91.77,2.61,2.61,0,0,0,1.71-.59.65.65,0,0,1,.86.12.63.63,0,0,1-.11.85,4,4,0,0,1-2.46.83A3.88,3.88,0,0,1,324.85,201.56Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.7091c4035dd46e7b95467ac1e7834ff4.svg";
export { ForwardRef as ReactComponent };